import React, { useContext, useEffect, useState } from "react";
import { MdOutlineChevronLeft, MdOutlineChevronRight } from "react-icons/md";
import globalContext from "../../../Context/GlobalContext";

export default function MainSecThreeMobile() {
  const contextData = useContext(globalContext);
  const [pieces, setPieces] = useState([]);
  const [piecesIndex, setPiecesIndex] = useState(0);

  const piecesObj = [
    {
      id: 25,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_283)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.5246 17.9146C25.5246 18.199 25.5246 18.4833 25.2403 18.7677C24.9559 19.0521 24.6715 19.0521 24.3872 19.0521H22.1123C21.5436 19.0521 20.9749 18.4833 20.9749 17.9146V16.4928C20.9749 16.2085 20.9749 15.9241 20.6905 15.6397C20.4061 15.6397 20.1218 15.3554 19.8374 15.3554H15.572C15.0033 15.3554 14.4346 14.7867 14.4346 14.2179V12.7961C14.4346 12.5118 14.4346 12.2274 14.7189 11.9431C15.0033 11.6587 15.2877 11.6587 15.572 11.6587H31.2118C31.4962 11.6587 31.7805 11.6587 31.7805 11.9431C32.0649 12.2274 32.3493 12.5118 32.3493 12.7961V14.2179C32.3493 14.5023 32.0649 14.7867 31.7805 15.071C31.7805 15.3554 31.4962 15.3554 31.2118 15.3554H26.6621C26.0933 15.3554 25.5246 15.9241 25.5246 16.4928V17.9146Z"
              stroke="#FEC42B"
              stroke-width="1.4218"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M54.2448 33.8386C52.2542 36.1135 50.5481 40.6633 50.2637 42.3695C49.695 43.7913 50.5481 45.7818 51.1168 46.3505C51.9699 47.4879 54.2448 48.0567 54.8135 48.0567C56.5197 48.0567 58.2258 46.9192 58.7945 46.3505C59.6476 45.2131 59.932 42.9382 59.6476 42.3695C59.0789 38.9571 56.5197 34.9761 55.3822 33.8386C55.0979 33.2699 54.8135 33.2699 54.2448 33.8386Z"
              stroke="#FEC42B"
              stroke-width="1.4218"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.0502 20.4736C2.49096 20.4736 1.35352 23.0329 1.35352 24.1703C1.35352 28.7201 1.35352 34.976 1.35352 36.6822C1.35352 39.2414 3.91276 40.3788 5.0502 40.3788C7.04072 40.3788 9.88432 40.3788 11.0218 40.3788V44.6443C11.0218 47.2035 13.581 48.3409 14.7184 48.3409C17.562 48.3409 25.5241 48.3409 30.927 48.3409C32.0644 48.3409 35.1924 47.4879 36.6142 45.7817C39.7421 43.5068 48.5573 34.976 54.5289 27.5826C54.8132 27.0139 55.0976 26.4452 55.0976 26.1608V23.0329C55.0976 22.1798 54.5289 21.6111 53.9601 21.3267C53.3914 21.0424 52.5383 21.0424 52.254 21.3267L38.3203 28.1514C37.7516 28.7201 36.8985 28.4357 36.6142 28.1514C36.0455 27.867 35.7611 27.0139 35.7611 26.7296C35.7611 26.1608 35.7611 25.0234 35.7611 24.1703C35.7611 23.0329 34.3393 20.4736 31.7801 20.4736C28.0834 20.4736 15.5715 20.4736 6.18764 20.4736H5.0502Z"
              stroke="#FEC42B"
              stroke-width="1.4218"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.0214 35.5448C11.0214 32.7012 11.0214 27.2984 11.0214 25.3079C11.0214 24.4548 10.1683 24.1704 9.88393 24.1704C8.74649 24.1704 6.75597 24.1704 6.18725 24.1704C5.33416 24.1704 5.0498 25.0235 5.0498 25.3079C5.0498 29.2889 5.0498 34.123 5.0498 35.5448C5.0498 36.3979 5.90288 36.6823 6.18725 36.6823C7.32469 36.6823 9.31521 36.6823 9.88393 36.6823C10.4526 36.6823 11.0214 36.1135 11.0214 35.5448Z"
              stroke="#FEC42B"
              stroke-width="1.4218"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M21.7226 41.2326C20.9686 41.2326 20.3071 41.0532 19.738 40.6943C19.1725 40.3354 18.7303 39.8334 18.4113 39.1882C18.0959 38.5429 17.9382 37.789 17.9382 36.9262C17.9382 36.0563 18.0959 35.2969 18.4113 34.648C18.7303 33.9992 19.1725 33.4953 19.738 33.1365C20.3071 32.7776 20.9686 32.5982 21.7226 32.5982C22.4766 32.5982 23.1363 32.7776 23.7018 33.1365C24.2709 33.4953 24.7131 33.9992 25.0285 34.648C25.3475 35.2969 25.507 36.0563 25.507 36.9262C25.507 37.789 25.3475 38.5429 25.0285 39.1882C24.7131 39.8334 24.2709 40.3354 23.7018 40.6943C23.1363 41.0532 22.4766 41.2326 21.7226 41.2326ZM21.7226 40.0799C22.2953 40.0799 22.7666 39.9331 23.1363 39.6395C23.506 39.3458 23.7797 38.9598 23.9573 38.4813C24.1349 38.0028 24.2238 37.4845 24.2238 36.9262C24.2238 36.368 24.1349 35.8479 23.9573 35.3657C23.7797 34.8836 23.506 34.494 23.1363 34.1967C22.7666 33.8995 22.2953 33.7509 21.7226 33.7509C21.1499 33.7509 20.6786 33.8995 20.3089 34.1967C19.9392 34.494 19.6655 34.8836 19.4879 35.3657C19.3103 35.8479 19.2214 36.368 19.2214 36.9262C19.2214 37.4845 19.3103 38.0028 19.4879 38.4813C19.6655 38.9598 19.9392 39.3458 20.3089 39.6395C20.6786 39.9331 21.1499 40.0799 21.7226 40.0799ZM27.4657 41.0586V32.7069H28.7489V41.0586H27.4657ZM28.1182 31.315C27.8681 31.315 27.6524 31.2298 27.4712 31.0594C27.2936 30.889 27.2048 30.6842 27.2048 30.445C27.2048 30.2058 27.2936 30.0009 27.4712 29.8306C27.6524 29.6602 27.8681 29.575 28.1182 29.575C28.3683 29.575 28.5822 29.6602 28.7598 29.8306C28.9411 30.0009 29.0317 30.2058 29.0317 30.445C29.0317 30.6842 28.9411 30.889 28.7598 31.0594C28.5822 31.2298 28.3683 31.315 28.1182 31.315ZM32.3824 29.923V41.0586H31.0992V29.923H32.3824Z"
              fill="#FEC42B"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_283">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6395 12.071L20.7697 15.7988L22.3673 14.9112L20.0596 11.0059L18.6395 12.071ZM11.0064 20.0591L14.9117 22.3668L15.7993 20.7692L12.0715 18.639L11.0064 20.0591ZM30.0005 4.43784C31.2431 4.43784 32.3082 4.61536 33.5508 4.79287L34.6158 1.95264H34.7934H35.1484L35.3259 2.13015H35.5034H35.8585L36.036 2.30767H36.391H36.746L36.9235 2.48518H37.1011H37.4561L37.6336 2.6627H37.9886L38.1661 2.84021H38.3437H38.6987V3.01773H38.8762H39.2312L39.4087 3.19524H39.5863L39.7638 3.37275H40.1188L39.5863 6.39051C41.7164 7.27808 43.8466 8.52068 45.6218 9.9408L48.107 7.98814C49.5271 9.23074 50.7697 10.4733 52.0123 12.071L50.0596 14.3787C51.4797 16.1538 52.7223 18.284 53.6099 20.4142L56.6277 19.8816C57.3377 21.6568 57.6928 23.6094 58.0478 25.3846L55.2076 26.4497C55.3851 27.6923 55.5626 28.7574 55.5626 30C55.5626 31.2426 55.3851 32.3077 55.2076 33.5503L58.0478 34.6154C57.6928 36.3905 57.3377 38.3432 56.6277 40.1183L53.6099 39.5858C52.7223 41.716 51.4797 43.8461 50.0596 45.6213L52.0123 48.1065C50.7697 49.5266 49.5271 50.7692 48.107 52.0118L45.6218 50.0591C43.8466 51.4793 41.7164 52.7219 39.5863 53.6094L40.1188 56.6272C38.3437 57.3372 36.391 57.6923 34.6158 58.0473L33.5508 55.2071C32.3082 55.3846 31.2431 55.5621 30.0005 55.5621C28.7579 55.5621 27.6928 55.3846 26.4502 55.2071L25.3851 58.0473C23.6099 57.6923 21.6573 57.3372 19.8821 56.6272L20.4147 53.6094C18.2845 52.7219 16.1543 51.4793 14.3792 50.0591L12.0715 52.0118C10.4738 50.7692 9.23123 49.5266 7.98863 48.1065L9.94129 45.6213C8.52117 43.8461 7.27857 41.716 6.39099 39.5858L3.37324 40.1183C2.8407 38.3432 2.30815 36.3905 1.95312 34.6154L4.79336 33.5503C4.61585 32.3077 4.43833 31.2426 4.43833 30C4.43833 15.9763 15.9768 4.43784 30.0005 4.43784ZM30.0005 6.39051C16.8644 6.39051 6.39099 16.8639 6.39099 30H17.7519C17.7519 36.7455 23.2549 42.2485 30.0005 42.2485C36.746 42.2485 42.249 36.7455 42.249 30C42.249 23.2544 36.746 17.7515 30.0005 17.7515V6.39051ZM30.0005 26.0946C32.1306 26.0946 33.9058 27.8698 33.9058 30C33.9058 32.1301 32.1306 33.9053 30.0005 33.9053C27.8703 33.9053 26.0951 32.1301 26.0951 30C26.0951 29.6449 26.2726 29.1124 26.2726 28.7574L18.817 18.9941L28.7579 26.4497C29.1129 26.2722 29.4679 26.0946 30.0005 26.0946Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.532544"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "کوتاه",
      pieceName: "روغن موتور",
      desc: "کار اصلی روغن در موتور خودرو، روان‌سازی و به حداقل رساندن اصطکاک بین اجزای موتور است. البته روغن موتورها وظایف بسیار مهم دیگری در موتور خودرو برعهده دارند. جلوگیری از زنگ‌زدگی و خوردگی موتور، پاک‌کنندگی موتور و معلق سازی مواد حاصل از سایش قطعات، آب بندی موتور، حفاظت از سطوح فلزی موتور، افزایش کارایی موتور و برخی از ویژگی‌های دیگر، همگی از وظایف روغن موتور است.",
    },
    {
      id: 26,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_260)">
            <path
              d="M15.1016 45.3983V41.6815V41.416C15.6325 41.416 16.1635 41.416 16.6945 41.6815C17.2255 41.947 18.2874 42.478 18.2874 42.478C19.3494 43.2744 19.8803 44.3364 19.8803 44.8673V49.1151"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M26.5172 50.9735V46.7257C26.7827 45.6637 24.9243 44.6018 23.5968 44.3363C23.0659 44.3363 22.0039 44.0708 22.0039 44.0708"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M45.8979 45.3983V41.6815V41.416C45.3669 41.416 44.836 41.416 44.305 41.6815C43.774 41.947 42.7121 42.478 42.7121 42.478C41.6501 43.2744 41.1191 44.3364 41.1191 44.8673V49.1151"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M26.5176 46.7257C26.5176 45.6637 29.1724 45.1327 30.4999 45.1327C33.1547 45.1327 34.4822 46.1947 34.4822 46.7257C34.2167 45.6637 36.3406 44.6018 37.4025 44.3363C37.9335 44.3363 38.9955 44.0708 38.9955 44.0708"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.8096 13.274C35.8096 14.0705 37.137 14.3359 37.137 14.3359C38.1989 14.3359 38.4644 13.274 38.4644 13.274C38.4644 12.743 37.668 12.4775 37.137 12.4775C36.3405 12.4775 35.8096 13.274 35.8096 13.274Z"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M36.0752 20.9732C36.0752 21.5042 36.8717 22.0352 37.4026 22.0352C38.1991 22.0352 38.7301 20.9732 38.7301 20.9732C38.7301 20.4422 37.9336 20.1768 37.4026 20.1768C36.6062 20.1768 36.0752 20.9732 36.0752 20.9732Z"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M38.9951 17.2568C38.9951 17.7877 40.3226 18.0532 40.3226 18.0532C41.3845 18.0532 41.65 17.2568 41.65 17.2568C41.65 16.7258 40.8535 16.1948 40.3226 16.1948C39.5261 16.1948 38.9951 17.2568 38.9951 17.2568Z"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.8267 11.6812C31.8267 12.2122 31.0303 12.7432 30.4993 12.7432C29.7028 12.7432 29.1719 11.6812 29.1719 11.6812C29.1719 11.1503 29.9683 10.8848 30.4993 10.8848C31.2958 10.8848 31.8267 11.6812 31.8267 11.6812Z"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.19 13.274C25.19 14.0705 23.8626 14.3359 23.8626 14.3359C22.8006 14.3359 22.5352 13.274 22.5352 13.274C22.5352 12.743 23.3316 12.4775 23.8626 12.4775C24.6591 12.4775 25.19 13.274 25.19 13.274Z"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.9244 20.9732C24.9244 21.5042 24.1279 22.0352 23.597 22.0352C22.8005 22.0352 22.2695 20.9732 22.2695 20.9732C22.2695 20.4422 23.597 20.1768 23.597 20.1768C24.6589 20.1768 24.9244 20.9732 24.9244 20.9732Z"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.0045 17.2568C22.0045 17.7877 20.677 18.0532 20.677 18.0532C19.6151 18.0532 19.3496 17.2568 19.3496 17.2568C19.3496 16.7258 20.1461 16.1948 20.677 16.1948C21.4735 16.1948 22.0045 17.2568 22.0045 17.2568Z"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.8267 22.5665C31.8267 23.0975 31.0303 23.3629 30.4993 23.3629C29.7028 23.3629 29.1719 22.5665 29.1719 22.5665C29.1719 22.0355 29.9683 21.77 30.4993 21.77C31.2958 21.77 31.8267 22.5665 31.8267 22.5665Z"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M35.0129 17.2564C35.0129 18.8493 32.0925 19.6458 30.4996 19.6458C27.3138 19.6458 25.9863 18.0529 25.9863 17.2564C25.9863 15.6635 28.9067 14.6016 30.4996 14.6016C33.42 14.6016 35.0129 16.46 35.0129 17.2564Z"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M45.898 15.9291C45.898 22.5663 35.544 25.7521 30.4998 25.7521C20.4113 25.7521 15.1016 19.1149 15.1016 15.9291C15.1016 10.8848 25.4555 8.22998 30.4998 8.22998C40.8538 8.22998 45.898 13.5397 45.898 15.9291Z"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M48.2873 17.2565C48.2873 24.6902 36.3404 28.407 30.4997 28.407C18.8182 28.407 12.9775 20.9733 12.9775 17.2565C12.9775 11.1503 24.659 8.22998 30.4997 8.22998C42.1811 8.22998 48.2873 14.3362 48.2873 17.2565Z"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M12.9775 17.2563L13.243 41.4156C13.243 44.867 19.0837 51.7696 30.4997 51.7696C36.3404 51.7696 47.7563 48.3183 47.7563 41.4156L48.2873 17.2563"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M48.0219 32.124C48.0219 39.5577 36.3405 43.2745 30.4998 43.2745C19.0839 43.2745 13.2432 35.8408 13.2432 32.124"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M34.4824 46.7256V50.9734"
              stroke="#FEC42B"
              stroke-width="1.59292"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_260">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6395 12.071L20.7697 15.7988L22.3673 14.9112L20.0596 11.0059L18.6395 12.071ZM11.0064 20.0591L14.9117 22.3668L15.7993 20.7692L12.0715 18.639L11.0064 20.0591ZM30.0005 4.43784C31.2431 4.43784 32.3082 4.61536 33.5508 4.79287L34.6158 1.95264H34.7934H35.1484L35.3259 2.13015H35.5034H35.8585L36.036 2.30767H36.391H36.746L36.9235 2.48518H37.1011H37.4561L37.6336 2.6627H37.9886L38.1661 2.84021H38.3437H38.6987V3.01773H38.8762H39.2312L39.4087 3.19524H39.5863L39.7638 3.37275H40.1188L39.5863 6.39051C41.7164 7.27808 43.8466 8.52068 45.6218 9.9408L48.107 7.98814C49.5271 9.23074 50.7697 10.4733 52.0123 12.071L50.0596 14.3787C51.4797 16.1538 52.7223 18.284 53.6099 20.4142L56.6277 19.8816C57.3377 21.6568 57.6928 23.6094 58.0478 25.3846L55.2076 26.4497C55.3851 27.6923 55.5626 28.7574 55.5626 30C55.5626 31.2426 55.3851 32.3077 55.2076 33.5503L58.0478 34.6154C57.6928 36.3905 57.3377 38.3432 56.6277 40.1183L53.6099 39.5858C52.7223 41.716 51.4797 43.8461 50.0596 45.6213L52.0123 48.1065C50.7697 49.5266 49.5271 50.7692 48.107 52.0118L45.6218 50.0591C43.8466 51.4793 41.7164 52.7219 39.5863 53.6094L40.1188 56.6272C38.3437 57.3372 36.391 57.6923 34.6158 58.0473L33.5508 55.2071C32.3082 55.3846 31.2431 55.5621 30.0005 55.5621C28.7579 55.5621 27.6928 55.3846 26.4502 55.2071L25.3851 58.0473C23.6099 57.6923 21.6573 57.3372 19.8821 56.6272L20.4147 53.6094C18.2845 52.7219 16.1543 51.4793 14.3792 50.0591L12.0715 52.0118C10.4738 50.7692 9.23123 49.5266 7.98863 48.1065L9.94129 45.6213C8.52117 43.8461 7.27857 41.716 6.39099 39.5858L3.37324 40.1183C2.8407 38.3432 2.30815 36.3905 1.95312 34.6154L4.79336 33.5503C4.61585 32.3077 4.43833 31.2426 4.43833 30C4.43833 15.9763 15.9768 4.43784 30.0005 4.43784ZM30.0005 6.39051C16.8644 6.39051 6.39099 16.8639 6.39099 30H17.7519C17.7519 36.7455 23.2549 42.2485 30.0005 42.2485C36.746 42.2485 42.249 36.7455 42.249 30C42.249 23.2544 36.746 17.7515 30.0005 17.7515V6.39051ZM30.0005 26.0946C32.1306 26.0946 33.9058 27.8698 33.9058 30C33.9058 32.1301 32.1306 33.9053 30.0005 33.9053C27.8703 33.9053 26.0951 32.1301 26.0951 30C26.0951 29.6449 26.2726 29.1124 26.2726 28.7574L18.817 18.9941L28.7579 26.4497C29.1129 26.2722 29.4679 26.0946 30.0005 26.0946Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.532544"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "کوتاه",
      pieceName: "فیلتر روغن",
      desc: "فیلتر روغن وظیفه حذف ناخالصی و جذب ذرات مضر از درون روغن موتور را بر عهده دارد.",
    },
    {
      id: 27,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_162)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M51.1493 44.1557C51.1493 44.6752 50.8895 45.1947 50.6298 45.7142C50.6298 45.7142 49.8506 46.2336 49.3311 46.2336H11.6688C10.6298 46.2336 9.85059 45.4544 9.85059 44.1557V15.5843C9.85059 14.5453 10.6298 13.7661 11.6688 13.7661H49.3311C49.8506 13.7661 50.6298 14.2856 50.6298 14.2856C50.6298 14.2856 51.1493 15.0648 51.1493 15.5843V44.1557Z"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M9.85059 29.8701H51.1493"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M47.5127 13.7661C47.5127 24.6752 47.5127 40.7791 47.5127 46.2336"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M43.6162 13.7661C43.6162 24.6752 43.6162 40.7791 43.6162 46.2336"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M39.9805 13.7661C39.9805 24.6752 39.9805 40.7791 39.9805 46.2336"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M36.084 13.7661C36.084 24.6752 36.084 40.7791 36.084 46.2336"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M32.4473 13.7661C32.4473 24.6752 32.4473 40.7791 32.4473 46.2336"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M28.5518 13.7661C28.5518 24.6752 28.5518 40.7791 28.5518 46.2336"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M24.915 13.7661C24.915 24.6752 24.915 40.7791 24.915 46.2336"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M21.0186 13.7661C21.0186 24.6752 21.0186 40.7791 21.0186 46.2336"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M17.3828 13.7661C17.3828 24.6752 17.3828 40.7791 17.3828 46.2336"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M13.4863 13.7661C13.4863 24.6752 13.4863 40.7791 13.4863 46.2336"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.9541 46.2338C5.9541 47.2727 6.21384 48.3117 6.99306 49.0909C7.77228 49.8701 8.81124 50.1299 9.85021 50.1299H51.1489C53.2268 50.1299 55.045 48.3117 55.045 46.2338V13.7662C55.045 12.7273 54.7853 11.6883 54.0061 10.9091C53.2268 10.1299 52.1879 9.87012 51.1489 9.87012H9.85021C8.81124 9.87012 7.77228 10.1299 6.99306 10.9091C6.21384 11.6883 5.9541 12.7273 5.9541 13.7662V46.2338Z"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_162">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6395 12.071L20.7697 15.7988L22.3673 14.9112L20.0596 11.0059L18.6395 12.071ZM11.0064 20.0591L14.9117 22.3668L15.7993 20.7692L12.0715 18.639L11.0064 20.0591ZM30.0005 4.43784C31.2431 4.43784 32.3082 4.61536 33.5508 4.79287L34.6158 1.95264H34.7934H35.1484L35.3259 2.13015H35.5034H35.8585L36.036 2.30767H36.391H36.746L36.9235 2.48518H37.1011H37.4561L37.6336 2.6627H37.9886L38.1661 2.84021H38.3437H38.6987V3.01773H38.8762H39.2312L39.4087 3.19524H39.5863L39.7638 3.37275H40.1188L39.5863 6.39051C41.7164 7.27808 43.8466 8.52068 45.6218 9.9408L48.107 7.98814C49.5271 9.23074 50.7697 10.4733 52.0123 12.071L50.0596 14.3787C51.4797 16.1538 52.7223 18.284 53.6099 20.4142L56.6277 19.8816C57.3377 21.6568 57.6928 23.6094 58.0478 25.3846L55.2076 26.4497C55.3851 27.6923 55.5626 28.7574 55.5626 30C55.5626 31.2426 55.3851 32.3077 55.2076 33.5503L58.0478 34.6154C57.6928 36.3905 57.3377 38.3432 56.6277 40.1183L53.6099 39.5858C52.7223 41.716 51.4797 43.8461 50.0596 45.6213L52.0123 48.1065C50.7697 49.5266 49.5271 50.7692 48.107 52.0118L45.6218 50.0591C43.8466 51.4793 41.7164 52.7219 39.5863 53.6094L40.1188 56.6272C38.3437 57.3372 36.391 57.6923 34.6158 58.0473L33.5508 55.2071C32.3082 55.3846 31.2431 55.5621 30.0005 55.5621C28.7579 55.5621 27.6928 55.3846 26.4502 55.2071L25.3851 58.0473C23.6099 57.6923 21.6573 57.3372 19.8821 56.6272L20.4147 53.6094C18.2845 52.7219 16.1543 51.4793 14.3792 50.0591L12.0715 52.0118C10.4738 50.7692 9.23123 49.5266 7.98863 48.1065L9.94129 45.6213C8.52117 43.8461 7.27857 41.716 6.39099 39.5858L3.37324 40.1183C2.8407 38.3432 2.30815 36.3905 1.95312 34.6154L4.79336 33.5503C4.61585 32.3077 4.43833 31.2426 4.43833 30C4.43833 15.9763 15.9768 4.43784 30.0005 4.43784ZM30.0005 6.39051C16.8644 6.39051 6.39099 16.8639 6.39099 30H17.7519C17.7519 36.7455 23.2549 42.2485 30.0005 42.2485C36.746 42.2485 42.249 36.7455 42.249 30C42.249 23.2544 36.746 17.7515 30.0005 17.7515V6.39051ZM30.0005 26.0946C32.1306 26.0946 33.9058 27.8698 33.9058 30C33.9058 32.1301 32.1306 33.9053 30.0005 33.9053C27.8703 33.9053 26.0951 32.1301 26.0951 30C26.0951 29.6449 26.2726 29.1124 26.2726 28.7574L18.817 18.9941L28.7579 26.4497C29.1129 26.2722 29.4679 26.0946 30.0005 26.0946Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.532544"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "کوتاه",
      pieceName: "فیلتر موتور",
      desc: "فیلتر موتور خودرو جلوی ورود گرد و غبار و سنگریزه‌ها را به موتور می‌گیرد",
    },
    {
      id: 28,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_189)">
            <path
              d="M8.13184 35.2632H52.8687"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M8.13184 23.9478H52.8687"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M3.9209 16.5791V43.4212"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M12.3418 16.5791V43.4212"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M16.2891 16.5791V43.4212"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M20.5 16.5791V43.4212"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M24.4473 16.5791V43.4212"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M28.3945 16.5791V43.4212"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M32.6055 16.5791V43.4212"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M36.5527 16.5791V43.4212"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M40.7627 16.5791V43.4212"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M44.71 16.5791V43.4212"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M48.9209 16.5791V43.4212"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.39458 47.895C23.1314 47.895 45.4998 47.895 52.8683 47.895C55.763 47.895 57.0788 45.0002 57.0788 43.4213C57.0788 29.2108 57.0788 18.4213 57.0788 16.5792C57.0788 13.6844 54.1841 12.3687 52.8683 12.3687C37.8683 12.3687 15.763 12.3687 8.39458 12.3687C5.49985 12.3687 3.9209 15.2634 3.9209 16.5792C3.9209 20.2634 3.9209 36.316 3.9209 43.4213C3.9209 46.316 6.81564 47.895 8.39458 47.895Z"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M50.7634 43.4212C37.3424 43.4212 17.0792 43.4212 10.2371 43.4212C8.92131 43.4212 8.13184 43.1581 8.13184 43.1581C8.13184 42.1054 8.13184 26.3159 8.13184 18.6844C8.13184 17.3686 9.71078 16.5791 10.2371 16.5791C23.9213 16.5791 43.9213 16.5791 50.7634 16.5791C52.0792 16.5791 52.8687 17.8949 52.8687 18.6844C52.8687 20.7896 52.8687 35.0002 52.8687 41.3159C52.8687 42.8949 51.5529 43.4212 50.7634 43.4212Z"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_189">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6395 12.071L20.7697 15.7988L22.3673 14.9112L20.0596 11.0059L18.6395 12.071ZM11.0064 20.0591L14.9117 22.3668L15.7993 20.7692L12.0715 18.639L11.0064 20.0591ZM30.0005 4.43784C31.2431 4.43784 32.3082 4.61536 33.5508 4.79287L34.6158 1.95264H34.7934H35.1484L35.3259 2.13015H35.5034H35.8585L36.036 2.30767H36.391H36.746L36.9235 2.48518H37.1011H37.4561L37.6336 2.6627H37.9886L38.1661 2.84021H38.3437H38.6987V3.01773H38.8762H39.2312L39.4087 3.19524H39.5863L39.7638 3.37275H40.1188L39.5863 6.39051C41.7164 7.27808 43.8466 8.52068 45.6218 9.9408L48.107 7.98814C49.5271 9.23074 50.7697 10.4733 52.0123 12.071L50.0596 14.3787C51.4797 16.1538 52.7223 18.284 53.6099 20.4142L56.6277 19.8816C57.3377 21.6568 57.6928 23.6094 58.0478 25.3846L55.2076 26.4497C55.3851 27.6923 55.5626 28.7574 55.5626 30C55.5626 31.2426 55.3851 32.3077 55.2076 33.5503L58.0478 34.6154C57.6928 36.3905 57.3377 38.3432 56.6277 40.1183L53.6099 39.5858C52.7223 41.716 51.4797 43.8461 50.0596 45.6213L52.0123 48.1065C50.7697 49.5266 49.5271 50.7692 48.107 52.0118L45.6218 50.0591C43.8466 51.4793 41.7164 52.7219 39.5863 53.6094L40.1188 56.6272C38.3437 57.3372 36.391 57.6923 34.6158 58.0473L33.5508 55.2071C32.3082 55.3846 31.2431 55.5621 30.0005 55.5621C28.7579 55.5621 27.6928 55.3846 26.4502 55.2071L25.3851 58.0473C23.6099 57.6923 21.6573 57.3372 19.8821 56.6272L20.4147 53.6094C18.2845 52.7219 16.1543 51.4793 14.3792 50.0591L12.0715 52.0118C10.4738 50.7692 9.23123 49.5266 7.98863 48.1065L9.94129 45.6213C8.52117 43.8461 7.27857 41.716 6.39099 39.5858L3.37324 40.1183C2.8407 38.3432 2.30815 36.3905 1.95312 34.6154L4.79336 33.5503C4.61585 32.3077 4.43833 31.2426 4.43833 30C4.43833 15.9763 15.9768 4.43784 30.0005 4.43784ZM30.0005 6.39051C16.8644 6.39051 6.39099 16.8639 6.39099 30H17.7519C17.7519 36.7455 23.2549 42.2485 30.0005 42.2485C36.746 42.2485 42.249 36.7455 42.249 30C42.249 23.2544 36.746 17.7515 30.0005 17.7515V6.39051ZM30.0005 26.0946C32.1306 26.0946 33.9058 27.8698 33.9058 30C33.9058 32.1301 32.1306 33.9053 30.0005 33.9053C27.8703 33.9053 26.0951 32.1301 26.0951 30C26.0951 29.6449 26.2726 29.1124 26.2726 28.7574L18.817 18.9941L28.7579 26.4497C29.1129 26.2722 29.4679 26.0946 30.0005 26.0946Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.532544"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "کوتاه",
      pieceName: "فیلتر اتاق",
      desc: " فیلتر کابین نیز هوای تمیز و تصفیه‌شده را در اختیار سرنشینان خودرو قرار می‌دهد",
    },
    {
      id: 29,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_180)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.4068 27.4764C23.7712 24.1119 28.818 18.7848 30.7806 17.1026C31.3413 16.5418 32.1825 16.8222 32.4628 17.1026C32.7432 17.3829 33.304 17.9437 33.304 17.9437C34.1451 18.5044 33.5843 19.6259 33.304 19.9063C29.9395 23.2708 24.8927 28.3175 23.2105 29.9998C22.6497 30.5605 21.5283 30.2801 21.2479 29.9998C20.9675 29.7194 20.6871 29.439 20.4068 29.1586C19.846 28.5979 20.1264 27.7568 20.4068 27.4764Z"
              stroke="#FEC42B"
              stroke-width="1.40187"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.3975 35.0466C13.3975 33.9251 14.2386 33.084 15.3601 33.084C16.4816 33.084 17.3227 33.9251 17.3227 35.0466C17.3227 36.1681 16.4816 37.0092 15.3601 37.0092C14.2386 37.0092 13.3975 36.1681 13.3975 35.0466Z"
              stroke="#FEC42B"
              stroke-width="1.40187"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M44.5192 19.0652L51.5285 12.0559C52.0893 11.4951 52.0893 10.654 51.5285 10.0933L50.407 8.97178L49.5659 8.69141C49.0051 8.69141 48.4444 8.97178 48.4444 8.97178L41.4351 15.9811L34.7061 9.25215L33.865 8.97178C33.3042 8.97178 32.7435 9.25215 32.7435 9.25215L32.4631 9.8129L31.9023 10.654C31.9023 11.2148 32.4631 11.7755 32.4631 11.7755L49.0051 28.3176L49.8463 28.5979L50.6874 28.3176L51.2481 27.7568C51.8089 27.1961 51.8089 26.355 51.2481 25.7942L44.5192 19.0652Z"
              stroke="#FEC42B"
              stroke-width="1.40187"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M47.6032 29.7193C42.8368 34.2053 32.1826 44.8595 28.2574 48.7847C26.2947 51.0277 23.2106 49.9062 22.0891 48.7847L18.4443 45.1399L12.5564 51.0277C12.2761 51.3081 11.9957 51.3081 11.7153 51.3081C11.1546 51.3081 10.8742 51.3081 10.5938 51.0277L9.47232 49.9062C8.91157 49.3455 8.91157 48.5044 9.47232 47.9436L15.3602 42.0558L11.7153 38.4109C9.75269 36.4483 10.5938 33.3642 11.7153 32.2427C19.8461 24.1118 28.5377 15.4202 31.0611 13.1772L47.6032 29.7193Z"
              stroke="#FEC42B"
              stroke-width="1.40187"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_180">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6395 12.071L20.7697 15.7988L22.3673 14.9112L20.0596 11.0059L18.6395 12.071ZM11.0064 20.0591L14.9117 22.3668L15.7993 20.7692L12.0715 18.639L11.0064 20.0591ZM30.0005 4.43784C31.2431 4.43784 32.3082 4.61536 33.5508 4.79287L34.6158 1.95264H34.7934H35.1484L35.3259 2.13015H35.5034H35.8585L36.036 2.30767H36.391H36.746L36.9235 2.48518H37.1011H37.4561L37.6336 2.6627H37.9886L38.1661 2.84021H38.3437H38.6987V3.01773H38.8762H39.2312L39.4087 3.19524H39.5863L39.7638 3.37275H40.1188L39.5863 6.39051C41.7164 7.27808 43.8466 8.52068 45.6218 9.9408L48.107 7.98814C49.5271 9.23074 50.7697 10.4733 52.0123 12.071L50.0596 14.3787C51.4797 16.1538 52.7223 18.284 53.6099 20.4142L56.6277 19.8816C57.3377 21.6568 57.6928 23.6094 58.0478 25.3846L55.2076 26.4497C55.3851 27.6923 55.5626 28.7574 55.5626 30C55.5626 31.2426 55.3851 32.3077 55.2076 33.5503L58.0478 34.6154C57.6928 36.3905 57.3377 38.3432 56.6277 40.1183L53.6099 39.5858C52.7223 41.716 51.4797 43.8461 50.0596 45.6213L52.0123 48.1065C50.7697 49.5266 49.5271 50.7692 48.107 52.0118L45.6218 50.0591C43.8466 51.4793 41.7164 52.7219 39.5863 53.6094L40.1188 56.6272C38.3437 57.3372 36.391 57.6923 34.6158 58.0473L33.5508 55.2071C32.3082 55.3846 31.2431 55.5621 30.0005 55.5621C28.7579 55.5621 27.6928 55.3846 26.4502 55.2071L25.3851 58.0473C23.6099 57.6923 21.6573 57.3372 19.8821 56.6272L20.4147 53.6094C18.2845 52.7219 16.1543 51.4793 14.3792 50.0591L12.0715 52.0118C10.4738 50.7692 9.23123 49.5266 7.98863 48.1065L9.94129 45.6213C8.52117 43.8461 7.27857 41.716 6.39099 39.5858L3.37324 40.1183C2.8407 38.3432 2.30815 36.3905 1.95312 34.6154L4.79336 33.5503C4.61585 32.3077 4.43833 31.2426 4.43833 30C4.43833 15.9763 15.9768 4.43784 30.0005 4.43784ZM30.0005 6.39051C16.8644 6.39051 6.39099 16.8639 6.39099 30H17.7519C17.7519 36.7455 23.2549 42.2485 30.0005 42.2485C36.746 42.2485 42.249 36.7455 42.249 30C42.249 23.2544 36.746 17.7515 30.0005 17.7515V6.39051ZM30.0005 26.0946C32.1306 26.0946 33.9058 27.8698 33.9058 30C33.9058 32.1301 32.1306 33.9053 30.0005 33.9053C27.8703 33.9053 26.0951 32.1301 26.0951 30C26.0951 29.6449 26.2726 29.1124 26.2726 28.7574L18.817 18.9941L28.7579 26.4497C29.1129 26.2722 29.4679 26.0946 30.0005 26.0946Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.532544"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "کوتاه",
      pieceName: "فیلتر بنزین",
      desc: "فیلتر بنزین در سر راه مسیر ورودی بنزین به موتور قرار می گیرد و باعث پاکسازی بنزین از وجود رسوبات و آلاینده ها می شود. عمل فیلتراسیون بنزین توسط کاغذ های مقاوم در برابر بنزین انجام می شود. به صورتی که آلودگی های درون بنزین در این کاغذ گیر افتاده و به داخل موتور خودرو نفوذ نخواهند کرد",
    },
    {
      id: 30,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44.4639 17.6958C47.7818 18.5253 51.0998 19.6313 54.4178 21.2903C55.5238 21.8433 56.3533 22.6728 56.6298 24.0552C57.1828 25.1612 56.9063 26.5437 56.3533 27.6497L50.2703 38.1566C49.1643 40.0921 46.6759 40.9216 44.4639 40.0921C43.0814 39.5391 41.6989 38.9861 40.3164 38.7096"
            stroke="#FEC42B"
            stroke-width="1.38249"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M14.3252 18.2485C11.5602 19.078 9.07176 20.184 6.58328 21.29C5.47729 21.843 4.64779 22.6725 4.0948 24.055C3.8183 25.161 4.0948 26.5435 4.64779 27.6495L10.7307 38.1564C11.8367 40.3683 14.3252 40.9213 16.5372 40.0919C22.6201 37.6034 29.2561 36.4974 35.892 37.6034"
            stroke="#FEC42B"
            stroke-width="1.38249"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.7257 19.3545L28.4262 11.0596L32.8501 19.3545C33.1266 19.9075 33.4031 20.4605 33.1266 21.0135C32.8501 23.2255 30.6382 24.8845 28.4262 24.8845C25.9377 24.8845 24.0022 23.2255 23.4492 21.0135C23.4492 20.4605 23.4492 19.9075 23.7257 19.3545Z"
            stroke="#FEC42B"
            stroke-width="1.38249"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.4952 19.6312L20.1312 7.46533L27.0436 19.6312C27.3201 20.1842 27.3201 20.4607 27.3201 21.0137C26.7671 24.6082 23.7257 27.3732 20.1312 27.3732C16.5367 27.3732 13.4952 24.6082 13.2188 21.0137C13.2188 20.4607 13.2187 20.1842 13.4952 19.6312Z"
            stroke="#FEC42B"
            stroke-width="1.38249"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M30.915 16.0366C33.68 16.0366 36.1685 16.3131 38.9335 16.5896"
            stroke="#FEC42B"
            stroke-width="1.38249"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25.6614 16.3135H25.1084H25.6614Z"
            stroke="#FEC42B"
            stroke-width="1.38249"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M34.5096 47.0047L48.058 27.0969C48.611 26.5439 48.3345 25.4379 47.7815 24.8849C46.952 24.3319 46.1225 24.6084 45.5695 25.1614L30.6387 44.2398"
            stroke="#FEC42B"
            stroke-width="1.38249"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.4912 48.3872C26.4912 46.1752 28.4267 44.2397 30.6387 44.2397C32.8507 44.2397 34.7861 46.1752 34.7861 48.3872C34.7861 50.5992 32.8507 52.5347 30.6387 52.5347C28.4267 52.5347 26.4912 50.5992 26.4912 48.3872Z"
            stroke="#FEC42B"
            stroke-width="1.38249"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6395 12.071L20.7697 15.7988L22.3673 14.9112L20.0596 11.0059L18.6395 12.071ZM11.0064 20.0591L14.9117 22.3668L15.7993 20.7692L12.0715 18.639L11.0064 20.0591ZM30.0005 4.43784C31.2431 4.43784 32.3082 4.61536 33.5508 4.79287L34.6158 1.95264H34.7934H35.1484L35.3259 2.13015H35.5034H35.8585L36.036 2.30767H36.391H36.746L36.9235 2.48518H37.1011H37.4561L37.6336 2.6627H37.9886L38.1661 2.84021H38.3437H38.6987V3.01773H38.8762H39.2312L39.4087 3.19524H39.5863L39.7638 3.37275H40.1188L39.5863 6.39051C41.7164 7.27808 43.8466 8.52068 45.6218 9.9408L48.107 7.98814C49.5271 9.23074 50.7697 10.4733 52.0123 12.071L50.0596 14.3787C51.4797 16.1538 52.7223 18.284 53.6099 20.4142L56.6277 19.8816C57.3377 21.6568 57.6928 23.6094 58.0478 25.3846L55.2076 26.4497C55.3851 27.6923 55.5626 28.7574 55.5626 30C55.5626 31.2426 55.3851 32.3077 55.2076 33.5503L58.0478 34.6154C57.6928 36.3905 57.3377 38.3432 56.6277 40.1183L53.6099 39.5858C52.7223 41.716 51.4797 43.8461 50.0596 45.6213L52.0123 48.1065C50.7697 49.5266 49.5271 50.7692 48.107 52.0118L45.6218 50.0591C43.8466 51.4793 41.7164 52.7219 39.5863 53.6094L40.1188 56.6272C38.3437 57.3372 36.391 57.6923 34.6158 58.0473L33.5508 55.2071C32.3082 55.3846 31.2431 55.5621 30.0005 55.5621C28.7579 55.5621 27.6928 55.3846 26.4502 55.2071L25.3851 58.0473C23.6099 57.6923 21.6573 57.3372 19.8821 56.6272L20.4147 53.6094C18.2845 52.7219 16.1543 51.4793 14.3792 50.0591L12.0715 52.0118C10.4738 50.7692 9.23123 49.5266 7.98863 48.1065L9.94129 45.6213C8.52117 43.8461 7.27857 41.716 6.39099 39.5858L3.37324 40.1183C2.8407 38.3432 2.30815 36.3905 1.95312 34.6154L4.79336 33.5503C4.61585 32.3077 4.43833 31.2426 4.43833 30C4.43833 15.9763 15.9768 4.43784 30.0005 4.43784ZM30.0005 6.39051C16.8644 6.39051 6.39099 16.8639 6.39099 30H17.7519C17.7519 36.7455 23.2549 42.2485 30.0005 42.2485C36.746 42.2485 42.249 36.7455 42.249 30C42.249 23.2544 36.746 17.7515 30.0005 17.7515V6.39051ZM30.0005 26.0946C32.1306 26.0946 33.9058 27.8698 33.9058 30C33.9058 32.1301 32.1306 33.9053 30.0005 33.9053C27.8703 33.9053 26.0951 32.1301 26.0951 30C26.0951 29.6449 26.2726 29.1124 26.2726 28.7574L18.817 18.9941L28.7579 26.4497C29.1129 26.2722 29.4679 26.0946 30.0005 26.0946Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.532544"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "کوتاه",
      pieceName: "شیشه شور",
      desc: " مایع شیشه شور ماشین در مخزن پلاستیکی مخصوص قرار داشته علاوه بر اینکه رسوب نمی‌کند، وظیفه پاک کردن مخزن، شلنگ‌های رابط و پمپ شیشه شور خودرو را از آلودگی و رسوب بر عهده دارد. علاوه بر این موارد از شیشه شور ماشین در زمستان برای جلوگیری از ترکیدگی و یخ زدن لاستیک برف پاکن استفاده می‌شود.",
    },
    {
      id: 31,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M51.5254 44.3587H51.269V44.6151V45.3844C51.269 46.41 50.7561 47.4357 49.9869 48.2049C49.4741 48.7177 48.4484 49.2305 47.4228 49.2305H13.5766C11.5254 49.2305 9.73049 47.4357 9.73049 45.3844V27.6921V27.4357H6.65357C5.88434 27.4357 5.62793 26.9228 5.62793 26.1536V24.8716C5.62793 24.3587 5.88434 23.8459 6.65357 23.8459H9.47408C9.73049 23.8459 9.73049 23.5895 9.73049 23.5895V22.8203C9.73049 20.769 11.5254 18.9741 13.5766 18.9741H47.4228C48.4484 18.9741 49.4741 19.4869 49.9869 19.9998C50.7561 20.769 51.269 21.7946 51.269 22.8203V40.5126L51.5254 40.769H54.3459C54.6023 40.769 55.1151 41.0254 55.1151 41.0254C55.3715 41.2818 55.6279 41.5382 55.6279 42.051V43.0767C55.6279 43.5895 55.3715 43.8459 55.1151 43.8459C55.1151 44.1023 54.6023 44.3587 54.3459 44.3587H51.5254Z"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M13.833 18.974V17.4356C13.833 16.9227 14.3458 16.1535 14.3458 16.1535C14.6022 15.6407 15.1151 15.3843 15.6279 15.3843H38.4484L39.474 15.8971L43.3202 18.974"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M19.2178 15.3844V10.769H24.0896V15.3844"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M17.6797 10.769H25.8848"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M47.4229 22.0513V46.1538"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M13.833 22.0513V46.4102"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M17.4229 22.0513C17.4229 30 17.4229 42.3077 17.4229 46.4102"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M21.2686 22.0513C21.2686 30 21.2686 42.3077 21.2686 46.4102"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M24.8584 22.0513C24.8584 30 24.8584 42.3077 24.8584 46.4102"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M28.7051 22.0513C28.7051 30 28.7051 42.3077 28.7051 46.4102"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M32.5508 22.0513C32.5508 30 32.5508 42.3077 32.5508 46.1538"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M36.1406 22.0513C36.1406 30 36.1406 42.3077 36.1406 46.1538"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M39.9873 22.0513C39.9873 30 39.9873 42.3077 39.9873 46.1538"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M43.5762 22.0513C43.5762 30 43.5762 42.3077 43.5762 46.1538"
            stroke="#FEC42B"
            stroke-width="1.53846"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6395 12.071L20.7697 15.7988L22.3673 14.9112L20.0596 11.0059L18.6395 12.071ZM11.0064 20.0591L14.9117 22.3668L15.7993 20.7692L12.0715 18.639L11.0064 20.0591ZM30.0005 4.43784C31.2431 4.43784 32.3082 4.61536 33.5508 4.79287L34.6158 1.95264H34.7934H35.1484L35.3259 2.13015H35.5034H35.8585L36.036 2.30767H36.391H36.746L36.9235 2.48518H37.1011H37.4561L37.6336 2.6627H37.9886L38.1661 2.84021H38.3437H38.6987V3.01773H38.8762H39.2312L39.4087 3.19524H39.5863L39.7638 3.37275H40.1188L39.5863 6.39051C41.7164 7.27808 43.8466 8.52068 45.6218 9.9408L48.107 7.98814C49.5271 9.23074 50.7697 10.4733 52.0123 12.071L50.0596 14.3787C51.4797 16.1538 52.7223 18.284 53.6099 20.4142L56.6277 19.8816C57.3377 21.6568 57.6928 23.6094 58.0478 25.3846L55.2076 26.4497C55.3851 27.6923 55.5626 28.7574 55.5626 30C55.5626 31.2426 55.3851 32.3077 55.2076 33.5503L58.0478 34.6154C57.6928 36.3905 57.3377 38.3432 56.6277 40.1183L53.6099 39.5858C52.7223 41.716 51.4797 43.8461 50.0596 45.6213L52.0123 48.1065C50.7697 49.5266 49.5271 50.7692 48.107 52.0118L45.6218 50.0591C43.8466 51.4793 41.7164 52.7219 39.5863 53.6094L40.1188 56.6272C38.3437 57.3372 36.391 57.6923 34.6158 58.0473L33.5508 55.2071C32.3082 55.3846 31.2431 55.5621 30.0005 55.5621C28.7579 55.5621 27.6928 55.3846 26.4502 55.2071L25.3851 58.0473C23.6099 57.6923 21.6573 57.3372 19.8821 56.6272L20.4147 53.6094C18.2845 52.7219 16.1543 51.4793 14.3792 50.0591L12.0715 52.0118C10.4738 50.7692 9.23123 49.5266 7.98863 48.1065L9.94129 45.6213C8.52117 43.8461 7.27857 41.716 6.39099 39.5858L3.37324 40.1183C2.8407 38.3432 2.30815 36.3905 1.95312 34.6154L4.79336 33.5503C4.61585 32.3077 4.43833 31.2426 4.43833 30C4.43833 15.9763 15.9768 4.43784 30.0005 4.43784ZM30.0005 6.39051C16.8644 6.39051 6.39099 16.8639 6.39099 30H17.7519C17.7519 36.7455 23.2549 42.2485 30.0005 42.2485C36.746 42.2485 42.249 36.7455 42.249 30C42.249 23.2544 36.746 17.7515 30.0005 17.7515V6.39051ZM30.0005 26.0946C32.1306 26.0946 33.9058 27.8698 33.9058 30C33.9058 32.1301 32.1306 33.9053 30.0005 33.9053C27.8703 33.9053 26.0951 32.1301 26.0951 30C26.0951 29.6449 26.2726 29.1124 26.2726 28.7574L18.817 18.9941L28.7579 26.4497C29.1129 26.2722 29.4679 26.0946 30.0005 26.0946Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.532544"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "کوتاه",
      pieceName: "رادیاتور",
      desc: "این وسیله مجموعه‌ای از لوله‌ها و پره‌های دفع حرارت است که در کنار هم می‌توانند آب داغ موتور را خنک کنند. آب به‌وسیله واترپمپ خودرو به درون موتور کشیده و بعد از دفع حرارت وارد رادیاتور می‌شود. رادیاتور ماشین نیز در معرض هوای خنک قرار دارد و می‌تواند حرارت اضافی مایع خنک کننده موتور را دفع کند",
    },
    {
      id: 32,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 62 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M51.2703 14.3241V10.2701C51.2703 8.91872 49.919 8.10791 49.1082 8.10791C46.4055 8.10791 42.3514 8.10791 41.0001 8.10791C39.6487 8.10791 38.8379 9.72953 38.8379 10.2701C38.8379 11.6214 38.8379 13.5133 38.8379 14.3241H51.2703Z"
            stroke="#FEC42B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.7305 14.3241V10.2701C10.7305 8.91872 12.3521 8.10791 12.8926 8.10791C15.5953 8.10791 19.6494 8.10791 21.0007 8.10791C22.3521 8.10791 23.1629 9.72953 23.1629 10.2701C23.1629 11.6214 23.1629 13.5133 23.1629 14.3241H10.7305Z"
            stroke="#FEC42B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M54.2434 47.5676C38.838 47.5676 15.5947 47.5676 7.75689 47.5676C6.40554 47.5676 5.59473 46.2162 5.59473 45.4054C5.59473 37.8378 5.59473 26.4865 5.59473 22.7027C5.59473 21.3513 7.21635 20.5405 7.75689 20.5405C23.1623 20.5405 46.4055 20.5405 54.2434 20.5405C55.5947 20.5405 56.4055 21.8919 56.4055 22.7027C56.4055 30.2703 56.4055 41.6216 56.4055 45.4054C56.4055 46.7567 55.0542 47.5676 54.2434 47.5676Z"
            stroke="#FEC42B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.59507 51.6212C22.6221 51.6212 47.7572 51.6212 56.4059 51.6212C59.1086 51.6212 60.4599 48.9185 60.4599 47.5672C60.4599 38.378 60.4599 25.1347 60.4599 20.5401C60.4599 17.8374 57.7572 16.2158 56.4059 16.2158C39.3789 16.2158 14.2437 16.2158 5.59507 16.2158C2.89237 16.2158 1.54102 19.1888 1.54102 20.5401C1.54102 29.4591 1.54102 42.9726 1.54102 47.5672C1.54102 50.2699 4.24372 51.6212 5.59507 51.6212Z"
            stroke="#FEC42B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M45.0547 40.2698V27.8374"
            stroke="#FEC42B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M38.8379 34.0537H51.2703"
            stroke="#FEC42B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M10.7305 34.0537H23.1629"
            stroke="#FEC42B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6395 12.071L20.7697 15.7988L22.3673 14.9112L20.0596 11.0059L18.6395 12.071ZM11.0064 20.0591L14.9117 22.3668L15.7993 20.7692L12.0715 18.639L11.0064 20.0591ZM30.0005 4.43784C31.2431 4.43784 32.3082 4.61536 33.5508 4.79287L34.6158 1.95264H34.7934H35.1484L35.3259 2.13015H35.5034H35.8585L36.036 2.30767H36.391H36.746L36.9235 2.48518H37.1011H37.4561L37.6336 2.6627H37.9886L38.1661 2.84021H38.3437H38.6987V3.01773H38.8762H39.2312L39.4087 3.19524H39.5863L39.7638 3.37275H40.1188L39.5863 6.39051C41.7164 7.27808 43.8466 8.52068 45.6218 9.9408L48.107 7.98814C49.5271 9.23074 50.7697 10.4733 52.0123 12.071L50.0596 14.3787C51.4797 16.1538 52.7223 18.284 53.6099 20.4142L56.6277 19.8816C57.3377 21.6568 57.6928 23.6094 58.0478 25.3846L55.2076 26.4497C55.3851 27.6923 55.5626 28.7574 55.5626 30C55.5626 31.2426 55.3851 32.3077 55.2076 33.5503L58.0478 34.6154C57.6928 36.3905 57.3377 38.3432 56.6277 40.1183L53.6099 39.5858C52.7223 41.716 51.4797 43.8461 50.0596 45.6213L52.0123 48.1065C50.7697 49.5266 49.5271 50.7692 48.107 52.0118L45.6218 50.0591C43.8466 51.4793 41.7164 52.7219 39.5863 53.6094L40.1188 56.6272C38.3437 57.3372 36.391 57.6923 34.6158 58.0473L33.5508 55.2071C32.3082 55.3846 31.2431 55.5621 30.0005 55.5621C28.7579 55.5621 27.6928 55.3846 26.4502 55.2071L25.3851 58.0473C23.6099 57.6923 21.6573 57.3372 19.8821 56.6272L20.4147 53.6094C18.2845 52.7219 16.1543 51.4793 14.3792 50.0591L12.0715 52.0118C10.4738 50.7692 9.23123 49.5266 7.98863 48.1065L9.94129 45.6213C8.52117 43.8461 7.27857 41.716 6.39099 39.5858L3.37324 40.1183C2.8407 38.3432 2.30815 36.3905 1.95312 34.6154L4.79336 33.5503C4.61585 32.3077 4.43833 31.2426 4.43833 30C4.43833 15.9763 15.9768 4.43784 30.0005 4.43784ZM30.0005 6.39051C16.8644 6.39051 6.39099 16.8639 6.39099 30H17.7519C17.7519 36.7455 23.2549 42.2485 30.0005 42.2485C36.746 42.2485 42.249 36.7455 42.249 30C42.249 23.2544 36.746 17.7515 30.0005 17.7515V6.39051ZM30.0005 26.0946C32.1306 26.0946 33.9058 27.8698 33.9058 30C33.9058 32.1301 32.1306 33.9053 30.0005 33.9053C27.8703 33.9053 26.0951 32.1301 26.0951 30C26.0951 29.6449 26.2726 29.1124 26.2726 28.7574L18.817 18.9941L28.7579 26.4497C29.1129 26.2722 29.4679 26.0946 30.0005 26.0946Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.532544"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "کوتاه",
      pieceName: "باطری",
      desc: "مهم‌ترین قطعه در سیستم الکتریکی خودرو است. وظیفه‌ی این سیستم تامین، ذخیره و تقسیم انرژی الکتریکی مورد نیاز بخش‌های مختلف خودرو است. وقتی خودرو خاموش است، چراغ‌های داخلی و خارجی، سیستم تهویه، سان روف، دستگاه پخش، دزدگیر، بالابر شیشه‌ و برف پاک‌کن از باتری تغذیه می‌کنند. وقتی خودرو روشن می‌شود، وظیفه‌ی تامین انرژی الکتریکی بر عهده‌ی قطعه‌ای به نام دینام است. قسمتی از انرژی تولید شده توسط دینام در باتری ذخیره می‌شود. زمانی که دینام نتواند انرژی مورد نیاز خودرو را تأمین کند، باتری از ذخیره خود برای کمک به دینام استفاده می کند ",
    },
    {
      id: 33,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_15)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M43.5041 23.1762L42.7316 22.6612C42.7316 22.4037 42.7316 22.1462 42.7316 21.8887L42.9891 21.6312C43.2466 21.6312 43.2466 21.6312 43.5041 21.6312H43.7617L44.2767 22.4037C44.5342 22.4037 44.5342 22.4037 44.7917 22.4037L45.5642 21.6312C45.8217 21.6312 45.8217 21.3736 45.5642 21.1161L44.7917 20.6011C44.7917 20.3436 44.7917 20.0861 44.7917 19.8286L45.3067 19.5711C45.3067 19.5711 45.3067 19.5711 45.5642 19.5711H45.8217L46.3368 20.3436C46.5943 20.3436 46.5943 20.3436 46.8518 20.3436L47.6243 19.5711C47.8818 19.5711 47.8818 19.3136 47.6243 19.056L47.1093 18.541L47.3668 18.2835C47.8818 17.7685 47.8818 16.996 47.3668 16.4809L45.8217 14.9359L44.2767 13.6483C44.0192 13.3908 43.7617 13.1333 43.5041 13.1333C42.9891 13.1333 42.7316 13.3908 42.4741 13.6483H42.2166L41.7016 13.1333H41.4441L40.6715 13.6483C40.414 13.9058 40.414 13.9058 40.414 14.1633C40.414 14.1633 40.414 14.1633 40.6715 14.4209L41.1865 14.9359C41.4441 15.1934 41.4441 15.1934 41.4441 15.4509C41.4441 15.4509 41.4441 15.4509 41.1865 15.7084L40.929 15.9659H40.6715C40.414 15.9659 40.414 15.9659 40.414 15.9659L39.6415 15.1934H39.384L38.6114 15.9659C38.3539 15.9659 38.3539 15.9659 38.3539 16.2234C38.3539 16.2234 38.3539 16.4809 38.6114 16.4809L39.1265 16.996C39.1265 17.2535 39.384 17.2535 39.384 17.511C39.384 17.511 39.1265 17.511 39.1265 17.7685L38.869 18.026H38.6114C38.3539 18.026 38.3539 18.026 38.3539 18.026L37.5814 17.2535C37.3239 17.2535 37.0664 17.2535 37.0664 17.2535L36.8089 17.511L30.3711 23.9488L33.4612 27.2964L36.8089 30.644L43.2466 24.2063L43.5041 23.9488C43.5041 23.6912 43.5041 23.4337 43.5041 23.1762Z"
              stroke="#FEC42B"
              stroke-width="1.54506"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.6029 41.4595C12.6029 41.4595 12.6029 41.4595 12.6029 41.717L11.3153 42.232L11.5729 42.4895L10.2853 43.7771C10.0278 44.0346 10.0278 44.5496 10.0278 44.8071C10.0278 45.0646 10.0278 45.3221 10.2853 45.5796L11.0578 46.3522L8.74023 48.9273L11.0578 51.2449L11.8304 50.4723L10.2853 48.9273L11.8304 47.1247L12.6029 47.8972L11.8304 48.6698L12.8604 49.6998L13.6329 48.9273L15.178 50.4723C15.4355 50.7299 15.693 50.7299 15.9505 50.7299C16.4656 50.7299 16.7231 50.7299 16.9806 50.4723L19.0407 48.4123L20.0707 47.8972L20.3282 47.6397C20.3282 47.3822 20.3282 47.3822 20.0707 47.1247L13.1179 41.717C12.8604 41.4595 12.8604 41.4595 12.8604 41.4595H12.6029Z"
              stroke="#FEC42B"
              stroke-width="1.54506"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.3581 46.0948H20.8431L13.8903 40.687L13.6328 40.172L13.8903 39.9145L14.6629 39.657H15.1779L22.1307 45.0647L22.3882 45.5797L22.1307 45.8373L21.3581 46.0948Z"
              stroke="#FEC42B"
              stroke-width="1.54506"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M23.4187 44.2922L22.9037 44.0347L15.9509 38.627L15.6934 38.3695L15.9509 37.8545L16.7234 37.5969H17.2384L24.1912 43.0047L24.4487 43.5197L24.1912 43.7772L23.4187 44.2922Z"
              stroke="#FEC42B"
              stroke-width="1.54506"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M48.6541 15.4509C48.1391 15.9659 47.3666 15.9659 46.8516 15.4509L46.079 14.6783L45.564 13.9058C45.049 13.3908 45.049 12.6183 45.564 12.1032L45.8215 11.8457L47.3666 10.8157C47.6241 10.8157 47.8816 10.5582 47.8816 10.3007L48.3966 9.52812C48.3966 9.27061 48.9116 9.0131 49.1692 8.75559H49.9417C50.1992 8.49808 50.7142 8.75559 50.9717 9.0131L51.4867 9.52812L51.7443 9.78563C52.0018 10.0431 52.2593 10.5582 52.0018 11.0732V11.5882C52.0018 12.1032 51.7443 12.3607 51.2292 12.6183L50.4567 12.8758C50.1992 13.1333 49.9417 13.1333 49.9417 13.3908L48.9116 14.9358V15.1934L48.6541 15.4509Z"
              stroke="#FEC42B"
              stroke-width="1.54506"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M28.3109 42.232L27.7958 42.4895L27.0233 42.747L25.9933 42.232L25.4783 41.717L25.2207 42.232L17.7529 36.3092L19.0405 35.2792L18.5255 34.7642L18.268 33.7341V33.2191L18.5255 32.4466L21.6156 29.3565L22.6456 29.0989L23.6757 28.0689V26.2663C23.6757 25.7513 23.9332 25.2363 23.9332 25.2363L24.9632 24.4638L25.7358 23.9487H28.5684L29.5984 24.2062L32.9461 27.8114L36.5512 31.4165L36.8087 32.1891V35.0217L36.2937 36.0517L35.5212 36.8243C35.5212 36.8243 35.0061 37.0818 34.4911 37.0818L32.6886 37.3393L31.916 38.1118V38.6268L28.3109 42.232Z"
              stroke="#FEC42B"
              stroke-width="1.54506"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_15">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M55.4129 28.624C55.4129 29.9084 55.2295 31.0093 55.2295 32.2937L57.9818 33.3946C57.6148 35.4129 57.2478 37.2478 56.5139 39.0827L53.5781 38.5322C52.6606 40.9175 51.3762 43.1194 50.0918 44.9542L51.9267 47.523C50.6423 48.9909 49.3579 50.2753 47.89 51.7432L45.6882 49.5414C43.8533 51.1928 41.6515 52.4772 39.4496 53.3946L40.0001 56.5139C38.1652 57.0643 36.3304 57.6148 34.4955 57.9818L33.5781 55.046C32.2937 55.2295 31.1928 55.2295 29.9084 55.2295C28.8074 55.2295 27.523 55.2295 26.4221 55.046L25.3212 57.9818C23.4863 57.6148 21.6515 57.0643 19.8166 56.5139L20.3671 53.3946C18.1652 52.4772 16.1469 51.1928 14.312 49.5414L11.9267 51.7432C10.4588 50.4588 9.17441 48.9909 7.89001 47.523L9.90836 44.9542C8.44047 43.1194 7.33955 40.9175 6.42212 38.5322L3.30285 39.0827C2.75239 37.2478 2.20193 35.4129 1.83496 33.3946L4.77074 32.2937C4.58725 31.0093 4.58725 29.9084 4.58725 28.624C4.58725 13.9451 15.9634 1.83496 29.9084 1.83496C44.0368 1.83496 55.4129 13.9451 55.4129 28.624ZM53.5781 28.624C53.5781 14.8625 42.9359 3.85331 29.9084 3.85331C16.8808 3.85331 6.42212 14.8625 6.42212 28.624H17.7983C17.7983 35.5964 23.3029 41.468 29.9084 41.468C36.6973 41.468 42.2019 35.5964 42.2019 28.624H53.5781ZM29.9084 24.5873C32.1102 24.5873 33.7616 26.4221 33.7616 28.624C33.7616 30.8258 32.1102 32.6606 29.9084 32.6606C27.89 32.6606 26.0551 30.8258 26.0551 28.624C26.0551 28.0735 26.2386 27.7065 26.2386 27.3395L18.7157 17.0643L28.624 24.7707C28.9909 24.5873 29.5414 24.5873 29.9084 24.5873ZM18.5322 9.72487L20.734 13.7616L22.2019 12.6606L20.1836 8.80744L18.5322 9.72487ZM11.0093 18.1652L14.8625 20.5506L15.7799 18.8992L11.9267 16.6973L11.0093 18.1652ZM47.89 16.6973L44.2203 18.8992L45.1377 20.5506L48.8074 18.1652L47.89 16.6973ZM39.8166 8.80744L37.6148 12.6606L39.2662 13.7616L41.468 9.72487L39.8166 8.80744ZM28.9909 6.23863V10.8258H30.8258V6.23863H28.9909Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.550459"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "میان",
      pieceName: "شمع",
      desc: " شمع ابزاری است برای انتقال جرقه‌های متناوب برق داخل سیلندرها که در انتهای سیلندر و روی سرسیلندر در موتور اتومبیل نصب می‌شود و برق موتور که با حرکت متناوب دلکو به سر شمع‌ها می‌رسد، طوری تنظیم شده که به هنگام فشردگی بخار بنزین در انتهای سیلندر جرقه‌ای از انتهای شمع ساطع شده، و باعث انفجار بنزین و حرکت موتور می شود.",
    },
    {
      id: 34,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_37)">
            <path
              d="M39.4475 30.263L38.1317 28.9472C38.1317 28.9472 38.1317 28.684 38.1317 28.4208L41.5528 25.263L53.1317 28.1577L50.237 25.263L43.1317 23.4208M43.1317 23.4208L44.4475 22.1051C44.4475 22.1051 44.4475 21.8419 44.4475 21.5787L37.0791 14.4735C37.0791 14.2103 37.0791 14.2103 36.8159 14.2103C36.8159 14.2103 36.5528 14.2103 36.5528 14.4735L35.5002 15.5261L32.0791 15.7893L42.8686 26.5787L43.1317 23.4208ZM43.1317 23.4208L36.2896 16.3156L39.7107 12.8945C39.9738 12.8945 39.9738 12.8945 40.237 12.8945C40.237 12.8945 40.237 12.8945 40.5002 12.8945L45.7633 18.4208C46.0265 18.4208 46.0265 18.684 45.7633 18.9472L43.9212 21.0524"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M48.3945 15.7893H48.6576H49.184L49.9734 14.9999V14.2104L44.4471 8.94724L44.184 8.68408L43.9208 8.94724L43.1313 9.73671L42.8682 9.99987L43.1313 10.263L48.3945 15.7893Z"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M38.1316 31.5789L39.4474 30.2632L51.8158 33.4211L49.9737 35.2632L38.9211 32.3684L37.6053 33.6842C37.6053 33.9474 37.6053 33.9474 37.3422 33.9474C37.3422 33.9474 37.079 33.9474 37.079 33.6842L24.9737 21.5789C24.7106 21.5789 24.7106 21.3158 24.9737 21.0526L26.0264 20C26.2895 20 26.5527 20 26.5527 20L38.1316 31.5789Z"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M36.0263 32.6317L23.3947 45.2632L20.2368 45.7895L17.3421 48.6843L16.8157 48.9474L16.5526 48.6843L9.97363 42.1053V41.579L13.1315 38.4211L13.3947 35.2632L26.0263 22.6317L27.3421 20.7896L32.0789 15.7896"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.4477 50.7893H13.9214L8.13194 44.9998C7.86878 44.7367 7.86878 44.4735 8.13194 44.2104L8.65825 43.6841L8.92141 43.4209C9.18457 43.4209 9.18457 43.6841 9.18457 43.6841L15.2372 49.4735V49.7367C15.2372 49.9998 15.2372 49.9998 15.2372 49.9998L14.4477 50.7893Z"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M10.7634 42.8945L8.6581 45.263L7.60547 47.3682L7.86863 47.8945L10.7634 51.0524H11.2897L13.6581 50.263L15.7634 47.8945"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M23.3945 45.2632L13.3945 35.2632"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M20.2371 45.7893L13.1318 38.4209"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M43.1316 10.2632L40.5 12.8948"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M51.8164 33.4209L53.1322 28.1577"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M48.3952 15.5264L45.7637 18.1579"
              stroke="#FEC42B"
              stroke-width="1.57895"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_37">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M55.4129 28.624C55.4129 29.9084 55.2295 31.0093 55.2295 32.2937L57.9818 33.3946C57.6148 35.4129 57.2478 37.2478 56.5139 39.0827L53.5781 38.5322C52.6606 40.9175 51.3762 43.1194 50.0918 44.9542L51.9267 47.523C50.6423 48.9909 49.3579 50.2753 47.89 51.7432L45.6882 49.5414C43.8533 51.1928 41.6515 52.4772 39.4496 53.3946L40.0001 56.5139C38.1652 57.0643 36.3304 57.6148 34.4955 57.9818L33.5781 55.046C32.2937 55.2295 31.1928 55.2295 29.9084 55.2295C28.8074 55.2295 27.523 55.2295 26.4221 55.046L25.3212 57.9818C23.4863 57.6148 21.6515 57.0643 19.8166 56.5139L20.3671 53.3946C18.1652 52.4772 16.1469 51.1928 14.312 49.5414L11.9267 51.7432C10.4588 50.4588 9.17441 48.9909 7.89001 47.523L9.90836 44.9542C8.44047 43.1194 7.33955 40.9175 6.42212 38.5322L3.30285 39.0827C2.75239 37.2478 2.20193 35.4129 1.83496 33.3946L4.77074 32.2937C4.58725 31.0093 4.58725 29.9084 4.58725 28.624C4.58725 13.9451 15.9634 1.83496 29.9084 1.83496C44.0368 1.83496 55.4129 13.9451 55.4129 28.624ZM53.5781 28.624C53.5781 14.8625 42.9359 3.85331 29.9084 3.85331C16.8808 3.85331 6.42212 14.8625 6.42212 28.624H17.7983C17.7983 35.5964 23.3029 41.468 29.9084 41.468C36.6973 41.468 42.2019 35.5964 42.2019 28.624H53.5781ZM29.9084 24.5873C32.1102 24.5873 33.7616 26.4221 33.7616 28.624C33.7616 30.8258 32.1102 32.6606 29.9084 32.6606C27.89 32.6606 26.0551 30.8258 26.0551 28.624C26.0551 28.0735 26.2386 27.7065 26.2386 27.3395L18.7157 17.0643L28.624 24.7707C28.9909 24.5873 29.5414 24.5873 29.9084 24.5873ZM18.5322 9.72487L20.734 13.7616L22.2019 12.6606L20.1836 8.80744L18.5322 9.72487ZM11.0093 18.1652L14.8625 20.5506L15.7799 18.8992L11.9267 16.6973L11.0093 18.1652ZM47.89 16.6973L44.2203 18.8992L45.1377 20.5506L48.8074 18.1652L47.89 16.6973ZM39.8166 8.80744L37.6148 12.6606L39.2662 13.7616L41.468 9.72487L39.8166 8.80744ZM28.9909 6.23863V10.8258H30.8258V6.23863H28.9909Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.550459"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "میان",
      pieceName: "انژکتور",
      desc: "انژکتور سیستمی است که وظیفه پاشش سوخت درون سیلندر را بر عهده دارد و در نتیجه در خودروهای پاششی مورد استفاده قرار می‌گیرد. این قطعه الکتریکی-مکانیکی در ورودی سیلندر قرار می‌گیرد و عمل تزریق سوخت درون محفظه‌ی احتراق را انجام می‌دهد. انژکتور جایگزینی برای کاربراتور است که در خودروهای قدیمی‌تر بخشی از سیستم سوخت‌رسانی خودرو بود. می‌دانیم که احتراق حاصل از انفجار ترکیب متراکم شده سوخت و هوا، تامین کننده کل انرژی مورد نیاز خود رو است.",
    },
    {
      id: 35,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_323)">
            <path
              d="M40.2402 46.4932L41.5389 47.7919"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M35.5645 48.3115L36.3437 50.1297"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M25.6943 48.5713V50.3895"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M21.0195 46.4932L20.5 48.3113"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M17.1229 43.6362L16.084 45.1947"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M14.0067 39.7402L12.708 41.0389"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M14.0067 20.5195L12.1885 20"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M17.1229 16.6234L15.3047 15.5845"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M21.0194 13.5062L19.7207 12.2075"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M25.6942 11.6883L24.6553 9.87012"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M30.3701 10.909L30.1104 9.09082M31.1493 50.909L30.6298 49.0908"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M35.3047 11.6883L35.5644 9.61035"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M39.9805 13.5062L40.5 11.688"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M43.876 16.6234L44.9149 14.8052"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M46.9932 20.5194L48.2919 19.2207"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M48.8115 25.1947L50.6297 24.1558"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M49.5908 29.8701L51.409 29.6104"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M49.0713 34.8052L50.8895 35.0649"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M46.9932 39.4805L48.8113 40"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M44.1357 43.3765L45.6942 44.4154"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M26.4736 30.1295C26.4736 27.7918 28.2918 25.9736 30.6295 25.9736C32.7074 25.9736 34.7853 27.7918 34.7853 30.1295C34.7853 32.2074 32.7074 34.2853 30.6295 34.2853C28.2918 34.2853 26.4736 32.2074 26.4736 30.1295Z"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M41.5387 37.1427L39.7205 38.9608C37.9023 36.8829 35.5647 35.3245 32.7075 34.0258L32.188 34.2855C31.6686 37.1427 31.4088 39.9998 31.9283 42.8569H29.3309C29.5906 39.9998 29.5906 37.1427 28.8114 34.2855C28.8114 34.2855 28.8114 34.0258 28.5517 34.0258H28.2919C25.6945 35.3245 23.3569 36.8829 21.2789 38.9608L19.7205 37.1427C22.3179 35.5842 24.3958 33.766 26.214 31.4284C26.214 31.1686 26.214 31.1686 26.214 30.9089C26.214 30.9089 26.214 30.9089 25.9543 30.6491C23.3569 29.3504 20.4997 28.5712 17.6426 28.3115L18.4218 25.9738C21.0192 27.0128 23.8763 27.5323 26.7335 27.5323C26.9932 27.5323 26.9932 27.5323 26.9932 27.2725C27.253 27.2725 27.253 27.0128 27.253 27.0128C26.4737 24.1556 25.4348 21.5582 23.8763 18.9608L26.214 17.9219C26.9932 20.779 28.2919 23.3764 30.1101 25.4543C30.3699 25.7141 30.3699 25.7141 30.6296 25.7141C30.6296 25.7141 30.8893 25.7141 30.8893 25.4543C32.7075 23.3764 34.0062 20.779 35.0452 17.9219L37.3828 18.9608C35.8244 21.2985 34.5257 23.8959 34.0062 26.753C34.0062 27.0128 34.0062 27.0128 34.0062 27.0128L34.266 27.5323C37.1231 27.5323 39.9802 27.0128 42.8374 25.9738L43.3569 28.3115C40.4997 28.5712 37.6426 29.3504 35.0452 30.6491C35.0452 30.9089 34.7854 30.9089 34.7854 30.9089C34.7854 31.1686 34.7854 31.1686 35.0452 31.4284C36.6036 33.766 38.9413 35.5842 41.5387 37.1427Z"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.81152 30.1297C8.81152 17.9219 18.4219 8.31152 30.6297 8.31152C42.5778 8.31152 52.4479 17.9219 52.4479 30.1297C52.4479 42.0778 42.5778 51.9479 30.6297 51.9479C18.4219 51.9479 8.81152 42.0778 8.81152 30.1297Z"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.3047 30.1299C15.3047 21.5584 22.0579 14.8052 30.6294 14.8052C38.9411 14.8052 45.6943 21.5584 45.6943 30.1299C45.6943 38.4415 38.9411 45.1948 30.6294 45.1948C22.0579 45.1948 15.3047 38.4415 15.3047 30.1299Z"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.6426 30.1296C17.6426 22.8569 23.3569 17.1426 30.6296 17.1426C37.6426 17.1426 43.3569 22.8569 43.3569 30.1296C43.3569 37.1426 37.6426 42.8569 30.6296 42.8569C23.3569 42.8569 17.6426 37.1426 17.6426 30.1296Z"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M12.1883 35.0649L10.3701 35.8442"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M11.409 30.1299L9.59082 30.6494"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M12.1883 25.1948H10.1104"
              stroke="#FEC42B"
              stroke-width="1.55844"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_323">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M55.4129 28.624C55.4129 29.9084 55.2295 31.0093 55.2295 32.2937L57.9818 33.3946C57.6148 35.4129 57.2478 37.2478 56.5139 39.0827L53.5781 38.5322C52.6606 40.9175 51.3762 43.1194 50.0918 44.9542L51.9267 47.523C50.6423 48.9909 49.3579 50.2753 47.89 51.7432L45.6882 49.5414C43.8533 51.1928 41.6515 52.4772 39.4496 53.3946L40.0001 56.5139C38.1652 57.0643 36.3304 57.6148 34.4955 57.9818L33.5781 55.046C32.2937 55.2295 31.1928 55.2295 29.9084 55.2295C28.8074 55.2295 27.523 55.2295 26.4221 55.046L25.3212 57.9818C23.4863 57.6148 21.6515 57.0643 19.8166 56.5139L20.3671 53.3946C18.1652 52.4772 16.1469 51.1928 14.312 49.5414L11.9267 51.7432C10.4588 50.4588 9.17441 48.9909 7.89001 47.523L9.90836 44.9542C8.44047 43.1194 7.33955 40.9175 6.42212 38.5322L3.30285 39.0827C2.75239 37.2478 2.20193 35.4129 1.83496 33.3946L4.77074 32.2937C4.58725 31.0093 4.58725 29.9084 4.58725 28.624C4.58725 13.9451 15.9634 1.83496 29.9084 1.83496C44.0368 1.83496 55.4129 13.9451 55.4129 28.624ZM53.5781 28.624C53.5781 14.8625 42.9359 3.85331 29.9084 3.85331C16.8808 3.85331 6.42212 14.8625 6.42212 28.624H17.7983C17.7983 35.5964 23.3029 41.468 29.9084 41.468C36.6973 41.468 42.2019 35.5964 42.2019 28.624H53.5781ZM29.9084 24.5873C32.1102 24.5873 33.7616 26.4221 33.7616 28.624C33.7616 30.8258 32.1102 32.6606 29.9084 32.6606C27.89 32.6606 26.0551 30.8258 26.0551 28.624C26.0551 28.0735 26.2386 27.7065 26.2386 27.3395L18.7157 17.0643L28.624 24.7707C28.9909 24.5873 29.5414 24.5873 29.9084 24.5873ZM18.5322 9.72487L20.734 13.7616L22.2019 12.6606L20.1836 8.80744L18.5322 9.72487ZM11.0093 18.1652L14.8625 20.5506L15.7799 18.8992L11.9267 16.6973L11.0093 18.1652ZM47.89 16.6973L44.2203 18.8992L45.1377 20.5506L48.8074 18.1652L47.89 16.6973ZM39.8166 8.80744L37.6148 12.6606L39.2662 13.7616L41.468 9.72487L39.8166 8.80744ZM28.9909 6.23863V10.8258H30.8258V6.23863H28.9909Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.550459"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "میان",
      pieceName: "لاستیک",
      desc: "لاستیک خودرو (تایر) بخشی از شاسی ماشین است که به صورت حلقه در اطراف چرخ قرار می‌گیرد. هدف از نصب تایر به دور چرخ، محافظت از رینگ خودرو و عملکرد بهتر آن است. این قطعه همواره در تماس با سطح زمین بوده و در مجاورت آسفالت، شن و ماسه، سنگ ریزه، خاک، گل و … است. از این رو باید از مقاومت مناسبی نسبت به این مواد برخوردار باشد.",
    },
    {
      id: 36,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_209)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M39.3393 15.268C39.3393 15.8037 39.0714 16.3394 39.0714 16.3394L38 16.6073H35.3214C34.7857 16.6073 34.25 16.0716 34.25 15.268V13.6609L33.7143 12.8573L32.9107 12.5894H28.0893C27.2857 12.5894 26.75 11.7859 26.75 11.2501V9.643C26.75 9.10728 27.0179 8.57157 27.0179 8.57157C27.0179 8.57157 27.5536 8.30371 28.0893 8.30371H45.5L46.3036 8.57157C46.3036 8.57157 46.8393 9.10728 46.8393 9.643V11.2501L46.3036 12.0537L45.5 12.5894H40.6786C39.875 12.5894 39.3393 13.1251 39.3393 13.6609V15.268Z"
              stroke="#FEC42B"
              stroke-width="1.60714"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M39.8749 34.8215C39.3391 34.8215 38.5356 34.8215 37.9999 34.8215L37.732 33.2144L36.9284 32.9465L35.857 33.7501C35.3213 33.4822 34.7856 32.9465 34.5177 32.4108L35.3213 31.3394L35.0534 30.5358L33.4463 30.2679C33.4463 29.7322 33.4463 28.9286 33.4463 28.3929L35.0534 28.1251L35.3213 27.3215L34.5177 26.2501C34.7856 25.7144 35.3213 25.1786 35.857 24.9108L36.9284 25.7144L37.732 25.4465L37.9999 23.8394C38.5356 23.8394 39.3391 23.8394 39.8749 23.8394L40.1427 25.4465L40.9463 25.7144L42.0177 24.9108C42.5534 25.1786 43.0891 25.7144 43.357 26.2501L42.5534 27.3215L42.8213 28.1251L44.4284 28.3929C44.4284 28.9286 44.4284 29.7322 44.4284 30.2679L42.8213 30.5358L42.5534 31.3394L43.357 32.4108C43.0891 32.9465 42.5534 33.4822 42.0177 33.7501L40.9463 32.9465L40.1427 33.2144L39.8749 34.8215Z"
              stroke="#FEC42B"
              stroke-width="1.60714"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M37.1963 29.4644C37.1963 28.3929 37.9999 27.5894 38.8034 27.5894C39.8749 27.5894 40.6784 28.3929 40.6784 29.4644C40.6784 30.2679 39.8749 31.0715 38.8034 31.0715C37.9999 31.0715 37.1963 30.2679 37.1963 29.4644Z"
              stroke="#FEC42B"
              stroke-width="1.60714"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M29.1604 43.9288C28.3569 43.9288 27.5533 43.9288 26.7497 43.9288L26.4819 42.0538C26.214 41.7859 25.9462 41.7859 25.4104 41.5181L24.0711 42.5895C23.2676 42.3216 22.7319 41.5181 22.1961 40.9824L23.2676 39.3752C23.2676 39.1074 22.9997 38.8395 22.9997 38.3038L21.1247 38.0359C20.8569 37.2324 20.8569 36.4288 21.1247 35.6252L22.9997 35.3574C22.9997 35.0895 23.2676 34.8216 23.2676 34.2859L22.1961 32.9466C22.7319 32.1431 23.2676 31.6074 24.0711 31.0716L25.4104 32.1431C25.9462 32.1431 26.214 31.8752 26.4819 31.8752L26.7497 30.0002C27.5533 29.7324 28.3569 29.7324 29.1604 30.0002L29.4283 31.8752C29.964 31.8752 30.2319 32.1431 30.4997 32.1431L32.1069 31.0716C32.6426 31.6074 33.4461 32.1431 33.714 32.9466L32.6426 34.2859C32.9104 34.8216 32.9104 35.0895 33.1783 35.3574L35.0533 35.6252C35.0533 36.4288 35.0533 37.2324 35.0533 38.0359L33.1783 38.3038C32.9104 38.8395 32.9104 39.1074 32.6426 39.3752L33.714 40.9824C33.4461 41.5181 32.6426 42.3216 32.1069 42.5895L30.4997 41.5181C30.2319 41.7859 29.964 41.7859 29.4283 42.0538L29.1604 43.9288Z"
              stroke="#FEC42B"
              stroke-width="1.60714"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.9463 36.9646C25.9463 35.6253 26.7499 34.8218 28.0891 34.8218C29.1606 34.8218 30.232 35.6253 30.232 36.9646C30.232 38.0361 29.1606 39.1075 28.0891 39.1075C26.7499 39.1075 25.9463 38.0361 25.9463 36.9646Z"
              stroke="#FEC42B"
              stroke-width="1.60714"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M51.3927 43.1251C51.9284 42.3215 52.4642 41.5179 52.4642 40.4465V38.8394C52.4642 38.3036 52.9999 37.5001 53.5356 37.5001H54.0713C54.3391 37.5001 54.607 37.7679 54.8749 38.0358C55.1427 38.3036 55.4106 38.5715 55.4106 38.8394V43.9286C55.4106 44.1965 55.4106 44.4644 55.6784 44.7322C55.9463 45.0001 56.2142 45.0001 56.482 45.0001H58.357C58.6249 45.0001 58.8927 45.0001 59.1606 44.7322C59.4284 44.4644 59.4284 44.1965 59.4284 43.9286V26.2501C59.4284 25.9822 59.4284 25.7144 59.1606 25.4465C58.8927 25.1786 58.6249 24.9108 58.357 24.9108H56.482C56.2142 24.9108 55.9463 25.1786 55.6784 25.4465C55.4106 25.7144 55.4106 25.9822 55.4106 26.2501V31.0715C55.4106 31.6072 55.1427 31.8751 54.8749 32.1429C54.607 32.4108 54.3391 32.4108 54.0713 32.4108H53.5356C53.2677 32.4108 52.9999 32.4108 52.732 32.1429C52.4641 31.8751 52.4642 31.6072 52.4642 31.0715V22.5001C52.4642 21.1608 51.9284 20.0894 51.1249 19.2858C50.3213 18.4822 49.2499 18.2144 48.1784 18.2144H22.732C21.6606 18.2144 20.5891 18.4822 19.7856 19.2858L16.0356 23.3036C15.232 24.1072 14.1606 24.3751 12.8213 24.3751C11.7499 24.3751 10.6784 24.9108 9.87486 25.7144C9.07129 26.5179 8.53557 27.5894 8.53557 28.6608V31.0715C8.53557 31.6072 8.53557 31.8751 8.26772 32.1429C7.99986 32.4108 7.732 32.4108 7.19629 32.4108H6.92843C6.66057 32.4108 6.39272 32.4108 6.12486 32.1429C5.857 31.8751 5.58915 31.6072 5.58915 31.0715V26.2501C5.58915 25.4465 5.05343 24.9108 4.51772 24.9108H2.64272C2.37486 24.9108 2.107 25.1786 1.83915 25.4465C1.57129 25.7144 1.57129 25.9822 1.57129 26.2501V43.9286C1.57129 44.1965 1.57129 44.4644 1.83915 44.7322C2.107 45.0001 2.37486 45.0001 2.64272 45.0001H4.51772C5.05343 45.0001 5.58915 44.4644 5.58915 43.9286V38.8394C5.58915 38.3036 6.39272 37.5001 6.92843 37.5001H7.19629C7.732 37.5001 7.99986 37.7679 8.26772 38.0358C8.53557 38.3036 8.53557 38.5715 8.53557 38.8394V41.2501C8.53557 42.3215 9.07129 43.3929 9.87486 44.1965C10.6784 45.0001 11.7499 45.5358 12.8213 45.5358C13.8927 45.5358 15.232 46.0715 16.0356 46.8751L19.7856 50.6251C20.5891 51.1608 21.6606 51.6965 22.732 51.6965H42.0177C43.357 51.6965 44.4284 51.1608 45.232 50.3572L51.3927 43.1251Z"
              stroke="#FEC42B"
              stroke-width="1.60714"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_209">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M55.4129 28.624C55.4129 29.9084 55.2295 31.0093 55.2295 32.2937L57.9818 33.3946C57.6148 35.4129 57.2478 37.2478 56.5139 39.0827L53.5781 38.5322C52.6606 40.9175 51.3762 43.1194 50.0918 44.9542L51.9267 47.523C50.6423 48.9909 49.3579 50.2753 47.89 51.7432L45.6882 49.5414C43.8533 51.1928 41.6515 52.4772 39.4496 53.3946L40.0001 56.5139C38.1652 57.0643 36.3304 57.6148 34.4955 57.9818L33.5781 55.046C32.2937 55.2295 31.1928 55.2295 29.9084 55.2295C28.8074 55.2295 27.523 55.2295 26.4221 55.046L25.3212 57.9818C23.4863 57.6148 21.6515 57.0643 19.8166 56.5139L20.3671 53.3946C18.1652 52.4772 16.1469 51.1928 14.312 49.5414L11.9267 51.7432C10.4588 50.4588 9.17441 48.9909 7.89001 47.523L9.90836 44.9542C8.44047 43.1194 7.33955 40.9175 6.42212 38.5322L3.30285 39.0827C2.75239 37.2478 2.20193 35.4129 1.83496 33.3946L4.77074 32.2937C4.58725 31.0093 4.58725 29.9084 4.58725 28.624C4.58725 13.9451 15.9634 1.83496 29.9084 1.83496C44.0368 1.83496 55.4129 13.9451 55.4129 28.624ZM53.5781 28.624C53.5781 14.8625 42.9359 3.85331 29.9084 3.85331C16.8808 3.85331 6.42212 14.8625 6.42212 28.624H17.7983C17.7983 35.5964 23.3029 41.468 29.9084 41.468C36.6973 41.468 42.2019 35.5964 42.2019 28.624H53.5781ZM29.9084 24.5873C32.1102 24.5873 33.7616 26.4221 33.7616 28.624C33.7616 30.8258 32.1102 32.6606 29.9084 32.6606C27.89 32.6606 26.0551 30.8258 26.0551 28.624C26.0551 28.0735 26.2386 27.7065 26.2386 27.3395L18.7157 17.0643L28.624 24.7707C28.9909 24.5873 29.5414 24.5873 29.9084 24.5873ZM18.5322 9.72487L20.734 13.7616L22.2019 12.6606L20.1836 8.80744L18.5322 9.72487ZM11.0093 18.1652L14.8625 20.5506L15.7799 18.8992L11.9267 16.6973L11.0093 18.1652ZM47.89 16.6973L44.2203 18.8992L45.1377 20.5506L48.8074 18.1652L47.89 16.6973ZM39.8166 8.80744L37.6148 12.6606L39.2662 13.7616L41.468 9.72487L39.8166 8.80744ZM28.9909 6.23863V10.8258H30.8258V6.23863H28.9909Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.550459"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "میان",
      pieceName: "گیربکس",
      desc: "گیربکس یا همان جعبه دنده خودرو، یکی از قطعات مهمی که حرکت خودرو بدون آن غیرممکن به نظر می‌رسد است. گیربکس میزان معینی از گشتاور تولیدی توسط قوای محرکه را از طریق کلاچ به چرخ‌ها منتقل کرده و جزئی از سیستم انتقال قدرت محسوب میشود ",
    },
    {
      id: 37,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M32.4822 37.7971L27.4602 34.8896L24.5527 39.9117"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M27.4609 34.8901C27.4609 39.9121 31.69 43.8769 36.712 43.8769C41.7341 43.8769 45.6988 39.9121 45.6988 34.8901C45.6988 29.8681 41.7341 25.9033 36.712 25.9033"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M31.6895 31.9822L36.7115 34.8897L39.619 29.8677"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M36.7116 34.8897C36.7116 31.1892 34.3328 28.0174 31.161 26.4315C27.7249 25.1099 23.7601 25.9029 21.1169 28.5461C18.4738 31.1892 17.9451 34.8897 19.2667 38.3258C20.5883 41.7619 24.0244 43.8764 27.4605 43.8764"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M39.3552 15.3304C39.3552 15.5947 39.0909 16.1234 39.0909 16.3877C38.8266 16.3877 38.2979 16.652 38.0336 16.652H35.3904C34.8618 16.652 34.0689 16.1234 34.0689 15.3304V13.7445C34.0689 13.4802 34.0689 13.2159 33.8045 12.9516C33.5402 12.6872 33.2759 12.4229 33.0116 12.4229H27.9896C27.1966 12.4229 26.668 11.8943 26.668 11.1013V9.51543C26.668 9.25112 26.9323 8.9868 27.1966 8.72248C27.1966 8.45816 27.7252 8.19385 27.9896 8.19385H45.4345C45.9631 8.19385 46.2274 8.45816 46.4918 8.72248C46.7561 8.9868 46.7561 9.25112 46.7561 9.51543V11.1013C46.7561 11.63 46.7561 11.8943 46.4918 12.1586C46.2274 12.4229 45.9631 12.4229 45.4345 12.4229H40.6768C39.8838 12.4229 39.3552 12.9516 39.3552 13.7445V15.3304Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.46511 25.11H2.8792C2.35057 25.11 2.08625 25.11 1.82193 25.3744C1.55762 25.6387 1.55762 25.903 1.55762 26.1673V43.8766C1.55762 44.1409 1.55762 44.4052 1.82193 44.6695C2.08625 44.9338 2.35057 45.1981 2.8792 45.1981H4.46511C4.99374 45.1981 5.78669 44.6695 5.78669 43.8766V38.8545C5.78669 38.3259 6.31533 37.5329 6.84396 37.5329H7.37259C7.63691 37.5329 7.90123 37.7973 8.16555 38.0616C8.42986 38.3259 8.69418 38.5902 8.69418 38.8545V41.2334C8.69418 42.555 8.9585 43.6122 9.75145 44.4052C10.5444 45.1981 11.6017 45.4625 12.9233 45.4625C13.9805 45.4625 15.3021 45.9911 16.0951 46.784L19.7955 50.4845C20.5885 51.2774 21.6457 51.8061 22.703 51.8061H42.2625C43.3197 51.8061 44.6413 51.2774 45.4343 50.2202L51.5136 43.0836C52.0422 42.555 52.3065 41.4977 52.3065 40.4404V38.8545C52.3065 38.3259 53.0995 37.5329 53.6281 37.5329H54.1567C54.4211 37.5329 54.6854 37.7973 54.9497 38.0616C55.214 38.3259 55.214 38.5902 55.214 38.8545V43.8766C55.214 44.1409 55.4783 44.4052 55.7426 44.6695C56.007 44.9338 56.2713 45.1981 56.5356 45.1981H58.3858C58.6501 45.1981 58.9144 44.9338 59.1788 44.6695C59.4431 44.4052 59.4431 44.1409 59.4431 43.8766V26.1673C59.4431 25.903 59.4431 25.6387 59.1788 25.3744C58.9144 25.11 58.6501 25.11 58.3858 25.11H56.5356C56.2713 25.11 56.007 25.11 55.7426 25.3744C55.4783 25.6387 55.214 25.903 55.214 26.1673V31.1893C55.214 31.4537 55.214 31.9823 54.9497 31.9823C54.6854 32.2466 54.4211 32.5109 54.1567 32.5109H53.6281C53.3638 32.5109 53.0995 32.2466 52.8351 31.9823C52.5708 31.9823 52.3065 31.4537 52.3065 31.1893V22.4669C52.3065 21.4096 52.0422 20.088 51.2492 19.2951C50.4563 18.5021 49.399 18.2378 48.0774 18.2378H22.9673C21.6457 18.2378 20.5885 18.5021 19.7955 19.2951L15.8307 23.2598C15.0378 24.0528 13.9805 24.5814 12.9233 24.5814C11.6017 24.5814 10.5444 24.8457 9.75145 25.6387C8.9585 26.4316 8.69418 27.7532 8.69418 28.8105V31.1893C8.69418 31.4537 8.42986 31.9823 8.16555 31.9823C7.90123 32.2466 7.63691 32.5109 7.37259 32.5109H6.84396C6.57964 32.5109 6.31533 32.2466 6.05101 31.9823C5.78669 31.9823 5.78669 31.4537 5.78669 31.1893V26.1673C5.78669 25.6387 4.99374 25.11 4.46511 25.11Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M55.4129 28.624C55.4129 29.9084 55.2295 31.0093 55.2295 32.2937L57.9818 33.3946C57.6148 35.4129 57.2478 37.2478 56.5139 39.0827L53.5781 38.5322C52.6606 40.9175 51.3762 43.1194 50.0918 44.9542L51.9267 47.523C50.6423 48.9909 49.3579 50.2753 47.89 51.7432L45.6882 49.5414C43.8533 51.1928 41.6515 52.4772 39.4496 53.3946L40.0001 56.5139C38.1652 57.0643 36.3304 57.6148 34.4955 57.9818L33.5781 55.046C32.2937 55.2295 31.1928 55.2295 29.9084 55.2295C28.8074 55.2295 27.523 55.2295 26.4221 55.046L25.3212 57.9818C23.4863 57.6148 21.6515 57.0643 19.8166 56.5139L20.3671 53.3946C18.1652 52.4772 16.1469 51.1928 14.312 49.5414L11.9267 51.7432C10.4588 50.4588 9.17441 48.9909 7.89001 47.523L9.90836 44.9542C8.44047 43.1194 7.33955 40.9175 6.42212 38.5322L3.30285 39.0827C2.75239 37.2478 2.20193 35.4129 1.83496 33.3946L4.77074 32.2937C4.58725 31.0093 4.58725 29.9084 4.58725 28.624C4.58725 13.9451 15.9634 1.83496 29.9084 1.83496C44.0368 1.83496 55.4129 13.9451 55.4129 28.624ZM53.5781 28.624C53.5781 14.8625 42.9359 3.85331 29.9084 3.85331C16.8808 3.85331 6.42212 14.8625 6.42212 28.624H17.7983C17.7983 35.5964 23.3029 41.468 29.9084 41.468C36.6973 41.468 42.2019 35.5964 42.2019 28.624H53.5781ZM29.9084 24.5873C32.1102 24.5873 33.7616 26.4221 33.7616 28.624C33.7616 30.8258 32.1102 32.6606 29.9084 32.6606C27.89 32.6606 26.0551 30.8258 26.0551 28.624C26.0551 28.0735 26.2386 27.7065 26.2386 27.3395L18.7157 17.0643L28.624 24.7707C28.9909 24.5873 29.5414 24.5873 29.9084 24.5873ZM18.5322 9.72487L20.734 13.7616L22.2019 12.6606L20.1836 8.80744L18.5322 9.72487ZM11.0093 18.1652L14.8625 20.5506L15.7799 18.8992L11.9267 16.6973L11.0093 18.1652ZM47.89 16.6973L44.2203 18.8992L45.1377 20.5506L48.8074 18.1652L47.89 16.6973ZM39.8166 8.80744L37.6148 12.6606L39.2662 13.7616L41.468 9.72487L39.8166 8.80744ZM28.9909 6.23863V10.8258H30.8258V6.23863H28.9909Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.550459"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "میان",
      pieceName: "اینجکشن",
      desc: "استفاده از موتورشور نیز همچون استفاده از مکمل‌های جرم‌گیر روش بسیار ساده‌ای دارد. پیش از تعویض روغن، مواد موتورشور را داخل موتور ریخته و پس از آن با توجه به توصیه شرکت سازنده محلول، موتور را دقایقی روشن نگه دارید (در حدود 5 الی 10 دقیقه) تا محلول به‌همراه روغن به‌تمامی بخش‌های موتور خودرو برسد. پس از طی شدن زمان موردنظر روغن خودرو را عوض کنید تا محلول موتورشور نیز به‌همراه رسوبات، از پیشرانه خودرو خارج شود.",
    },
    {
      id: 38,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.1038 44.9341L29.5752 44.1411L30.1038 44.9341Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.4251 47.313L30.8965 46.52L31.4251 47.313Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33.2754 49.4272L32.4824 48.6343L33.2754 49.4272Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.9668 43.3478V42.2905C22.9668 42.2905 22.9668 42.8192 22.9668 43.3478Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.9668 45.727V44.9341V45.727Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.4958 48.6344L23.2314 47.5771C23.2314 47.5771 23.4958 48.1058 23.4958 48.6344Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.6807 38.0615L18.2093 37.2686L17.6807 38.0615Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.3594 40.4404L16.888 39.6475L16.3594 40.4404Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.5664 43.0836L15.8307 42.0264L15.5664 43.0836Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.5664 31.1893L16.6237 30.6606C16.3594 30.925 16.095 30.925 15.5664 31.1893Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.4512 32.5111L14.2441 31.9824L13.4512 32.5111Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.3369 34.3613L12.1299 33.5684L11.3369 34.3613Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.416 24.0527H18.4733H17.416Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.7734 24.0527H15.8307C15.5664 24.0527 15.0378 24.0527 14.7734 24.0527Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.1299 24.5817L13.1872 24.3174L12.1299 24.5817Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.4385 18.7666L23.4957 19.2952L22.4385 18.7666Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.3232 17.4448L21.1162 17.9735L20.3232 17.4448Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.6807 16.6519L18.7379 16.9162C18.2093 16.9162 17.6807 16.6519 17.6807 16.6519Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28.2529 14.5376L28.7816 15.3305L28.2529 14.5376Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.4033 12.4229L27.1963 13.2158L26.4033 12.4229Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M43.8476 30.6606L43.0547 31.1893L43.8476 30.6606Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M46.2272 29.3394L45.1699 29.868C45.6986 29.6037 46.2272 29.3394 46.2272 29.3394Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.998 37.7974H41.2051H41.998Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M44.6406 37.5332L43.8477 37.7975L44.6406 37.5332Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M47.5485 37.2686H46.4912C46.4912 37.2686 47.0198 37.2686 47.5485 37.2686Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M36.9756 43.0838L36.1826 42.5552L36.9756 43.0838Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M39.3545 44.1408L38.5615 43.8765L39.3545 44.1408Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.9977 45.1984L40.9404 44.9341L41.9977 45.1984Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45.4336 26.1673C45.4336 26.4316 45.698 26.4316 45.698 26.4316H49.1341H49.3984C49.3984 26.1673 49.6627 26.1673 49.3984 25.903C47.5482 18.2378 41.2046 12.4228 33.5394 10.8369C33.2751 10.8369 33.2751 10.8369 33.0107 11.1012C33.0107 11.1012 33.0107 11.1012 33.0107 11.3655V14.5374C33.0107 14.8017 33.0107 15.066 33.2751 15.066C39.09 16.3876 43.5834 20.6166 45.4336 26.1673Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M42.5261 27.7533C42.7904 28.5463 43.0547 28.8106 43.8477 28.8106H50.9842C51.2486 28.8106 51.5129 28.8106 51.7772 28.282C52.0415 28.0176 52.3058 27.7533 52.0415 27.489C50.4556 16.9163 41.7331 8.9868 31.1605 8.19385C30.8961 8.19385 30.3675 8.45816 30.1032 8.72248C29.8389 8.9868 29.8389 9.25112 29.8389 9.51543V16.652C29.8389 17.1806 30.3675 17.7093 30.8961 17.9736C36.4468 18.2379 41.2045 22.467 42.5261 27.7533Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.7383 30.9251C18.7383 24.8458 23.7603 19.8237 29.8396 19.8237C35.9189 19.8237 40.9409 24.8458 40.9409 30.9251C40.9409 37.0043 35.9189 42.0264 29.8396 42.0264C23.7603 42.0264 18.7383 37.0043 18.7383 30.9251Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25.6104 30.9254C25.6104 28.5465 27.4606 26.6963 29.8394 26.6963C31.954 26.6963 33.8042 28.5465 33.8042 30.9254C33.8042 33.3042 31.954 35.1544 29.8394 35.1544C27.4606 35.1544 25.6104 33.3042 25.6104 30.9254Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.8391 38.326C29.8391 37.533 29.0462 37.0044 28.5175 37.0044C27.7246 37.0044 26.9316 37.533 26.9316 38.326C26.9316 39.1189 27.7246 39.6476 28.5175 39.6476C29.0462 39.6476 29.8391 39.1189 29.8391 38.326Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M37.7682 34.6255C37.7682 33.8325 37.2395 33.0396 36.4466 33.0396C35.6536 33.0396 35.125 33.8325 35.125 34.6255C35.125 35.1541 35.6536 35.947 36.4466 35.947C37.2395 35.947 37.7682 35.1541 37.7682 34.6255Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M36.7115 25.639C36.7115 24.846 36.1829 24.3174 35.3899 24.3174C34.597 24.3174 34.0684 24.846 34.0684 25.639C34.0684 26.4319 34.597 26.9606 35.3899 26.9606C36.1829 26.9606 36.7115 26.4319 36.7115 25.639Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27.9885 24.053C27.9885 23.2601 27.1956 22.7314 26.667 22.7314C25.874 22.7314 25.0811 23.2601 25.0811 24.053C25.0811 24.846 25.874 25.3746 26.667 25.3746C27.1956 25.3746 27.9885 24.846 27.9885 24.053Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.76 31.9824C23.76 31.1894 22.9671 30.3965 22.1741 30.3965C21.3812 30.3965 20.8525 31.1894 20.8525 31.9824C20.8525 32.511 21.3812 33.304 22.1741 33.304C22.9671 33.304 23.76 32.511 23.76 31.9824Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M35.918 14.5372V12.687"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M45.6982 23.5244H47.5485"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M33.0107 8.45817V8.19385"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M50.4559 28.8105C51.5131 37.5329 47.0197 45.7268 39.0902 49.4272C31.425 53.392 22.1739 52.0704 15.8303 46.2554C9.48671 40.7047 7.10786 31.4536 10.2797 23.2598C13.4515 15.3303 21.1167 10.0439 29.8391 10.0439"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M55.4129 28.624C55.4129 29.9084 55.2295 31.0093 55.2295 32.2937L57.9818 33.3946C57.6148 35.4129 57.2478 37.2478 56.5139 39.0827L53.5781 38.5322C52.6606 40.9175 51.3762 43.1194 50.0918 44.9542L51.9267 47.523C50.6423 48.9909 49.3579 50.2753 47.89 51.7432L45.6882 49.5414C43.8533 51.1928 41.6515 52.4772 39.4496 53.3946L40.0001 56.5139C38.1652 57.0643 36.3304 57.6148 34.4955 57.9818L33.5781 55.046C32.2937 55.2295 31.1928 55.2295 29.9084 55.2295C28.8074 55.2295 27.523 55.2295 26.4221 55.046L25.3212 57.9818C23.4863 57.6148 21.6515 57.0643 19.8166 56.5139L20.3671 53.3946C18.1652 52.4772 16.1469 51.1928 14.312 49.5414L11.9267 51.7432C10.4588 50.4588 9.17441 48.9909 7.89001 47.523L9.90836 44.9542C8.44047 43.1194 7.33955 40.9175 6.42212 38.5322L3.30285 39.0827C2.75239 37.2478 2.20193 35.4129 1.83496 33.3946L4.77074 32.2937C4.58725 31.0093 4.58725 29.9084 4.58725 28.624C4.58725 13.9451 15.9634 1.83496 29.9084 1.83496C44.0368 1.83496 55.4129 13.9451 55.4129 28.624ZM53.5781 28.624C53.5781 14.8625 42.9359 3.85331 29.9084 3.85331C16.8808 3.85331 6.42212 14.8625 6.42212 28.624H17.7983C17.7983 35.5964 23.3029 41.468 29.9084 41.468C36.6973 41.468 42.2019 35.5964 42.2019 28.624H53.5781ZM29.9084 24.5873C32.1102 24.5873 33.7616 26.4221 33.7616 28.624C33.7616 30.8258 32.1102 32.6606 29.9084 32.6606C27.89 32.6606 26.0551 30.8258 26.0551 28.624C26.0551 28.0735 26.2386 27.7065 26.2386 27.3395L18.7157 17.0643L28.624 24.7707C28.9909 24.5873 29.5414 24.5873 29.9084 24.5873ZM18.5322 9.72487L20.734 13.7616L22.2019 12.6606L20.1836 8.80744L18.5322 9.72487ZM11.0093 18.1652L14.8625 20.5506L15.7799 18.8992L11.9267 16.6973L11.0093 18.1652ZM47.89 16.6973L44.2203 18.8992L45.1377 20.5506L48.8074 18.1652L47.89 16.6973ZM39.8166 8.80744L37.6148 12.6606L39.2662 13.7616L41.468 9.72487L39.8166 8.80744ZM28.9909 6.23863V10.8258H30.8258V6.23863H28.9909Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.550459"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "میان",
      pieceName: "لنت ترمز",
      desc: "لنت ترمز بخشی از سامانهٔ ترمز دیسکی است که در خودروها و برخی صنایع دیگر کاربرد دارند. لنت‌های ترمز از صفحه‌های فولادی در پشت و مواد اصطکاکی متصل‌شده به سطح صفحهٔ فلزی، که در مقابل دیسک چرخندهٔ ترمز قرار می‌گیرد، تشکیل شده‌اند.",
    },
    {
      id: 39,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M38.1361 29.1818C38.6816 33 36.227 36.5455 32.4088 37.3636C32.1361 37.6364 32.1361 37.6364 31.8634 37.9091L31.3179 40.9091C31.0452 41.1818 30.7725 41.4545 30.4997 41.4545C29.9543 41.4545 29.6816 41.1818 29.6816 40.9091L28.8634 37.9091C28.8634 37.6364 28.5907 37.6364 28.3179 37.3636C24.7725 36.5455 22.3179 33 22.5907 29.1818C22.5907 28.9091 22.5907 28.9091 22.5907 28.9091C22.5907 28.6364 22.3179 28.6364 22.3179 28.6364H16.3179C15.227 28.6364 14.4088 28.0909 13.8634 27.5455C13.3179 26.7273 13.0452 25.6364 13.3179 24.5455C15.7725 17.1818 22.5907 12 30.4997 12C38.4088 12 45.227 17.1818 47.6816 24.5455C47.9543 25.6364 47.6816 26.7273 47.1361 27.5455C46.5907 28.0909 45.4997 28.6364 44.4088 28.6364H38.6816C38.4088 28.6364 38.4088 28.6364 38.4088 28.9091C38.1361 28.9091 38.1361 28.9091 38.1361 29.1818Z"
            stroke="#FEC42B"
            stroke-width="1.36364"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M52.045 30C52.045 18 42.4996 8.45459 30.4996 8.45459C18.4996 8.45459 8.9541 18 8.9541 30C8.9541 42 18.4996 51.5455 30.4996 51.5455C42.4996 51.5455 52.045 42 52.045 30Z"
            stroke="#FEC42B"
            stroke-width="1.36364"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M36.2272 25.9092C35.9544 24.5456 34.8635 22.3638 34.3181 21.8183H33.7726C32.6817 22.9092 31.8635 25.091 31.5908 25.9092C31.0453 29.7274 37.0453 29.7274 36.2272 25.9092Z"
            stroke="#FEC42B"
            stroke-width="1.36364"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M29.9546 21.8183C28.0455 24.0001 26.4091 28.091 26.1364 29.4547C25.0455 36.5456 35.9546 36.5456 34.5909 29.4547C34.5909 29.182 34.5909 28.9092 34.5909 28.6365C32.9546 28.9092 31.3182 28.091 31.5909 25.9092C31.8637 25.6365 32.1364 24.8183 32.4091 24.0001C31.8637 23.182 31.3182 22.3638 31.0455 21.8183C30.5 21.5456 30.2273 21.5456 29.9546 21.8183Z"
            stroke="#FEC42B"
            stroke-width="1.36364"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M27.4995 47.4547L24.4995 36.5456C24.2267 35.182 22.8631 34.3638 21.4995 34.3638H17.6813C16.5904 34.3638 15.4995 34.9092 14.954 35.7274C14.4086 36.8183 14.4086 37.9092 14.954 39.0001C18.2267 44.4547 23.954 48.0001 30.4995 48.0001C36.7722 48.0001 42.7722 44.4547 45.7722 39.0001C46.5904 37.9092 46.5904 36.8183 46.0449 35.7274C45.2267 34.9092 44.4086 34.3638 43.0449 34.3638H39.4995C37.8631 34.3638 36.7722 35.182 36.2267 36.5456L33.4995 47.4547"
            stroke="#FEC42B"
            stroke-width="1.36364"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M55.4129 28.624C55.4129 29.9084 55.2295 31.0093 55.2295 32.2937L57.9818 33.3946C57.6148 35.4129 57.2478 37.2478 56.5139 39.0827L53.5781 38.5322C52.6606 40.9175 51.3762 43.1194 50.0918 44.9542L51.9267 47.523C50.6423 48.9909 49.3579 50.2753 47.89 51.7432L45.6882 49.5414C43.8533 51.1928 41.6515 52.4772 39.4496 53.3946L40.0001 56.5139C38.1652 57.0643 36.3304 57.6148 34.4955 57.9818L33.5781 55.046C32.2937 55.2295 31.1928 55.2295 29.9084 55.2295C28.8074 55.2295 27.523 55.2295 26.4221 55.046L25.3212 57.9818C23.4863 57.6148 21.6515 57.0643 19.8166 56.5139L20.3671 53.3946C18.1652 52.4772 16.1469 51.1928 14.312 49.5414L11.9267 51.7432C10.4588 50.4588 9.17441 48.9909 7.89001 47.523L9.90836 44.9542C8.44047 43.1194 7.33955 40.9175 6.42212 38.5322L3.30285 39.0827C2.75239 37.2478 2.20193 35.4129 1.83496 33.3946L4.77074 32.2937C4.58725 31.0093 4.58725 29.9084 4.58725 28.624C4.58725 13.9451 15.9634 1.83496 29.9084 1.83496C44.0368 1.83496 55.4129 13.9451 55.4129 28.624ZM53.5781 28.624C53.5781 14.8625 42.9359 3.85331 29.9084 3.85331C16.8808 3.85331 6.42212 14.8625 6.42212 28.624H17.7983C17.7983 35.5964 23.3029 41.468 29.9084 41.468C36.6973 41.468 42.2019 35.5964 42.2019 28.624H53.5781ZM29.9084 24.5873C32.1102 24.5873 33.7616 26.4221 33.7616 28.624C33.7616 30.8258 32.1102 32.6606 29.9084 32.6606C27.89 32.6606 26.0551 30.8258 26.0551 28.624C26.0551 28.0735 26.2386 27.7065 26.2386 27.3395L18.7157 17.0643L28.624 24.7707C28.9909 24.5873 29.5414 24.5873 29.9084 24.5873ZM18.5322 9.72487L20.734 13.7616L22.2019 12.6606L20.1836 8.80744L18.5322 9.72487ZM11.0093 18.1652L14.8625 20.5506L15.7799 18.8992L11.9267 16.6973L11.0093 18.1652ZM47.89 16.6973L44.2203 18.8992L45.1377 20.5506L48.8074 18.1652L47.89 16.6973ZM39.8166 8.80744L37.6148 12.6606L39.2662 13.7616L41.468 9.72487L39.8166 8.80744ZM28.9909 6.23863V10.8258H30.8258V6.23863H28.9909Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.550459"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "میان",
      pieceName: "هیدرولیک",
      desc: "سیستم فرمان برقی هیدرولیک یک سیستم حلقه بسته است که از مایعات هیدرولیک (روغن هیدرولیک) تحت فشار برای تغییر زاویه چرخ های جلو بر اساس زاویه فرمان استفاده می کند. این سیستم شامل یک پمپ هیدرولیک است که توسط کمربند، سوپاپ ها، سیلندر، مخزن و یک مکانیزم کنترل شونده توسط راننده (جعبه دنده شامل چرخ دنده ها و فرمان) هدایت می شود.",
    },
    {
      id: 40,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_70)">
            <path
              d="M40.1273 26.5117H26.1738"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M26.1744 26.5117L25.0581 26.7908C24.7791 27.3489 24.5 27.628 24.5 28.1861"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M24.5 28.186V45.2093"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M24.5 45.2095L25.0581 46.3257L26.1744 46.8839"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M26.1738 46.8838H40.1273"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M40.127 46.8839C40.6851 46.8839 41.5223 46.3257 41.5223 46.3257L41.8014 45.2095"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M41.8018 45.2093V28.186"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M41.8014 28.1861C41.8014 27.628 41.8014 27.3489 41.5223 26.7908C41.5223 26.7908 40.6851 26.5117 40.127 26.5117"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M15.0113 18.9766H14.4531"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M15.0113 17.3022H14.4531"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M21.7088 18.9766H21.4297"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M21.7088 17.3022H21.4297"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M35.6626 18.9766H35.1045"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M43.4759 18.9766H42.6387"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M35.6626 17.3022H35.1045"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M43.4759 17.3022H42.6387"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M31.4761 18.9766H30.918"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M31.4761 17.3022H30.918"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M13.6162 28.1861L13.8953 26.5117"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M13.8945 26.5115L14.1736 26.2324H14.7317"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M14.7324 26.2324L16.965 30.1394"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M16.9646 30.4185H16.6855"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M13.6162 28.1861L14.1744 27.6279"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M14.1738 27.6277L14.732 27.3486L15.011 27.6277"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M15.0107 27.6279L16.6852 30.4186"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M27.2906 42.6978C27.2906 43.2559 27.0116 43.535 27.0116 43.535H26.1743C26.1743 43.535 25.6162 43.2559 25.6162 42.6978"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M27.29 42.6976V28.7441"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M25.6162 28.7441V42.6976"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M27.2906 28.7439C27.2906 28.1858 27.0116 27.9067 26.4534 27.9067C25.8953 27.9067 25.6162 28.1858 25.6162 28.7439"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M44.3135 15.6279L52.4065 17.3023"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M52.4062 17.3022L52.6853 17.8604"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M52.6855 17.8604V18.4185"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M52.6853 18.4185L52.4062 18.9766"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M52.4065 18.9766L44.3135 20.651"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M43.4766 20.6509V21.209H43.7556"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M43.7549 21.209L44.313 20.6509"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M43.4766 15.628V15.3489L43.7556 15.0698"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M43.7549 15.0698L44.313 15.3489V15.628"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M43.4766 15.6279V20.6512"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M44.3135 20.6512V15.6279"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M23.6621 25.6744V24.5581"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M23.6621 24.5582C23.6621 24.0001 24.2203 23.4419 24.2203 23.4419C24.4993 22.8838 24.7784 22.8838 25.3365 22.8838"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M25.3369 22.8838H41.2439"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M41.2441 22.8838C41.8023 22.8838 42.0814 22.8838 42.3604 23.4419C42.3604 23.4419 42.9186 24.0001 42.9186 24.5582"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M42.918 24.5581V25.6744"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M22.5459 20.0928H30.0808"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M30.0811 20.0931C30.6392 20.0931 30.9183 19.814 30.9183 19.2559"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M30.918 19.2555V17.0229"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M30.9183 17.0232L30.6392 16.4651L30.0811 16.186"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M30.0808 16.186H22.5459"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M22.5462 16.186L21.9881 16.4651L21.709 17.0232"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M21.709 17.0229V19.2555"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M21.709 19.2559L21.9881 19.814L22.5462 20.0931"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M35.6621 19.2555V17.0229"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M35.6621 17.0232L35.9412 16.4651L36.4993 16.186"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M36.5 16.186H41.8023"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M41.8018 16.186L42.3599 16.4651L42.639 17.0232"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M42.6387 17.0229V19.2555"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M42.639 19.2559L42.3599 19.814L41.8018 20.0931"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M41.8023 20.0928H36.5"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M36.4993 20.0931C35.9412 20.0931 35.6621 19.814 35.6621 19.2559"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M12.2207 34.8835L13.337 24.2788"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M13.3369 24.2791C13.3369 23.721 13.8951 23.4419 13.8951 23.4419"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M13.8945 23.4417C13.8945 23.4417 14.4527 23.1626 14.4527 22.6045"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M14.4531 22.6043V17.0229"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M14.4534 17.0232L14.1744 16.4651L13.6162 16.186"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M13.616 16.186H9.70898"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M9.70883 16.186L8.59255 16.7442L8.31348 17.8605"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M8.31348 17.8604V34.8836"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M8.31348 34.8838L8.59255 36.0001L9.70883 36.5582"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M9.70898 36.5581H10.5462"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M10.5459 36.5582C11.3831 36.5582 11.9412 35.721 12.2203 34.8838"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M19.7555 24.558H18.0811V14.7905H19.7555"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M19.7549 14.7905C20.313 14.7905 20.5921 14.7905 20.8712 15.3487C20.8712 15.3487 21.4293 15.9068 21.4293 16.4649"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M21.4297 16.4648V22.8834"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M21.4293 22.8838C21.4293 23.4419 20.8712 24.0001 20.8712 24.0001C20.8712 24.0001 20.313 24.5582 19.7549 24.5582"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M15.0107 22.8834V16.4648"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M15.0107 16.4649C15.0107 15.9068 15.5689 15.3487 15.5689 15.3487C15.848 14.7905 16.127 14.7905 16.6852 14.7905"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M16.6855 14.7905H18.0809V24.558H16.6855"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M16.6852 24.5582C15.848 24.5582 15.0107 23.721 15.0107 22.8838"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M31.4766 22.3257H35.1045"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M35.1045 22.3254V14.7905"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M31.4766 22.3254V14.7905"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M23.6621 25.6743H42.9179"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M31.4766 14.7906L32.0347 13.6744L33.151 13.1162"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M33.1504 13.1162C33.7085 13.1162 34.5457 13.6744 34.5457 13.6744L35.1039 14.7906"
              stroke="#FEC42B"
              stroke-width="1.39535"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_70">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M55.4129 28.624C55.4129 29.9084 55.2295 31.0093 55.2295 32.2937L57.9818 33.3946C57.6148 35.4129 57.2478 37.2478 56.5139 39.0827L53.5781 38.5322C52.6606 40.9175 51.3762 43.1194 50.0918 44.9542L51.9267 47.523C50.6423 48.9909 49.3579 50.2753 47.89 51.7432L45.6882 49.5414C43.8533 51.1928 41.6515 52.4772 39.4496 53.3946L40.0001 56.5139C38.1652 57.0643 36.3304 57.6148 34.4955 57.9818L33.5781 55.046C32.2937 55.2295 31.1928 55.2295 29.9084 55.2295C28.8074 55.2295 27.523 55.2295 26.4221 55.046L25.3212 57.9818C23.4863 57.6148 21.6515 57.0643 19.8166 56.5139L20.3671 53.3946C18.1652 52.4772 16.1469 51.1928 14.312 49.5414L11.9267 51.7432C10.4588 50.4588 9.17441 48.9909 7.89001 47.523L9.90836 44.9542C8.44047 43.1194 7.33955 40.9175 6.42212 38.5322L3.30285 39.0827C2.75239 37.2478 2.20193 35.4129 1.83496 33.3946L4.77074 32.2937C4.58725 31.0093 4.58725 29.9084 4.58725 28.624C4.58725 13.9451 15.9634 1.83496 29.9084 1.83496C44.0368 1.83496 55.4129 13.9451 55.4129 28.624ZM53.5781 28.624C53.5781 14.8625 42.9359 3.85331 29.9084 3.85331C16.8808 3.85331 6.42212 14.8625 6.42212 28.624H17.7983C17.7983 35.5964 23.3029 41.468 29.9084 41.468C36.6973 41.468 42.2019 35.5964 42.2019 28.624H53.5781ZM29.9084 24.5873C32.1102 24.5873 33.7616 26.4221 33.7616 28.624C33.7616 30.8258 32.1102 32.6606 29.9084 32.6606C27.89 32.6606 26.0551 30.8258 26.0551 28.624C26.0551 28.0735 26.2386 27.7065 26.2386 27.3395L18.7157 17.0643L28.624 24.7707C28.9909 24.5873 29.5414 24.5873 29.9084 24.5873ZM18.5322 9.72487L20.734 13.7616L22.2019 12.6606L20.1836 8.80744L18.5322 9.72487ZM11.0093 18.1652L14.8625 20.5506L15.7799 18.8992L11.9267 16.6973L11.0093 18.1652ZM47.89 16.6973L44.2203 18.8992L45.1377 20.5506L48.8074 18.1652L47.89 16.6973ZM39.8166 8.80744L37.6148 12.6606L39.2662 13.7616L41.468 9.72487L39.8166 8.80744ZM28.9909 6.23863V10.8258H30.8258V6.23863H28.9909Z"
            fill="#F5F5F5"
            stroke="#F5F5F5"
            stroke-width="0.550459"
            stroke-miterlimit="2.61313"
          />
        </svg>
      ),
      categoryName: "میان",
      pieceName: "موتورشویی",
      desc: "تمیز بودن موتور خودرو لاعث کاهش مصرف سوخت و افزایش طول عمر قطعات می شود یکی از بهترین روش ها برای موتورشویی استفاده از بخار است که چربی ها و کثیفی هارا به طور کامل از سطح موتور خودرو می زداید .",
    },
    {
      id: 41,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_313)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.7681 46.8753C15.7681 45.8039 14.9646 44.7324 13.6253 44.7324C12.286 44.7324 11.4824 45.8039 11.4824 46.8753C11.4824 48.2146 12.286 49.0181 13.6253 49.0181C14.9646 49.0181 15.7681 48.2146 15.7681 46.8753Z"
              stroke="#FEC42B"
              stroke-width="1.60714"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M50.3216 12.3216C50.3216 11.2501 49.518 10.1787 48.4466 10.1787C47.3751 10.1787 46.3037 11.2501 46.3037 12.3216C46.3037 13.393 47.3751 14.1966 48.4466 14.1966C49.518 14.1966 50.3216 13.393 50.3216 12.3216Z"
              stroke="#FEC42B"
              stroke-width="1.60714"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.3933 45.8039L18.4468 46.3396C18.7147 48.2146 17.6433 50.3575 15.7683 51.1611C13.8933 52.2325 11.7504 51.6968 10.1433 50.3575C8.80399 48.7503 8.53613 46.6075 9.3397 44.7325C10.1433 42.8575 12.2861 41.7861 14.1611 42.0539L14.6968 39.1075C14.6968 38.8396 14.6968 38.5718 14.9647 38.5718L16.304 37.2325C16.5718 36.9646 16.8397 36.6968 17.1076 36.6968C17.6433 36.6968 17.9111 36.9646 18.179 37.2325L23.2683 42.3218C23.5361 42.5896 23.804 43.1254 23.804 43.3932C23.804 43.6611 23.5361 43.9289 23.2683 44.1968L21.929 45.5361C21.929 45.8039 21.6611 45.8039 21.3933 45.8039Z"
              stroke="#FEC42B"
              stroke-width="1.60714"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M45.768 21.9644C46.5716 24.3751 45.5002 23.8394 44.1609 23.0358C42.8216 22.5001 41.2145 21.4287 39.8752 20.3572C38.268 19.2858 36.9287 18.2144 35.8573 17.4108C34.7859 16.8751 33.7145 16.8751 33.7145 16.8751C33.7145 16.8751 33.7145 17.6787 34.2502 19.018C35.0537 20.0894 36.1252 21.6965 36.9287 23.3037C38.0002 24.643 39.0716 26.2501 39.6073 27.3215C40.4109 28.6608 40.4109 29.4644 40.4109 29.4644C40.4109 29.4644 39.3395 29.4644 38.268 28.9287C37.1966 28.1251 35.5895 27.0537 34.2502 25.9822C32.643 24.9108 31.3037 24.1072 30.2323 23.3037C28.893 22.768 28.0895 22.5001 28.0895 22.5001C28.0895 22.5001 28.0895 23.5715 28.6252 24.643C29.4287 25.9822 30.5002 27.5894 31.3037 28.9287C32.3752 30.5358 33.4466 32.143 33.9823 33.2144C34.7859 34.2858 34.7859 35.3572 34.7859 35.3572C34.7859 35.3572 33.7145 35.3572 32.643 34.8215C31.5716 34.018 29.9645 32.9465 28.6252 31.8751C28.0895 31.6072 27.8216 31.3394 27.2859 31.0715C26.2145 30.268 25.4109 29.7322 24.6073 29.1965C23.268 28.393 22.4645 28.393 22.4645 28.393C22.4645 28.393 22.4645 29.4644 23.0002 30.5358"
              stroke="#FEC42B"
              stroke-width="1.60714"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M27.2859 43.1251C27.018 43.393 26.7501 43.393 26.4823 43.393C25.9466 43.393 25.6787 43.393 25.4109 43.1251L17.643 35.0894C17.1073 34.5537 17.1073 33.7501 17.643 33.2144L19.518 31.0716C19.7859 30.8037 20.3216 30.8037 20.5894 30.8037C20.8573 30.8037 21.1251 30.8037 21.393 31.0716L22.1966 31.8751C22.4644 32.143 22.7323 32.143 23.0001 32.143C23.5359 32.143 23.8037 32.143 24.0716 31.8751L41.2144 14.7323C41.4823 14.4644 41.7501 14.4644 42.018 14.4644L42.8216 14.1966C43.0894 14.1966 43.3573 14.1966 43.6251 13.9287L44.1609 13.393C44.4287 13.1251 44.4287 12.8573 44.4287 12.5894C44.4287 10.9823 45.2323 9.37514 46.8394 8.57157C48.1787 8.03585 50.0537 8.30371 51.1251 9.37514C52.1966 10.7144 52.4644 12.3216 51.9287 13.9287C51.1251 15.268 49.7859 16.0716 48.1787 16.0716C47.643 16.0716 47.3751 16.0716 47.1073 16.3394L46.5716 16.8751C46.3037 17.143 46.3037 17.4109 46.3037 17.6787V18.4823C46.3037 18.7501 46.0359 19.2859 45.768 19.2859L28.6251 36.4287C28.3573 36.6966 28.3573 37.2323 28.3573 37.5001C28.3573 37.768 28.3573 38.0359 28.6251 38.3037L29.4287 39.1073C29.6966 39.3751 29.6966 39.643 29.6966 39.9109C29.6966 40.4466 29.6966 40.7144 29.4287 40.9823L27.2859 43.1251Z"
              stroke="#FEC42B"
              stroke-width="1.60714"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_313">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_265_470)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.3125 1.875C46.125 1.875 58.125 13.875 58.125 28.6875C58.125 43.3125 46.125 55.3125 31.3125 55.3125C30.1875 55.3125 28.875 55.3125 27.75 55.125L26.625 58.125C24.5625 57.75 22.6875 57.1875 20.8125 56.625L21.375 53.4375C18.9375 52.5 16.875 51.1875 15 49.6875L12.5625 51.75C11.0625 50.4375 9.5625 49.125 8.25 47.4375L10.3125 45C8.8125 43.125 7.5 41.0625 6.5625 38.625L3.375 39.1875C2.8125 37.3125 2.25 35.4375 1.875 33.375L4.875 32.25C4.6875 31.125 4.6875 29.8125 4.6875 28.6875C4.6875 13.875 16.6875 1.875 31.3125 1.875ZM31.3125 53.4375C45 53.4375 56.25 42.375 56.25 28.6875C56.25 15 45 3.75 31.3125 3.75C17.625 3.75 6.5625 15 6.5625 28.6875H18.5625C18.5625 35.625 24.375 41.4375 31.3125 41.4375V53.4375ZM43.3125 47.4375L41.0625 43.5L39.375 44.4375L41.8125 48.5625L43.3125 47.4375ZM51.1875 39L47.25 36.75L46.3125 38.4375L50.25 40.6875L51.1875 39ZM53.8125 27.75H49.125V29.625H53.8125V27.75ZM50.25 16.6875L46.3125 18.9375L47.25 20.625L51.1875 18.1875L50.25 16.6875ZM41.8125 8.8125L39.375 12.75L41.0625 13.6875L43.3125 9.75L41.8125 8.8125ZM30.375 6.1875V10.875H32.25V6.1875H30.375ZM11.625 18.1875L15.5625 20.625L16.5 18.9375L12.5625 16.6875L11.625 18.1875ZM19.3125 9.75L21.5625 13.5L23.25 12.5625L21 8.8125L19.3125 9.75ZM31.3125 24.5625C33.5625 24.5625 35.4375 26.4375 35.4375 28.6875C35.4375 30.9375 33.5625 32.625 31.3125 32.625C29.0625 32.625 27.375 30.9375 27.375 28.6875C27.375 28.125 27.375 27.75 27.5625 27.375L19.6875 17.0625L30 24.75C30.375 24.75 30.9375 24.5625 31.3125 24.5625Z"
              fill="#F5F5F5"
              stroke="#F5F5F5"
              stroke-width="0.5625"
              stroke-miterlimit="2.61313"
            />
          </g>
          <defs>
            <clipPath id="clip0_265_470">
              <rect width="60" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      categoryName: "بلند",
      pieceName: "تعلیق",
      desc: "سامانه تعلیق یا فنربندی  بخشی از خودرو است که باعث می‌شود نوسانات حاصل از حرکت خودرو بر روی سطوح ناهموار به جِرم معلق که شامل اتاق، شاسی، متعلقات و سرنشینان وارد نشود.",
    },
    {
      id: 42,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_437)">
            <path
              d="M29.8027 39.9069L30.3608 37.6743H29.2445L28.6864 39.9069H29.8027ZM10.5469 29.8603C10.5469 24.558 12.7794 19.5348 16.4073 15.9069C20.0352 12.2789 25.0585 10.0464 30.3608 10.0464C35.9422 10.0464 40.9655 12.2789 44.5934 15.9069C48.2213 19.5348 50.4539 24.558 50.4539 29.8603C50.4539 35.4417 48.2213 40.465 44.5934 44.0929C40.9655 47.7208 35.9422 49.9534 30.3608 49.9534C25.0585 49.9534 20.0352 47.7208 16.4073 44.0929C12.7794 40.465 10.5469 35.4417 10.5469 29.8603H11.105C11.105 34.8836 13.0585 39.3487 16.1283 42.6975L21.9887 38.5115C20.0352 36.2789 18.6399 33.7673 18.6399 30.6975L11.3841 29.3022C11.3841 29.5813 11.105 29.8603 11.105 29.8603H10.5469ZM16.4073 42.9766C16.6864 43.2557 16.6864 43.2557 16.9655 43.5348C20.0352 46.6045 24.5004 48.8371 29.2445 49.1162L30.6399 41.8603H30.3608C27.5701 41.8603 24.7794 40.7441 22.5469 39.0696L16.4073 42.9766ZM29.8027 49.1162C30.0818 49.1162 30.3608 49.1162 30.3608 49.1162C35.3841 49.1162 39.8492 47.4417 43.198 44.372L39.012 38.2324V38.5115C36.7794 40.465 34.2678 41.5813 31.198 41.8603L29.8027 49.1162ZM43.4771 43.8138C43.7562 43.8138 43.7562 43.5348 44.0352 43.5348C47.105 40.465 49.3376 35.9999 49.6166 31.2557L42.3608 29.8603C42.3608 32.9301 41.2445 35.7208 39.5701 37.6743L43.4771 43.8138ZM49.6166 30.4185C49.6166 30.4185 49.6166 30.1394 49.6166 29.8603C49.6166 25.1162 47.9422 20.651 44.8725 17.3022L38.7329 21.4882H39.012C40.9655 23.4417 42.0818 26.2324 42.3608 29.0231L49.6166 30.4185ZM44.3143 16.7441L44.0352 16.465C40.9655 13.1162 36.5004 11.1627 31.7562 10.8836L30.3608 18.1394C33.4306 18.1394 36.2213 18.9766 38.1748 20.9301L44.3143 16.7441ZM30.919 10.8836C30.919 10.8836 30.6399 10.6045 30.3608 10.6045C25.6166 10.6045 21.1515 12.558 17.8027 15.6278L21.9887 21.4882C23.9422 19.5348 26.7329 18.1394 29.5236 18.1394L30.919 10.8836ZM17.2445 15.9069C17.2445 16.1859 16.9655 16.1859 16.9655 16.465C13.6166 19.5348 11.6632 23.9999 11.3841 28.7441L18.6399 30.1394V29.8603C18.6399 27.0696 19.4771 24.2789 21.4306 22.0464L17.2445 15.9069ZM22.5469 22.0464C20.3143 23.9999 19.198 26.7906 19.198 29.8603C19.198 32.9301 20.3143 35.9999 22.5469 37.9534C24.5004 39.9069 27.2911 41.3022 30.3608 41.3022C33.4306 41.3022 36.5004 39.9069 38.4539 37.9534C40.4073 35.9999 41.8027 32.9301 41.8027 29.8603C41.8027 26.7906 40.4073 23.9999 38.4539 22.0464C36.5004 19.8138 33.4306 18.6976 30.3608 18.6976C27.2911 18.6976 24.5004 19.8138 22.5469 22.0464ZM23.3841 29.3022C23.6632 27.6278 24.5004 26.2324 25.6166 24.8371C26.4539 23.9999 27.8492 23.1627 29.5236 22.8836H28.1283C27.8492 22.8836 27.5701 22.8836 27.5701 22.8836C27.2911 22.8836 27.2911 22.6045 27.012 22.6045C27.012 22.3255 26.7329 22.3255 26.7329 22.0464C26.7329 21.7673 26.7329 21.7673 26.7329 21.4882V20.651C26.7329 20.372 26.7329 20.372 26.7329 20.0929C26.7329 19.8138 27.012 19.8138 27.012 19.5348C27.2911 19.5348 27.2911 19.5348 27.5701 19.2557C27.5701 19.2557 27.8492 19.2557 28.1283 19.2557H32.8725C33.1515 19.2557 33.1515 19.2557 33.4306 19.2557C33.7097 19.5348 33.7097 19.5348 33.9887 19.5348C33.9887 19.8138 34.2678 19.8138 34.2678 20.0929C34.2678 20.372 34.2678 20.372 34.2678 20.651V21.4882C34.2678 22.0464 34.2678 22.3255 33.9887 22.6045C33.7097 22.8836 33.1515 22.8836 32.8725 22.8836H31.4771C32.8725 23.1627 34.2678 23.9999 35.3841 24.8371C36.5004 26.2324 37.3376 27.9069 37.3376 29.8603C37.3376 31.8138 36.5004 33.4882 35.3841 34.8836C33.9887 35.9999 32.3143 36.8371 30.3608 36.8371C28.4073 36.8371 26.7329 35.9999 25.6166 34.8836C24.5004 33.7673 23.6632 32.0929 23.3841 30.4185V32.372C23.3841 32.651 23.3841 33.2092 23.105 33.4882C22.8259 33.4882 22.5469 33.7673 21.9887 33.7673H21.1515C20.8725 33.7673 20.8725 33.7673 20.5934 33.7673C20.3143 33.4882 20.3143 33.4882 20.0352 33.4882C20.0352 33.2092 20.0352 32.9301 19.7562 32.9301C19.7562 32.651 19.7562 32.372 19.7562 32.372V27.6278C19.7562 27.3487 19.7562 27.0696 19.7562 27.0696C20.0352 26.7906 20.0352 26.5115 20.0352 26.5115C20.3143 26.2324 20.3143 26.2324 20.5934 26.2324C20.8725 25.9534 20.8725 25.9534 21.1515 25.9534H21.9887C22.2678 25.9534 22.2678 25.9534 22.5469 26.2324C22.8259 26.2324 22.8259 26.2324 23.105 26.5115C23.105 26.5115 23.3841 26.7906 23.3841 27.0696C23.3841 27.0696 23.3841 27.3487 23.3841 27.6278V29.3022ZM25.8957 25.3952C24.7794 26.5115 24.2213 28.1859 24.2213 29.8603C24.2213 31.5348 24.7794 33.2092 25.8957 34.3255C27.012 35.4417 28.6864 36.2789 30.3608 36.2789C32.3143 36.2789 33.7097 35.4417 34.8259 34.3255C35.9422 33.2092 36.7794 31.5348 36.7794 29.8603C36.7794 28.1859 35.9422 26.5115 34.8259 25.3952C33.7097 24.2789 32.3143 23.7208 30.3608 23.7208C28.6864 23.7208 27.012 24.2789 25.8957 25.3952ZM30.3608 27.6278C30.919 27.6278 31.4771 27.6278 31.7562 27.9069C32.0352 28.1859 32.3143 28.465 32.5934 28.7441C32.8725 29.3022 32.8725 29.5813 32.8725 30.1394C32.8725 30.4185 32.8725 30.9766 32.5934 31.2557C32.3143 31.5348 32.0352 32.0929 31.7562 32.0929C31.4771 32.372 30.919 32.651 30.3608 32.651C29.8027 32.651 29.2446 32.372 28.6864 31.8138C28.1283 31.2557 27.8492 30.6976 27.8492 30.1394C27.8492 29.3022 28.1283 28.7441 28.6864 28.1859C29.2446 27.9069 29.8027 27.6278 30.3608 27.6278ZM31.4771 28.465C31.198 28.1859 30.919 28.1859 30.3608 28.1859C30.0818 28.1859 29.5236 28.465 29.2445 28.7441C28.9655 29.0231 28.6864 29.5813 28.6864 30.1394C28.6864 30.4185 28.9655 30.9766 29.2445 31.2557C29.5236 31.5348 30.0818 31.8138 30.3608 31.8138C30.919 31.8138 31.198 31.8138 31.4771 31.5348C31.7562 31.5348 31.7562 31.2557 32.0352 30.9766C32.3143 30.6976 32.3143 30.4185 32.3143 30.1394C32.3143 29.5813 32.3143 29.3022 32.0352 29.0231C31.7562 28.7441 31.7562 28.7441 31.4771 28.465ZM25.8957 29.5813L25.6166 29.3022C25.6166 29.0231 25.6166 29.0231 25.6166 28.7441C25.6166 28.465 25.8957 28.465 25.8957 28.1859L26.1748 27.9069H26.4539V27.6278C26.4539 27.6278 26.4539 27.6278 26.7329 27.3487L26.4539 27.0696C26.7329 26.7906 26.7329 26.5115 27.012 26.5115L27.2911 26.2324H27.8492C27.8492 26.2324 28.1283 26.2324 28.1283 25.9534H28.4073V25.6743L28.6864 25.3952C28.6864 25.3952 28.9655 25.3952 29.2445 25.1162C29.2445 25.1162 29.5236 25.1162 29.8027 25.1162L30.0818 25.3952H30.3608H30.919L31.198 25.1162C31.4771 25.1162 31.4771 25.1162 31.7562 25.1162C32.0352 25.3952 32.0352 25.3952 32.3143 25.3952L32.5934 25.6743V25.9534L33.1515 26.2324H33.4306C33.7097 26.2324 33.9887 26.5115 33.9887 26.5115C34.2678 26.5115 34.2678 26.7906 34.2678 27.0696L34.5469 27.6278C34.5469 27.9069 34.5469 27.9069 34.5469 27.9069H34.8259L35.105 28.1859C35.105 28.465 35.105 28.465 35.3841 28.7441C35.3841 29.0231 35.3841 29.0231 35.3841 29.3022L35.105 29.5813C35.105 29.8603 35.105 29.8603 35.105 30.1394L35.3841 30.6975C35.3841 30.9766 35.3841 31.2557 35.3841 31.2557C35.105 31.5348 35.105 31.8138 35.105 31.8138L34.8259 32.0929H34.5469C34.2678 32.0929 34.2678 32.651 34.2678 32.651V33.2092C34.2678 33.2092 34.2678 33.4882 33.9887 33.4882C33.9887 33.7673 33.7097 33.7673 33.4306 34.0464H33.1515V33.7673L32.8725 34.0464L32.5934 34.3255L32.3143 34.6045C32.0352 34.6045 32.0352 34.8836 31.7562 34.8836C31.4771 34.8836 31.4771 34.8836 31.198 34.8836H30.919V34.6045H30.3608H30.0818V34.8836H29.8027C29.5236 34.8836 29.2445 34.8836 29.2445 34.8836C28.9655 34.8836 28.6864 34.8836 28.6864 34.6045L28.4073 34.3255V34.0464H28.1283L27.8492 33.7673V34.0464H27.2911C27.2911 33.7673 27.012 33.7673 27.012 33.4882C26.7329 33.4882 26.7329 33.2092 26.4539 33.2092V32.651V32.372L26.1748 32.0929L25.8957 31.8138C25.8957 31.8138 25.6166 31.5348 25.6166 31.2557C25.6166 31.2557 25.6166 30.9766 25.6166 30.6975V30.4185C25.6166 30.1394 25.8957 30.1394 25.8957 30.1394C25.8957 29.8603 25.8957 29.8603 25.8957 29.5813ZM26.1748 29.0231L26.4539 29.3022V29.5813C26.4539 29.5813 26.4539 29.8603 26.4539 30.1394V30.9766H26.1748V31.2557H26.4539L26.7329 31.5348C27.012 31.8138 27.012 31.8138 27.012 32.0929L27.2911 32.372V32.9301V33.2092H27.5701H28.1283L28.4073 33.4882C28.6864 33.4882 28.6864 33.4882 28.9655 33.7673L29.2445 34.0464V34.3255H29.5236V34.0464H30.0818H30.3608H30.6399H31.198L31.4771 34.3255L31.7562 34.0464L32.0352 33.7673C32.0352 33.4882 32.3143 33.4882 32.3143 33.4882C32.5934 33.4882 32.5934 33.2092 32.8725 33.2092H33.1515H33.4306L33.7097 32.9301V32.372C33.7097 32.372 33.7097 32.0929 33.9887 32.0929C33.9887 31.8138 33.9887 31.8138 33.9887 31.5348L34.5469 31.2557L34.8259 30.9766H34.5469L34.2678 30.4185L34.5469 30.1394C34.5469 29.8603 34.2678 29.5813 34.2678 29.5813L34.5469 29.3022V28.7441L33.9887 28.465C33.7097 28.1859 33.7097 27.9069 33.7097 27.6278V27.3487L33.4306 27.0696V26.7906H33.1515H32.8725C32.5934 26.7906 32.5934 26.7906 32.3143 26.5115H32.0352L31.7562 25.9534H31.4771V25.6743L31.198 25.9534L30.919 26.2324H30.3608H30.0818L29.5236 25.9534V25.6743L29.2445 25.9534L28.9655 26.5115C28.6864 26.5115 28.6864 26.5115 28.4073 26.5115C28.4073 26.7906 28.1283 26.7906 28.1283 26.7906H27.5701L27.2911 27.0696V27.6278C27.2911 27.9069 27.012 27.9069 27.012 28.1859C27.012 28.1859 27.012 28.465 26.7329 28.465L26.4539 28.7441L26.1748 29.0231ZM22.8259 32.372L20.3143 31.5348V32.372V32.651C20.5934 32.651 20.5934 32.9301 20.5934 32.9301H20.8725C20.8725 33.2092 21.1515 33.2092 21.1515 33.2092H21.9887C22.2678 33.2092 22.5469 32.9301 22.5469 32.9301C22.8259 32.651 22.8259 32.651 22.8259 32.372ZM22.8259 31.5348V30.6975L20.3143 29.8603V30.9766L22.8259 31.5348ZM22.8259 29.8603V28.7441L20.3143 28.1859V29.3022L22.8259 29.8603ZM22.8259 28.1859V27.6278C22.8259 27.3487 22.8259 27.3487 22.8259 27.3487C22.8259 27.0696 22.5469 27.0696 22.5469 27.0696C22.5469 26.7906 22.5469 26.7906 22.2678 26.7906H21.9887H21.1515H20.8725C20.8725 26.7906 20.5934 26.7906 20.5934 27.0696C20.5934 27.0696 20.5934 27.0696 20.3143 27.3487C20.3143 27.3487 20.3143 27.3487 20.3143 27.6278L22.8259 28.1859ZM28.1283 19.8138C27.8492 19.8138 27.8492 19.8138 27.8492 19.8138C27.5701 20.0929 27.5701 20.0929 27.5701 20.0929L27.2911 20.372V20.651V21.4882V21.7673C27.2911 22.0464 27.5701 22.0464 27.5701 22.0464C27.5701 22.0464 27.5701 22.3255 27.8492 22.3255C27.8492 22.3255 27.8492 22.3255 28.1283 22.3255L28.6864 19.8138H28.1283ZM28.9655 22.3255H29.8027L30.3608 19.8138H29.5236L28.9655 22.3255ZM30.6399 22.3255H31.4771L32.0352 19.8138H31.198L30.6399 22.3255ZM32.3143 22.3255H32.8725C33.1515 22.3255 33.4306 22.3255 33.4306 22.0464C33.7097 22.0464 33.7097 21.7673 33.7097 21.4882V20.651V20.372L33.4306 20.0929C33.4306 20.0929 33.1515 20.0929 33.1515 19.8138H32.8725L32.3143 22.3255ZM40.4073 27.6278C40.4073 27.3487 40.4073 27.3487 40.4073 27.3487C40.1283 27.3487 40.1283 26.7906 40.1283 26.7906C39.8492 26.7906 39.8492 26.7906 39.5701 26.7906H39.012C38.7329 26.7906 38.7329 26.7906 38.4539 26.7906C38.4539 26.7906 38.4539 27.0696 38.1748 27.0696C38.1748 27.0696 38.1748 27.3487 38.1748 27.6278L40.4073 28.1859V27.6278ZM38.1748 28.465V29.3022L40.4073 29.8603V29.0231L38.1748 28.465ZM38.1748 30.1394V30.9766L40.4073 31.5348V30.6975L38.1748 30.1394ZM38.1748 31.8138V32.372V32.651V32.9301C38.4539 32.9301 38.4539 33.2092 38.4539 33.2092C38.7329 33.2092 38.7329 33.2092 39.012 33.2092H39.5701C39.8492 33.2092 40.1283 33.2092 40.4073 32.9301C40.4073 32.9301 40.4073 32.651 40.4073 32.372L38.1748 31.8138ZM40.9655 27.0696C41.2445 27.0696 41.2445 27.3487 41.2445 27.6278V32.372C41.2445 32.651 40.9655 33.2092 40.6864 33.4882C40.4073 33.7673 40.1283 33.7673 39.5701 33.7673H39.012C38.7329 33.7673 38.4539 33.7673 38.4539 33.7673C38.1748 33.7673 37.8957 33.4882 37.8957 33.4882C37.6166 33.2092 37.6166 33.2092 37.6166 32.9301C37.3376 32.651 37.3376 32.651 37.3376 32.372V27.6278C37.3376 27.3487 37.3376 27.0696 37.6166 27.0696C37.6166 26.7906 37.6166 26.7906 37.8957 26.5115C37.8957 26.5115 38.1748 26.2324 38.4539 26.2324C38.4539 26.2324 38.7329 26.2324 39.012 26.2324H39.5701C39.8492 26.2324 40.1283 26.2324 40.4073 26.2324L40.6864 26.5115C40.9655 26.7906 40.9655 26.7906 40.9655 27.0696ZM31.198 37.6743L30.3608 39.9069H31.4771L32.0352 37.6743H31.198ZM32.8725 39.9069C33.1515 39.9069 33.1515 39.9069 33.4306 39.9069C33.4306 39.6278 33.7097 39.3487 33.7097 39.0696V38.5115C33.7097 38.2324 33.7097 38.2324 33.4306 37.9534C33.4306 37.9534 33.4306 37.9534 33.4306 37.6743H33.1515H32.8725L32.0352 39.9069H32.8725ZM28.6864 37.6743H28.1283C27.8492 37.6743 27.8492 37.6743 27.8492 37.6743C27.5701 37.9534 27.2911 37.9534 27.2911 37.9534C27.2911 38.2324 27.2911 38.2324 27.2911 38.5115V39.0696C27.2911 39.3487 27.2911 39.3487 27.2911 39.6278C27.2911 39.6278 27.2911 39.6278 27.5701 39.9069C27.5701 39.9069 27.8492 39.9069 28.1283 39.9069L28.6864 37.6743ZM33.9887 40.1859C33.7097 40.465 33.1515 40.7441 32.8725 40.7441H28.1283C27.8492 40.7441 27.5701 40.7441 27.5701 40.465C27.2911 40.465 27.012 40.465 27.012 40.1859C26.7329 40.1859 26.7329 39.9069 26.7329 39.9069C26.4539 39.6278 26.4539 39.3487 26.4539 39.0696V38.5115C26.4539 38.2324 26.4539 37.9534 26.7329 37.9534C26.7329 37.6743 26.7329 37.3952 27.012 37.3952C27.012 37.1162 27.2911 37.1162 27.5701 37.1162C27.5701 36.8371 27.8492 36.8371 28.1283 36.8371H32.8725C32.8725 36.8371 33.1515 36.8371 33.4306 37.1162C33.4306 37.1162 33.7097 37.1162 33.9887 37.3952C33.9887 37.3952 33.9887 37.6743 34.2678 37.9534C34.2678 37.9534 34.2678 38.2324 34.2678 38.5115V39.0696C34.2678 39.6278 33.9887 39.9069 33.9887 40.1859Z"
              fill="#FEC42B"
            />
            <path
              d="M10.5469 29.8603C10.5469 24.558 12.7794 19.5348 16.4073 15.9069C20.0352 12.2789 25.0585 10.0464 30.3608 10.0464C35.9422 10.0464 40.9655 12.2789 44.5934 15.9069C48.2213 19.5348 50.4539 24.558 50.4539 29.8603C50.4539 35.4417 48.2213 40.465 44.5934 44.0929C40.9655 47.7208 35.9422 49.9534 30.3608 49.9534C25.0585 49.9534 20.0352 47.7208 16.4073 44.0929C12.7794 40.465 10.5469 35.4417 10.5469 29.8603ZM10.5469 29.8603H11.105M11.105 29.8603C11.105 34.8836 13.0585 39.3487 16.1283 42.6975L21.9887 38.5115C20.0352 36.2789 18.6399 33.7673 18.6399 30.6975L11.3841 29.3022C11.3841 29.5813 11.105 29.8603 11.105 29.8603ZM34.5469 29.3022L34.2678 29.5813C34.2678 29.5813 34.5469 29.8603 34.5469 30.1394L34.2678 30.4185L34.5469 30.9766H34.8259L34.5469 31.2557L33.9887 31.5348C33.9887 31.8138 33.9887 31.8138 33.9887 32.0929C33.7097 32.0929 33.7097 32.372 33.7097 32.372V32.9301L33.4306 33.2092H33.1515H32.8725C32.5934 33.2092 32.5934 33.4882 32.3143 33.4882C32.3143 33.4882 32.0352 33.4882 32.0352 33.7673L31.7562 34.0464L31.4771 34.3255L31.198 34.0464H30.6399H30.3608H30.0818H29.5236V34.3255H29.2445V34.0464L28.9655 33.7673C28.6864 33.4882 28.6864 33.4882 28.4073 33.4882L28.1283 33.2092H27.5701H27.2911V32.9301V32.372L27.012 32.0929C27.012 31.8138 27.012 31.8138 26.7329 31.5348L26.4539 31.2557H26.1748V30.9766H26.4539V30.1394C26.4539 29.8603 26.4539 29.5813 26.4539 29.5813V29.3022L26.1748 29.0231L26.4539 28.7441L26.7329 28.465C27.012 28.465 27.012 28.1859 27.012 28.1859C27.012 27.9069 27.2911 27.9069 27.2911 27.6278V27.0696L27.5701 26.7906H28.1283C28.1283 26.7906 28.4073 26.7906 28.4073 26.5115C28.6864 26.5115 28.6864 26.5115 28.9655 26.5115L29.2445 25.9534L29.5236 25.6743V25.9534L30.0818 26.2324H30.3608H30.919L31.198 25.9534L31.4771 25.6743V25.9534H31.7562L32.0352 26.5115H32.3143C32.5934 26.7906 32.5934 26.7906 32.8725 26.7906H33.1515H33.4306V27.0696L33.7097 27.3487V27.6278C33.7097 27.9069 33.7097 28.1859 33.9887 28.465L34.5469 28.7441V29.3022ZM34.5469 29.3022L34.8259 29.0231M29.8027 39.9069L30.3608 37.6743H29.2445L28.6864 39.9069H29.8027ZM16.4073 42.9766C16.6864 43.2557 16.6864 43.2557 16.9655 43.5348C20.0352 46.6045 24.5004 48.8371 29.2445 49.1162L30.6399 41.8603H30.3608C27.5701 41.8603 24.7794 40.7441 22.5469 39.0696L16.4073 42.9766ZM29.8027 49.1162C30.0818 49.1162 30.3608 49.1162 30.3608 49.1162C35.3841 49.1162 39.8492 47.4417 43.198 44.372L39.012 38.2324V38.5115C36.7794 40.465 34.2678 41.5813 31.198 41.8603L29.8027 49.1162ZM43.4771 43.8138C43.7562 43.8138 43.7562 43.5348 44.0352 43.5348C47.105 40.465 49.3376 35.9999 49.6166 31.2557L42.3608 29.8603C42.3608 32.9301 41.2445 35.7208 39.5701 37.6743L43.4771 43.8138ZM49.6166 30.4185C49.6166 30.4185 49.6166 30.1394 49.6166 29.8603C49.6166 25.1162 47.9422 20.651 44.8725 17.3022L38.7329 21.4882H39.012C40.9655 23.4417 42.0818 26.2324 42.3608 29.0231L49.6166 30.4185ZM44.3143 16.7441L44.0352 16.465C40.9655 13.1162 36.5004 11.1627 31.7562 10.8836L30.3608 18.1394C33.4306 18.1394 36.2213 18.9766 38.1748 20.9301L44.3143 16.7441ZM30.919 10.8836C30.919 10.8836 30.6399 10.6045 30.3608 10.6045C25.6166 10.6045 21.1515 12.558 17.8027 15.6278L21.9887 21.4882C23.9422 19.5348 26.7329 18.1394 29.5236 18.1394L30.919 10.8836ZM17.2445 15.9069C17.2445 16.1859 16.9655 16.1859 16.9655 16.465C13.6166 19.5348 11.6632 23.9999 11.3841 28.7441L18.6399 30.1394V29.8603C18.6399 27.0696 19.4771 24.2789 21.4306 22.0464L17.2445 15.9069ZM22.5469 22.0464C20.3143 23.9999 19.198 26.7906 19.198 29.8603C19.198 32.9301 20.3143 35.9999 22.5469 37.9534C24.5004 39.9069 27.2911 41.3022 30.3608 41.3022C33.4306 41.3022 36.5004 39.9069 38.4539 37.9534C40.4073 35.9999 41.8027 32.9301 41.8027 29.8603C41.8027 26.7906 40.4073 23.9999 38.4539 22.0464C36.5004 19.8138 33.4306 18.6976 30.3608 18.6976C27.2911 18.6976 24.5004 19.8138 22.5469 22.0464ZM23.3841 29.3022C23.6632 27.6278 24.5004 26.2324 25.6166 24.8371C26.4539 23.9999 27.8492 23.1627 29.5236 22.8836H28.1283C27.8492 22.8836 27.5701 22.8836 27.5701 22.8836C27.2911 22.8836 27.2911 22.6045 27.012 22.6045C27.012 22.3255 26.7329 22.3255 26.7329 22.0464C26.7329 21.7673 26.7329 21.7673 26.7329 21.4882V20.651C26.7329 20.372 26.7329 20.372 26.7329 20.0929C26.7329 19.8138 27.012 19.8138 27.012 19.5348C27.2911 19.5348 27.2911 19.5348 27.5701 19.2557C27.5701 19.2557 27.8492 19.2557 28.1283 19.2557H32.8725C33.1515 19.2557 33.1515 19.2557 33.4306 19.2557C33.7097 19.5348 33.7097 19.5348 33.9887 19.5348C33.9887 19.8138 34.2678 19.8138 34.2678 20.0929C34.2678 20.372 34.2678 20.372 34.2678 20.651V21.4882C34.2678 22.0464 34.2678 22.3255 33.9887 22.6045C33.7097 22.8836 33.1515 22.8836 32.8725 22.8836H31.4771C32.8725 23.1627 34.2678 23.9999 35.3841 24.8371C36.5004 26.2324 37.3376 27.9069 37.3376 29.8603C37.3376 31.8138 36.5004 33.4882 35.3841 34.8836C33.9887 35.9999 32.3143 36.8371 30.3608 36.8371C28.4073 36.8371 26.7329 35.9999 25.6166 34.8836C24.5004 33.7673 23.6632 32.0929 23.3841 30.4185V32.372C23.3841 32.651 23.3841 33.2092 23.105 33.4882C22.8259 33.4882 22.5469 33.7673 21.9887 33.7673H21.1515C20.8725 33.7673 20.8725 33.7673 20.5934 33.7673C20.3143 33.4882 20.3143 33.4882 20.0352 33.4882C20.0352 33.2092 20.0352 32.9301 19.7562 32.9301C19.7562 32.651 19.7562 32.372 19.7562 32.372V27.6278C19.7562 27.3487 19.7562 27.0696 19.7562 27.0696C20.0352 26.7906 20.0352 26.5115 20.0352 26.5115C20.3143 26.2324 20.3143 26.2324 20.5934 26.2324C20.8725 25.9534 20.8725 25.9534 21.1515 25.9534H21.9887C22.2678 25.9534 22.2678 25.9534 22.5469 26.2324C22.8259 26.2324 22.8259 26.2324 23.105 26.5115C23.105 26.5115 23.3841 26.7906 23.3841 27.0696C23.3841 27.0696 23.3841 27.3487 23.3841 27.6278V29.3022ZM25.8957 25.3952C24.7794 26.5115 24.2213 28.1859 24.2213 29.8603C24.2213 31.5348 24.7794 33.2092 25.8957 34.3255C27.012 35.4417 28.6864 36.2789 30.3608 36.2789C32.3143 36.2789 33.7097 35.4417 34.8259 34.3255C35.9422 33.2092 36.7794 31.5348 36.7794 29.8603C36.7794 28.1859 35.9422 26.5115 34.8259 25.3952C33.7097 24.2789 32.3143 23.7208 30.3608 23.7208C28.6864 23.7208 27.012 24.2789 25.8957 25.3952ZM30.3608 27.6278C30.919 27.6278 31.4771 27.6278 31.7562 27.9069C32.0352 28.1859 32.3143 28.465 32.5934 28.7441C32.8725 29.3022 32.8725 29.5813 32.8725 30.1394C32.8725 30.4185 32.8725 30.9766 32.5934 31.2557C32.3143 31.5348 32.0352 32.0929 31.7562 32.0929C31.4771 32.372 30.919 32.651 30.3608 32.651C29.8027 32.651 29.2446 32.372 28.6864 31.8138C28.1283 31.2557 27.8492 30.6976 27.8492 30.1394C27.8492 29.3022 28.1283 28.7441 28.6864 28.1859C29.2446 27.9069 29.8027 27.6278 30.3608 27.6278ZM31.4771 28.465C31.198 28.1859 30.919 28.1859 30.3608 28.1859C30.0818 28.1859 29.5236 28.465 29.2445 28.7441C28.9655 29.0231 28.6864 29.5813 28.6864 30.1394C28.6864 30.4185 28.9655 30.9766 29.2445 31.2557C29.5236 31.5348 30.0818 31.8138 30.3608 31.8138C30.919 31.8138 31.198 31.8138 31.4771 31.5348C31.7562 31.5348 31.7562 31.2557 32.0352 30.9766C32.3143 30.6976 32.3143 30.4185 32.3143 30.1394C32.3143 29.5813 32.3143 29.3022 32.0352 29.0231C31.7562 28.7441 31.7562 28.7441 31.4771 28.465ZM25.8957 29.5813L25.6166 29.3022C25.6166 29.0231 25.6166 29.0231 25.6166 28.7441C25.6166 28.465 25.8957 28.465 25.8957 28.1859L26.1748 27.9069H26.4539V27.6278C26.4539 27.6278 26.4539 27.6278 26.7329 27.3487L26.4539 27.0696C26.7329 26.7906 26.7329 26.5115 27.012 26.5115L27.2911 26.2324H27.8492C27.8492 26.2324 28.1283 26.2324 28.1283 25.9534H28.4073V25.6743L28.6864 25.3952C28.6864 25.3952 28.9655 25.3952 29.2445 25.1162C29.2445 25.1162 29.5236 25.1162 29.8027 25.1162L30.0818 25.3952H30.3608H30.919L31.198 25.1162C31.4771 25.1162 31.4771 25.1162 31.7562 25.1162C32.0352 25.3952 32.0352 25.3952 32.3143 25.3952L32.5934 25.6743V25.9534L33.1515 26.2324H33.4306C33.7097 26.2324 33.9887 26.5115 33.9887 26.5115C34.2678 26.5115 34.2678 26.7906 34.2678 27.0696L34.5469 27.6278C34.5469 27.9069 34.5469 27.9069 34.5469 27.9069H34.8259L35.105 28.1859C35.105 28.465 35.105 28.465 35.3841 28.7441C35.3841 29.0231 35.3841 29.0231 35.3841 29.3022L35.105 29.5813C35.105 29.8603 35.105 29.8603 35.105 30.1394L35.3841 30.6975C35.3841 30.9766 35.3841 31.2557 35.3841 31.2557C35.105 31.5348 35.105 31.8138 35.105 31.8138L34.8259 32.0929H34.5469C34.2678 32.0929 34.2678 32.651 34.2678 32.651V33.2092C34.2678 33.2092 34.2678 33.4882 33.9887 33.4882C33.9887 33.7673 33.7097 33.7673 33.4306 34.0464H33.1515V33.7673L32.8725 34.0464L32.5934 34.3255L32.3143 34.6045C32.0352 34.6045 32.0352 34.8836 31.7562 34.8836C31.4771 34.8836 31.4771 34.8836 31.198 34.8836H30.919V34.6045H30.3608H30.0818V34.8836H29.8027C29.5236 34.8836 29.2445 34.8836 29.2445 34.8836C28.9655 34.8836 28.6864 34.8836 28.6864 34.6045L28.4073 34.3255V34.0464H28.1283L27.8492 33.7673V34.0464H27.2911C27.2911 33.7673 27.012 33.7673 27.012 33.4882C26.7329 33.4882 26.7329 33.2092 26.4539 33.2092V32.651V32.372L26.1748 32.0929L25.8957 31.8138C25.8957 31.8138 25.6166 31.5348 25.6166 31.2557C25.6166 31.2557 25.6166 30.9766 25.6166 30.6975V30.4185C25.6166 30.1394 25.8957 30.1394 25.8957 30.1394C25.8957 29.8603 25.8957 29.8603 25.8957 29.5813ZM22.8259 32.372L20.3143 31.5348V32.372V32.651C20.5934 32.651 20.5934 32.9301 20.5934 32.9301H20.8725C20.8725 33.2092 21.1515 33.2092 21.1515 33.2092H21.9887C22.2678 33.2092 22.5469 32.9301 22.5469 32.9301C22.8259 32.651 22.8259 32.651 22.8259 32.372ZM22.8259 31.5348V30.6975L20.3143 29.8603V30.9766L22.8259 31.5348ZM22.8259 29.8603V28.7441L20.3143 28.1859V29.3022L22.8259 29.8603ZM22.8259 28.1859V27.6278C22.8259 27.3487 22.8259 27.3487 22.8259 27.3487C22.8259 27.0696 22.5469 27.0696 22.5469 27.0696C22.5469 26.7906 22.5469 26.7906 22.2678 26.7906H21.9887H21.1515H20.8725C20.8725 26.7906 20.5934 26.7906 20.5934 27.0696C20.5934 27.0696 20.5934 27.0696 20.3143 27.3487C20.3143 27.3487 20.3143 27.3487 20.3143 27.6278L22.8259 28.1859ZM28.1283 19.8138C27.8492 19.8138 27.8492 19.8138 27.8492 19.8138C27.5701 20.0929 27.5701 20.0929 27.5701 20.0929L27.2911 20.372V20.651V21.4882V21.7673C27.2911 22.0464 27.5701 22.0464 27.5701 22.0464C27.5701 22.0464 27.5701 22.3255 27.8492 22.3255C27.8492 22.3255 27.8492 22.3255 28.1283 22.3255L28.6864 19.8138H28.1283ZM28.9655 22.3255H29.8027L30.3608 19.8138H29.5236L28.9655 22.3255ZM30.6399 22.3255H31.4771L32.0352 19.8138H31.198L30.6399 22.3255ZM32.3143 22.3255H32.8725C33.1515 22.3255 33.4306 22.3255 33.4306 22.0464C33.7097 22.0464 33.7097 21.7673 33.7097 21.4882V20.651V20.372L33.4306 20.0929C33.4306 20.0929 33.1515 20.0929 33.1515 19.8138H32.8725L32.3143 22.3255ZM40.4073 27.6278C40.4073 27.3487 40.4073 27.3487 40.4073 27.3487C40.1283 27.3487 40.1283 26.7906 40.1283 26.7906C39.8492 26.7906 39.8492 26.7906 39.5701 26.7906H39.012C38.7329 26.7906 38.7329 26.7906 38.4539 26.7906C38.4539 26.7906 38.4539 27.0696 38.1748 27.0696C38.1748 27.0696 38.1748 27.3487 38.1748 27.6278L40.4073 28.1859V27.6278ZM38.1748 28.465V29.3022L40.4073 29.8603V29.0231L38.1748 28.465ZM38.1748 30.1394V30.9766L40.4073 31.5348V30.6975L38.1748 30.1394ZM38.1748 31.8138V32.372V32.651V32.9301C38.4539 32.9301 38.4539 33.2092 38.4539 33.2092C38.7329 33.2092 38.7329 33.2092 39.012 33.2092H39.5701C39.8492 33.2092 40.1283 33.2092 40.4073 32.9301C40.4073 32.9301 40.4073 32.651 40.4073 32.372L38.1748 31.8138ZM40.9655 27.0696C41.2445 27.0696 41.2445 27.3487 41.2445 27.6278V32.372C41.2445 32.651 40.9655 33.2092 40.6864 33.4882C40.4073 33.7673 40.1283 33.7673 39.5701 33.7673H39.012C38.7329 33.7673 38.4539 33.7673 38.4539 33.7673C38.1748 33.7673 37.8957 33.4882 37.8957 33.4882C37.6166 33.2092 37.6166 33.2092 37.6166 32.9301C37.3376 32.651 37.3376 32.651 37.3376 32.372V27.6278C37.3376 27.3487 37.3376 27.0696 37.6166 27.0696C37.6166 26.7906 37.6166 26.7906 37.8957 26.5115C37.8957 26.5115 38.1748 26.2324 38.4539 26.2324C38.4539 26.2324 38.7329 26.2324 39.012 26.2324H39.5701C39.8492 26.2324 40.1283 26.2324 40.4073 26.2324L40.6864 26.5115C40.9655 26.7906 40.9655 26.7906 40.9655 27.0696ZM31.198 37.6743L30.3608 39.9069H31.4771L32.0352 37.6743H31.198ZM32.8725 39.9069C33.1515 39.9069 33.1515 39.9069 33.4306 39.9069C33.4306 39.6278 33.7097 39.3487 33.7097 39.0696V38.5115C33.7097 38.2324 33.7097 38.2324 33.4306 37.9534C33.4306 37.9534 33.4306 37.9534 33.4306 37.6743H33.1515H32.8725L32.0352 39.9069H32.8725ZM28.6864 37.6743H28.1283C27.8492 37.6743 27.8492 37.6743 27.8492 37.6743C27.5701 37.9534 27.2911 37.9534 27.2911 37.9534C27.2911 38.2324 27.2911 38.2324 27.2911 38.5115V39.0696C27.2911 39.3487 27.2911 39.3487 27.2911 39.6278C27.2911 39.6278 27.2911 39.6278 27.5701 39.9069C27.5701 39.9069 27.8492 39.9069 28.1283 39.9069L28.6864 37.6743ZM33.9887 40.1859C33.7097 40.465 33.1515 40.7441 32.8725 40.7441H28.1283C27.8492 40.7441 27.5701 40.7441 27.5701 40.465C27.2911 40.465 27.012 40.465 27.012 40.1859C26.7329 40.1859 26.7329 39.9069 26.7329 39.9069C26.4539 39.6278 26.4539 39.3487 26.4539 39.0696V38.5115C26.4539 38.2324 26.4539 37.9534 26.7329 37.9534C26.7329 37.6743 26.7329 37.3952 27.012 37.3952C27.012 37.1162 27.2911 37.1162 27.5701 37.1162C27.5701 36.8371 27.8492 36.8371 28.1283 36.8371H32.8725C32.8725 36.8371 33.1515 36.8371 33.4306 37.1162C33.4306 37.1162 33.7097 37.1162 33.9887 37.3952C33.9887 37.3952 33.9887 37.6743 34.2678 37.9534C34.2678 37.9534 34.2678 38.2324 34.2678 38.5115V39.0696C34.2678 39.6278 33.9887 39.9069 33.9887 40.1859Z"
              stroke="#FEC42B"
              stroke-width="0.27907"
              stroke-miterlimit="2.61313"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.5703 35.442C15.5703 34.8838 16.1285 34.3257 16.6866 34.3257C17.5238 34.3257 18.0819 34.8838 18.0819 35.442C18.0819 36.2792 17.5238 36.8373 16.6866 36.8373C16.1285 36.8373 15.5703 36.2792 15.5703 35.442Z"
              fill="#FEC42B"
              stroke="#FEC42B"
              stroke-width="0.27907"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.5703 24.2791C15.5703 23.4419 16.1285 22.8838 16.6866 22.8838C17.5238 22.8838 18.0819 23.4419 18.0819 24.2791C18.0819 24.8373 17.5238 25.3954 16.6866 25.3954C16.1285 25.3954 15.5703 24.8373 15.5703 24.2791Z"
              fill="#FEC42B"
              stroke="#FEC42B"
              stroke-width="0.27907"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M23.6631 16.1861C23.6631 15.628 24.2212 15.0698 24.7794 15.0698C25.6166 15.0698 26.1747 15.628 26.1747 16.1861C26.1747 17.0233 25.6166 17.5815 24.7794 17.5815C24.2212 17.5815 23.6631 17.0233 23.6631 16.1861Z"
              fill="#FEC42B"
              stroke="#FEC42B"
              stroke-width="0.27907"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M34.8262 16.1861C34.8262 15.628 35.3843 15.0698 36.2215 15.0698C36.7797 15.0698 37.3378 15.628 37.3378 16.1861C37.3378 17.0233 36.7797 17.5815 36.2215 17.5815C35.3843 17.5815 34.8262 17.0233 34.8262 16.1861Z"
              fill="#FEC42B"
              stroke="#FEC42B"
              stroke-width="0.27907"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M42.9189 24.2789C42.9189 23.7207 43.4771 23.1626 44.3143 23.1626C44.8724 23.1626 45.4306 23.7207 45.4306 24.2789C45.4306 25.1161 44.8724 25.6742 44.3143 25.6742C43.4771 25.6742 42.9189 25.1161 42.9189 24.2789Z"
              fill="#FEC42B"
              stroke="#FEC42B"
              stroke-width="0.27907"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M42.9189 35.721C42.9189 34.8838 43.4771 34.3257 44.0352 34.3257C44.8724 34.3257 45.4306 34.8838 45.4306 35.721C45.4306 36.2792 44.8724 36.8373 44.0352 36.8373C43.4771 36.8373 42.9189 36.2792 42.9189 35.721Z"
              fill="#FEC42B"
              stroke="#FEC42B"
              stroke-width="0.27907"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M34.8262 43.8138C34.8262 42.9766 35.3843 42.4185 35.9425 42.4185C36.7797 42.4185 37.3378 42.9766 37.3378 43.8138C37.3378 44.3719 36.7797 44.9301 35.9425 44.9301C35.3843 44.9301 34.8262 44.3719 34.8262 43.8138Z"
              fill="#FEC42B"
              stroke="#FEC42B"
              stroke-width="0.27907"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M23.3838 43.5347C23.3838 42.9766 23.9419 42.4185 24.7791 42.4185C25.3373 42.4185 25.8954 42.9766 25.8954 43.5347C25.8954 44.3719 25.3373 44.9301 24.7791 44.9301C23.9419 44.9301 23.3838 44.3719 23.3838 43.5347Z"
              fill="#FEC42B"
              stroke="#FEC42B"
              stroke-width="0.27907"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_437">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_265_470)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.3125 1.875C46.125 1.875 58.125 13.875 58.125 28.6875C58.125 43.3125 46.125 55.3125 31.3125 55.3125C30.1875 55.3125 28.875 55.3125 27.75 55.125L26.625 58.125C24.5625 57.75 22.6875 57.1875 20.8125 56.625L21.375 53.4375C18.9375 52.5 16.875 51.1875 15 49.6875L12.5625 51.75C11.0625 50.4375 9.5625 49.125 8.25 47.4375L10.3125 45C8.8125 43.125 7.5 41.0625 6.5625 38.625L3.375 39.1875C2.8125 37.3125 2.25 35.4375 1.875 33.375L4.875 32.25C4.6875 31.125 4.6875 29.8125 4.6875 28.6875C4.6875 13.875 16.6875 1.875 31.3125 1.875ZM31.3125 53.4375C45 53.4375 56.25 42.375 56.25 28.6875C56.25 15 45 3.75 31.3125 3.75C17.625 3.75 6.5625 15 6.5625 28.6875H18.5625C18.5625 35.625 24.375 41.4375 31.3125 41.4375V53.4375ZM43.3125 47.4375L41.0625 43.5L39.375 44.4375L41.8125 48.5625L43.3125 47.4375ZM51.1875 39L47.25 36.75L46.3125 38.4375L50.25 40.6875L51.1875 39ZM53.8125 27.75H49.125V29.625H53.8125V27.75ZM50.25 16.6875L46.3125 18.9375L47.25 20.625L51.1875 18.1875L50.25 16.6875ZM41.8125 8.8125L39.375 12.75L41.0625 13.6875L43.3125 9.75L41.8125 8.8125ZM30.375 6.1875V10.875H32.25V6.1875H30.375ZM11.625 18.1875L15.5625 20.625L16.5 18.9375L12.5625 16.6875L11.625 18.1875ZM19.3125 9.75L21.5625 13.5L23.25 12.5625L21 8.8125L19.3125 9.75ZM31.3125 24.5625C33.5625 24.5625 35.4375 26.4375 35.4375 28.6875C35.4375 30.9375 33.5625 32.625 31.3125 32.625C29.0625 32.625 27.375 30.9375 27.375 28.6875C27.375 28.125 27.375 27.75 27.5625 27.375L19.6875 17.0625L30 24.75C30.375 24.75 30.9375 24.5625 31.3125 24.5625Z"
              fill="#F5F5F5"
              stroke="#F5F5F5"
              stroke-width="0.5625"
              stroke-miterlimit="2.61313"
            />
          </g>
          <defs>
            <clipPath id="clip0_265_470">
              <rect width="60" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      categoryName: "بلند",
      pieceName: "کلاچ",
      desc: "کلاچ وسیله‌ای است که به کمک آن راننده هر زمان که بخواهد می‌تواند اتصال موتور را از جعبه‌دنده جدا نماید، بدین معنی که موتور روشن باشد بدون اینکه چرخ دنده‌ها در جعبه‌دنده بچرخند و خودرو حرکت نماید.",
    },
    {
      id: 43,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M35.0283 45H25.9717"
            stroke="#FEC42B"
            stroke-width="1.41509"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M35.0283 37.6416H25.9717"
            stroke="#FEC42B"
            stroke-width="1.41509"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M35.0283 30H25.9717"
            stroke="#FEC42B"
            stroke-width="1.41509"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M33.0477 22.9244L34.7458 21.2263C34.7458 21.2263 35.3119 20.3772 35.3119 19.8112C35.3119 19.2451 35.0289 18.6791 34.7458 18.1131L31.9156 15.5659C31.9156 15.5659 31.3496 14.7168 31.3496 14.1508C31.3496 13.5848 31.6326 13.0187 31.9156 12.4527L33.3307 11.0376"
            stroke="#FEC42B"
            stroke-width="1.41509"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M25.9716 22.9244L27.6697 21.2263C27.6697 21.2263 28.2357 20.3772 28.2357 19.8112C28.2357 19.2451 27.9527 18.6791 27.6697 18.1131L24.8395 15.5659C24.8395 15.5659 24.2734 14.7168 24.2734 14.1508C24.2734 13.5848 24.5565 13.0187 24.8395 12.4527L26.2546 11.0376"
            stroke="#FEC42B"
            stroke-width="1.41509"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.27344 31.6982V43.585C9.27344 43.868 9.27344 44.151 9.55646 44.434C9.83948 44.717 10.1225 44.717 10.4055 44.717H14.6508L23.4244 48.6793H37.5753L46.3489 44.717H50.3112C50.5942 44.717 51.1602 44.717 51.1602 44.434C51.4432 44.151 51.7263 43.868 51.7263 43.585V31.6982C51.7263 31.4151 51.4432 30.8491 51.1602 30.8491C51.1602 30.5661 50.5942 30.2831 50.3112 30.2831H46.3489L37.5753 26.3208H23.4244L14.6508 30.2831H10.4055C10.1225 30.2831 9.83948 30.5661 9.55646 30.8491C9.27344 30.8491 9.27344 31.4151 9.27344 31.6982Z"
            stroke="#FEC42B"
            stroke-width="1.41509"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M51.7266 33.396H55.6888L56.5379 33.679L56.8209 34.5281V40.4715L56.5379 41.3205L55.6888 41.8866H51.7266"
            stroke="#FEC42B"
            stroke-width="1.41509"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M9.27384 33.396H5.31158L4.46252 33.679L3.89648 34.5281V40.4715L4.46252 41.3205L5.31158 41.8866H9.27384"
            stroke="#FEC42B"
            stroke-width="1.41509"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M23.4248 26.3208V48.6793"
            stroke="#FEC42B"
            stroke-width="1.41509"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M37.5762 48.6793V26.3208"
            stroke="#FEC42B"
            stroke-width="1.41509"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_265_470)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.3125 1.875C46.125 1.875 58.125 13.875 58.125 28.6875C58.125 43.3125 46.125 55.3125 31.3125 55.3125C30.1875 55.3125 28.875 55.3125 27.75 55.125L26.625 58.125C24.5625 57.75 22.6875 57.1875 20.8125 56.625L21.375 53.4375C18.9375 52.5 16.875 51.1875 15 49.6875L12.5625 51.75C11.0625 50.4375 9.5625 49.125 8.25 47.4375L10.3125 45C8.8125 43.125 7.5 41.0625 6.5625 38.625L3.375 39.1875C2.8125 37.3125 2.25 35.4375 1.875 33.375L4.875 32.25C4.6875 31.125 4.6875 29.8125 4.6875 28.6875C4.6875 13.875 16.6875 1.875 31.3125 1.875ZM31.3125 53.4375C45 53.4375 56.25 42.375 56.25 28.6875C56.25 15 45 3.75 31.3125 3.75C17.625 3.75 6.5625 15 6.5625 28.6875H18.5625C18.5625 35.625 24.375 41.4375 31.3125 41.4375V53.4375ZM43.3125 47.4375L41.0625 43.5L39.375 44.4375L41.8125 48.5625L43.3125 47.4375ZM51.1875 39L47.25 36.75L46.3125 38.4375L50.25 40.6875L51.1875 39ZM53.8125 27.75H49.125V29.625H53.8125V27.75ZM50.25 16.6875L46.3125 18.9375L47.25 20.625L51.1875 18.1875L50.25 16.6875ZM41.8125 8.8125L39.375 12.75L41.0625 13.6875L43.3125 9.75L41.8125 8.8125ZM30.375 6.1875V10.875H32.25V6.1875H30.375ZM11.625 18.1875L15.5625 20.625L16.5 18.9375L12.5625 16.6875L11.625 18.1875ZM19.3125 9.75L21.5625 13.5L23.25 12.5625L21 8.8125L19.3125 9.75ZM31.3125 24.5625C33.5625 24.5625 35.4375 26.4375 35.4375 28.6875C35.4375 30.9375 33.5625 32.625 31.3125 32.625C29.0625 32.625 27.375 30.9375 27.375 28.6875C27.375 28.125 27.375 27.75 27.5625 27.375L19.6875 17.0625L30 24.75C30.375 24.75 30.9375 24.5625 31.3125 24.5625Z"
              fill="#F5F5F5"
              stroke="#F5F5F5"
              stroke-width="0.5625"
              stroke-miterlimit="2.61313"
            />
          </g>
          <defs>
            <clipPath id="clip0_265_470">
              <rect width="60" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      categoryName: "بلند",
      pieceName: "کاتالیزور",
      desc: "مبدل کاتالیستی وسیله ای است که سر راه خروجی اگزوز خودرو قرار می گیرد و طی یک سری واکنش های شیمیایی با تبدیل گازهای سمی حاصل از احتراق خودرو به گازهای بی ضرر، از آلودگی هوا جلوگیری می کند. البته این مبدل ها انواع مختلفی دارند و واکنش های شیمیایی هر کدام از آن ها بسته به نوع موتور و سوخت مصرفی متفاوت است.",
    },
    {
      id: 44,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M27.4336 37.3332C27.4336 29.3332 34.1003 22.6665 42.1003 22.6665C50.1003 22.6665 56.5003 29.3332 56.5003 37.3332C56.5003 45.3332 50.1003 51.7332 42.1003 51.7332C34.1003 51.7332 27.4336 45.3332 27.4336 37.3332Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.7002 17.3333C11.7002 12.2666 15.7002 8.2666 20.7669 8.2666C25.5669 8.2666 29.5669 12.2666 29.5669 17.3333C29.5669 22.3999 25.5669 26.3999 20.7669 26.3999C15.7002 26.3999 11.7002 22.3999 11.7002 17.3333Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.7667 45.6001C16.7667 42.4001 14.1 39.4668 10.6333 39.4668C7.16667 39.4668 4.5 42.4001 4.5 45.6001C4.5 49.0668 7.16667 51.7335 10.6333 51.7335C14.1 51.7335 16.7667 49.0668 16.7667 45.6001Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.9004 37.3333C30.9004 31.2 35.9671 26.1333 42.1004 26.1333C47.9671 26.1333 53.0337 31.2 53.0337 37.3333C53.0337 43.4666 48.2337 48.2666 42.1004 48.2666C35.9671 48.2666 30.9004 43.4666 30.9004 37.3333Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.3001 45.5998C13.3001 44.2664 12.2335 42.9331 10.6335 42.9331C9.30013 42.9331 7.9668 44.2664 7.9668 45.5998C7.9668 47.1998 9.30013 48.2664 10.6335 48.2664C12.2335 48.2664 13.3001 47.1998 13.3001 45.5998Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.167 17.3334C15.167 14.1334 17.567 11.7334 20.767 11.7334C23.7003 11.7334 26.1003 14.1334 26.1003 17.3334C26.1003 20.2667 23.7003 22.9334 20.767 22.9334C17.567 22.9334 15.167 20.2667 15.167 17.3334Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M42.6331 37.3332C42.6331 36.7999 42.0998 36.5332 42.0998 36.5332C41.5665 36.5332 41.2998 36.7999 41.2998 37.3332C41.2998 37.3332 41.5665 37.8665 42.0998 37.8665L42.6331 37.3332Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.3001 17.3332L20.7668 16.5332C20.2335 16.5332 19.9668 17.3332 19.9668 17.3332C19.9668 17.3332 20.2335 17.8665 20.7668 17.8665L21.3001 17.3332Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45.0337 37.3333C45.0337 35.4666 43.7004 34.1333 42.1004 34.1333C40.2337 34.1333 38.9004 35.4666 38.9004 37.3333C38.9004 38.9333 40.2337 40.2666 42.1004 40.2666C43.7004 40.2666 45.0337 38.9333 45.0337 37.3333Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9668 15.2C12.7668 11.7333 15.4334 9.33331 18.6334 8.53331C22.1001 7.73331 25.5668 9.06664 27.7001 11.7333C29.8334 14.4 30.3668 18.1333 28.7668 21.0666L16.2334 48.2666C14.9001 51.2 11.7001 52.5333 8.50009 51.4666C5.56676 50.4 3.96676 47.2 4.76676 44.2666L11.9668 15.2Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25.5666 9.59982L49.8332 25.0665C54.6332 27.9998 57.2999 33.8665 56.2332 39.7332C55.4332 45.3332 51.1666 50.1332 45.2999 51.4665C39.6999 52.7998 33.8332 50.6665 30.3666 45.8665L13.2999 22.6665C10.6332 19.1998 11.1666 14.3998 14.0999 11.1998C17.0332 7.99982 21.8332 7.46649 25.5666 9.59982Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M34.6334 24.7998L7.70009 40.2665C5.30009 41.5998 3.96676 44.5332 4.76676 47.1998C5.56676 49.8665 7.96676 51.7332 10.6334 51.7332H42.1001C48.2334 51.7332 53.5668 47.9998 55.7001 42.1332C57.8334 36.5332 55.9668 30.1332 51.4334 26.1332C46.6334 22.1332 39.9668 21.5998 34.6334 24.7998Z"
            stroke="#FEC42B"
            stroke-width="1.6"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_265_470)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.3125 1.875C46.125 1.875 58.125 13.875 58.125 28.6875C58.125 43.3125 46.125 55.3125 31.3125 55.3125C30.1875 55.3125 28.875 55.3125 27.75 55.125L26.625 58.125C24.5625 57.75 22.6875 57.1875 20.8125 56.625L21.375 53.4375C18.9375 52.5 16.875 51.1875 15 49.6875L12.5625 51.75C11.0625 50.4375 9.5625 49.125 8.25 47.4375L10.3125 45C8.8125 43.125 7.5 41.0625 6.5625 38.625L3.375 39.1875C2.8125 37.3125 2.25 35.4375 1.875 33.375L4.875 32.25C4.6875 31.125 4.6875 29.8125 4.6875 28.6875C4.6875 13.875 16.6875 1.875 31.3125 1.875ZM31.3125 53.4375C45 53.4375 56.25 42.375 56.25 28.6875C56.25 15 45 3.75 31.3125 3.75C17.625 3.75 6.5625 15 6.5625 28.6875H18.5625C18.5625 35.625 24.375 41.4375 31.3125 41.4375V53.4375ZM43.3125 47.4375L41.0625 43.5L39.375 44.4375L41.8125 48.5625L43.3125 47.4375ZM51.1875 39L47.25 36.75L46.3125 38.4375L50.25 40.6875L51.1875 39ZM53.8125 27.75H49.125V29.625H53.8125V27.75ZM50.25 16.6875L46.3125 18.9375L47.25 20.625L51.1875 18.1875L50.25 16.6875ZM41.8125 8.8125L39.375 12.75L41.0625 13.6875L43.3125 9.75L41.8125 8.8125ZM30.375 6.1875V10.875H32.25V6.1875H30.375ZM11.625 18.1875L15.5625 20.625L16.5 18.9375L12.5625 16.6875L11.625 18.1875ZM19.3125 9.75L21.5625 13.5L23.25 12.5625L21 8.8125L19.3125 9.75ZM31.3125 24.5625C33.5625 24.5625 35.4375 26.4375 35.4375 28.6875C35.4375 30.9375 33.5625 32.625 31.3125 32.625C29.0625 32.625 27.375 30.9375 27.375 28.6875C27.375 28.125 27.375 27.75 27.5625 27.375L19.6875 17.0625L30 24.75C30.375 24.75 30.9375 24.5625 31.3125 24.5625Z"
              fill="#F5F5F5"
              stroke="#F5F5F5"
              stroke-width="0.5625"
              stroke-miterlimit="2.61313"
            />
          </g>
          <defs>
            <clipPath id="clip0_265_470">
              <rect width="60" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      categoryName: "بلند",
      pieceName: "تسمه ها",
      desc: "تسمه‌های خودرو یکی از لوازم مصرفی به کار رفته در موتور خودرو هستند. این قطعات لاستیکی وظیفه انتقال نیرو به دستگاه‌هایی مانند فرمان، واتر پمپ و … را به عهده دارند. جنس تسمه‌ها از پلاستیک است و در گذر زمان و تحت تاثیر عوامل مختلف از بین می‌روند.",
    },
    {
      id: 45,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_242)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M23.8479 44.5249L17.0605 51.0407L17.6035 51.5837L24.1194 44.7964L23.8479 44.5249Z"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.1602 35.2945L16.5176 34.2085L26.2914 43.9823L25.2054 45.0682C24.9339 45.3397 24.9339 45.3397 24.6624 45.3397C24.6624 45.3397 24.6624 45.3397 24.3909 45.0682L15.1602 36.1089C15.1602 35.8375 15.1602 35.566 15.1602 35.2945Z"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.2461 33.3937V33.9367L26.5628 44.2534H26.8343L30.6352 40.724L19.7755 29.8643L16.2461 33.3937Z"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M36.3366 42.6246C36.8796 42.0816 36.8796 41.2672 36.3366 40.9957L19.504 24.1631L18.6895 23.8916L17.875 24.1631L16.5176 25.5206L34.9791 43.9821L36.3366 42.6246Z"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.4902 27.1495L33.35 38.0092L35.5219 35.8373L24.6622 24.9775L22.4902 27.1495Z"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M16.5176 25.5205L34.9791 43.982"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24.1201 24.1631L24.9346 23.6201C25.2061 23.0771 25.7491 23.0771 26.2921 23.6201L36.8803 34.2084C37.4233 34.7514 37.4233 35.0228 36.8803 35.5658L36.0658 36.3803L24.1201 24.1631Z"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.0742 23.8916L36.6082 46.4256L37.1511 45.8826L14.6172 23.3486L14.0742 23.8916Z"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M49.3689 18.7332L50.1834 17.9188C51.2694 16.8328 49.0974 13.3034 49.9119 12.4889L51.5409 10.5884C52.0839 10.317 52.0839 9.23098 51.5409 8.95949C50.9979 8.4165 50.1834 8.4165 49.6404 8.95949L48.0115 10.5884C47.197 11.4029 43.6676 9.23098 42.5816 10.317L41.7671 11.1314M49.3689 18.7332L41.7671 11.1314M49.3689 18.7332C45.025 23.0771 40.6811 27.421 36.3372 31.7649C35.7943 32.3079 35.2513 32.5794 34.7083 32.0364C33.6223 30.9504 32.8078 30.136 31.7219 28.7785C30.3644 27.6925 29.5499 26.878 28.4639 25.7921C27.921 25.2491 28.1924 24.7061 28.7354 23.8916M41.7671 11.1314C37.4232 15.4753 33.0793 19.8192 28.7354 23.8916M41.7671 11.1314L28.7354 23.8916"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M49.9111 12.4888L51.5401 10.5884"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.2462 45.3394C16.2462 44.7964 15.7032 44.2534 15.1602 44.2534C14.6172 44.2534 14.0742 44.7964 14.0742 45.3394C14.0742 45.8824 14.6172 46.4254 15.1602 46.4254C15.7032 46.4254 16.2462 45.8824 16.2462 45.3394Z"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.7033 36.3804L16.2463 36.9234L9.459 43.4392L8.91602 43.1677L15.7033 36.3804Z"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.4453 44.2536L17.8752 38.5522L21.6761 42.3532L16.2462 48.0545L14.8888 48.5975L11.9023 45.8826L12.4453 44.2536Z"
              stroke="#FEC42B"
              stroke-width="1.62896"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_242">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_265_470)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.3125 1.875C46.125 1.875 58.125 13.875 58.125 28.6875C58.125 43.3125 46.125 55.3125 31.3125 55.3125C30.1875 55.3125 28.875 55.3125 27.75 55.125L26.625 58.125C24.5625 57.75 22.6875 57.1875 20.8125 56.625L21.375 53.4375C18.9375 52.5 16.875 51.1875 15 49.6875L12.5625 51.75C11.0625 50.4375 9.5625 49.125 8.25 47.4375L10.3125 45C8.8125 43.125 7.5 41.0625 6.5625 38.625L3.375 39.1875C2.8125 37.3125 2.25 35.4375 1.875 33.375L4.875 32.25C4.6875 31.125 4.6875 29.8125 4.6875 28.6875C4.6875 13.875 16.6875 1.875 31.3125 1.875ZM31.3125 53.4375C45 53.4375 56.25 42.375 56.25 28.6875C56.25 15 45 3.75 31.3125 3.75C17.625 3.75 6.5625 15 6.5625 28.6875H18.5625C18.5625 35.625 24.375 41.4375 31.3125 41.4375V53.4375ZM43.3125 47.4375L41.0625 43.5L39.375 44.4375L41.8125 48.5625L43.3125 47.4375ZM51.1875 39L47.25 36.75L46.3125 38.4375L50.25 40.6875L51.1875 39ZM53.8125 27.75H49.125V29.625H53.8125V27.75ZM50.25 16.6875L46.3125 18.9375L47.25 20.625L51.1875 18.1875L50.25 16.6875ZM41.8125 8.8125L39.375 12.75L41.0625 13.6875L43.3125 9.75L41.8125 8.8125ZM30.375 6.1875V10.875H32.25V6.1875H30.375ZM11.625 18.1875L15.5625 20.625L16.5 18.9375L12.5625 16.6875L11.625 18.1875ZM19.3125 9.75L21.5625 13.5L23.25 12.5625L21 8.8125L19.3125 9.75ZM31.3125 24.5625C33.5625 24.5625 35.4375 26.4375 35.4375 28.6875C35.4375 30.9375 33.5625 32.625 31.3125 32.625C29.0625 32.625 27.375 30.9375 27.375 28.6875C27.375 28.125 27.375 27.75 27.5625 27.375L19.6875 17.0625L30 24.75C30.375 24.75 30.9375 24.5625 31.3125 24.5625Z"
              fill="#F5F5F5"
              stroke="#F5F5F5"
              stroke-width="0.5625"
              stroke-miterlimit="2.61313"
            />
          </g>
          <defs>
            <clipPath id="clip0_265_470">
              <rect width="60" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      categoryName: "بلند",
      pieceName: "برق",
      desc: " مجموعه ای از سیستم های الکتریکی و الکترونیکی که انرژی مورد نیاز خودرو را تامین می کنند، اساس سیم کشی خودرو را تشکیل می دهند. سیستم برق خودرو، بسیار گسترده و حیاتی برای انجام بخش اعظم وظایف هر خودرو می باشد.",
    },
    {
      id: 46,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_450)">
            <path
              d="M29.9447 54.7223C41.4506 54.7223 50.778 45.3949 50.778 33.889C50.778 22.3831 41.4506 13.0557 29.9447 13.0557C18.4387 13.0557 9.11133 22.3831 9.11133 33.889C9.11133 45.3949 18.4387 54.7223 29.9447 54.7223Z"
              stroke="#FEC42B"
              stroke-width="1.38889"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M4.11133 22.778C5.22244 20.5558 6.33355 18.3336 7.72244 16.3892"
              stroke="#FEC42B"
              stroke-width="1.38889"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M2.72201 27.2223C2.16645 29.4445 1.88867 31.6667 1.88867 33.8889V34.4445M32.9998 5.27783C35.4998 5.55561 37.722 6.11117 39.9442 6.9445M21.3331 6.66672C23.5553 6.11117 25.7776 5.55561 28.2776 5.27783M53.5553 16.6667C54.9442 18.6112 56.0553 20.5556 56.8887 22.7778M16.8887 8.61117C14.6664 10.0001 12.722 11.3889 11.0553 12.7778M58.5553 27.5001C58.8331 29.4445 59.1109 31.6667 59.1109 33.8889V34.4445M44.3887 8.88894C46.6109 10.0001 48.5553 11.3889 50.222 13.0556"
              stroke="#FEC42B"
              stroke-width="1.38889"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M26.889 38.3336L22.1668 26.6669H20.5001L16.0557 38.3336H17.7223L19.1112 34.7225H23.8334L25.2223 38.3336H26.889ZM26.889 38.3336L30.2223 26.3892H31.3334L28.0001 38.3336H26.889ZM40.7779 34.1669L42.4445 34.4447C42.1668 35.8336 41.3334 36.6669 40.5001 37.5003C39.6668 38.0558 38.8334 38.3336 37.7223 38.3336C36.3334 38.3336 35.2223 38.0558 34.6668 37.7781C33.8334 37.2225 33.2779 36.3892 32.7223 35.5558C32.4446 34.4447 32.1668 33.6114 32.1668 32.5003C32.1668 31.1114 32.4446 30.0003 33.0001 29.1669C33.2779 28.3336 34.1112 27.778 34.9446 27.2225C35.7779 26.6669 36.6112 26.3892 37.7223 26.3892C38.8334 26.3892 39.6668 26.6669 40.5001 27.5003C41.3334 28.0558 41.889 28.8892 42.1668 30.0003L40.7779 30.278C40.5001 29.4447 39.9446 28.8892 39.389 28.3336C39.1112 28.0558 38.2779 27.778 37.7223 27.778C36.6112 27.778 36.0557 28.0558 35.5001 28.3336C34.6668 28.8892 34.389 29.4447 34.1112 30.278C33.8334 30.8336 33.8334 31.6669 33.8334 32.5003C33.8334 33.3336 33.8334 34.1669 34.1112 35.0003C34.389 35.5558 34.9446 36.1114 35.5001 36.6669C36.0557 36.9447 36.889 37.2225 37.4446 37.2225C38.2779 37.2225 39.1112 36.9447 39.6668 36.3892C40.2223 35.8336 40.5001 35.2781 40.7779 34.1669ZM19.389 33.6114H23.2779L22.1668 30.278C21.889 29.4447 21.6112 28.6114 21.3334 27.778C21.0557 28.6114 21.0557 29.4447 20.7779 30.0003L19.389 33.6114Z"
              stroke="#FEC42B"
              stroke-width="1.38889"
              stroke-miterlimit="2.61313"
            />
            <path
              d="M33.555 10H27.7217V20.8333H33.555V10Z"
              stroke="#FEC42B"
              stroke-width="1.38889"
              stroke-miterlimit="2.61313"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_450">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_265_470)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.3125 1.875C46.125 1.875 58.125 13.875 58.125 28.6875C58.125 43.3125 46.125 55.3125 31.3125 55.3125C30.1875 55.3125 28.875 55.3125 27.75 55.125L26.625 58.125C24.5625 57.75 22.6875 57.1875 20.8125 56.625L21.375 53.4375C18.9375 52.5 16.875 51.1875 15 49.6875L12.5625 51.75C11.0625 50.4375 9.5625 49.125 8.25 47.4375L10.3125 45C8.8125 43.125 7.5 41.0625 6.5625 38.625L3.375 39.1875C2.8125 37.3125 2.25 35.4375 1.875 33.375L4.875 32.25C4.6875 31.125 4.6875 29.8125 4.6875 28.6875C4.6875 13.875 16.6875 1.875 31.3125 1.875ZM31.3125 53.4375C45 53.4375 56.25 42.375 56.25 28.6875C56.25 15 45 3.75 31.3125 3.75C17.625 3.75 6.5625 15 6.5625 28.6875H18.5625C18.5625 35.625 24.375 41.4375 31.3125 41.4375V53.4375ZM43.3125 47.4375L41.0625 43.5L39.375 44.4375L41.8125 48.5625L43.3125 47.4375ZM51.1875 39L47.25 36.75L46.3125 38.4375L50.25 40.6875L51.1875 39ZM53.8125 27.75H49.125V29.625H53.8125V27.75ZM50.25 16.6875L46.3125 18.9375L47.25 20.625L51.1875 18.1875L50.25 16.6875ZM41.8125 8.8125L39.375 12.75L41.0625 13.6875L43.3125 9.75L41.8125 8.8125ZM30.375 6.1875V10.875H32.25V6.1875H30.375ZM11.625 18.1875L15.5625 20.625L16.5 18.9375L12.5625 16.6875L11.625 18.1875ZM19.3125 9.75L21.5625 13.5L23.25 12.5625L21 8.8125L19.3125 9.75ZM31.3125 24.5625C33.5625 24.5625 35.4375 26.4375 35.4375 28.6875C35.4375 30.9375 33.5625 32.625 31.3125 32.625C29.0625 32.625 27.375 30.9375 27.375 28.6875C27.375 28.125 27.375 27.75 27.5625 27.375L19.6875 17.0625L30 24.75C30.375 24.75 30.9375 24.5625 31.3125 24.5625Z"
              fill="#F5F5F5"
              stroke="#F5F5F5"
              stroke-width="0.5625"
              stroke-miterlimit="2.61313"
            />
          </g>
          <defs>
            <clipPath id="clip0_265_470">
              <rect width="60" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      categoryName: "بلند",
      pieceName: "کولر",
      desc: "یک سیستم خنک کننده خودرو با چرخاندن مبرد و تبدیل آن از حالت گاز به مایع و سپس بازگشت دوباره آن کار می کند. همینطور که مبرد تغییر حالت می دهد، گرما و رطوبت را از وسیله نقلیه جذب کرده و به سیستم اجازه می دهد هوای خنک و خشک ساطع کند",
    },
    {
      id: 47,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M42.2616 17.4448L43.5832 15.8589C42.2616 14.273 40.9401 12.9514 39.3541 11.8941L36.9753 13.7443C35.1251 12.4228 33.0105 11.6298 30.896 11.3655L30.6317 8.458C28.5171 8.19369 26.6669 8.19369 24.8167 8.458L24.5524 11.3655C22.1735 11.8941 20.3233 12.6871 18.4731 14.0087L16.0942 12.1584C14.5083 13.48 13.1867 14.8016 12.1295 16.3875L13.9797 18.7664C12.6581 20.6166 11.8652 22.7311 11.6008 24.8457L8.69336 25.11C8.42904 27.2245 8.42904 29.0747 8.69336 30.925L11.6008 31.1893C12.1295 33.3038 13.1867 35.4184 14.244 37.2686L12.3938 39.6474C13.7154 40.969 14.7726 42.2906 16.3586 43.3479"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.3801 43.0836L21.6444 42.555L24.0233 43.3479C25.3449 43.6123 26.4021 44.6695 26.6664 45.9911L27.1951 48.37L23.759 51.8061C25.8735 52.0704 27.988 51.2775 29.5739 49.9559C31.1598 48.37 31.6885 46.5197 31.4241 44.4052L43.8471 32.5109C46.2259 33.0396 48.6048 32.5109 50.455 30.6607C52.0409 29.0748 52.8338 26.696 52.3052 24.3171L48.6048 28.0175L46.2259 27.2246C45.1686 26.9603 44.1114 25.903 43.8471 24.8457L43.3184 22.4669L47.0189 19.0308C44.9043 18.5021 42.5255 19.0308 40.9396 20.6167C39.0893 22.2026 38.2964 24.5814 38.825 26.696L26.1378 38.5902C24.0233 38.3259 21.9087 38.8545 20.3228 40.1761C18.7369 41.762 17.944 43.6123 18.2083 45.7268L21.3801 43.0836Z"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M37.5043 21.9382C35.1255 18.2378 30.6321 16.1232 26.1387 16.9162C21.6453 17.7092 18.2092 21.1453 17.1519 25.3743C16.3589 29.8677 18.2092 34.3611 21.9096 36.74"
            stroke="#FEC42B"
            stroke-width="1.5859"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_265_470)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.3125 1.875C46.125 1.875 58.125 13.875 58.125 28.6875C58.125 43.3125 46.125 55.3125 31.3125 55.3125C30.1875 55.3125 28.875 55.3125 27.75 55.125L26.625 58.125C24.5625 57.75 22.6875 57.1875 20.8125 56.625L21.375 53.4375C18.9375 52.5 16.875 51.1875 15 49.6875L12.5625 51.75C11.0625 50.4375 9.5625 49.125 8.25 47.4375L10.3125 45C8.8125 43.125 7.5 41.0625 6.5625 38.625L3.375 39.1875C2.8125 37.3125 2.25 35.4375 1.875 33.375L4.875 32.25C4.6875 31.125 4.6875 29.8125 4.6875 28.6875C4.6875 13.875 16.6875 1.875 31.3125 1.875ZM31.3125 53.4375C45 53.4375 56.25 42.375 56.25 28.6875C56.25 15 45 3.75 31.3125 3.75C17.625 3.75 6.5625 15 6.5625 28.6875H18.5625C18.5625 35.625 24.375 41.4375 31.3125 41.4375V53.4375ZM43.3125 47.4375L41.0625 43.5L39.375 44.4375L41.8125 48.5625L43.3125 47.4375ZM51.1875 39L47.25 36.75L46.3125 38.4375L50.25 40.6875L51.1875 39ZM53.8125 27.75H49.125V29.625H53.8125V27.75ZM50.25 16.6875L46.3125 18.9375L47.25 20.625L51.1875 18.1875L50.25 16.6875ZM41.8125 8.8125L39.375 12.75L41.0625 13.6875L43.3125 9.75L41.8125 8.8125ZM30.375 6.1875V10.875H32.25V6.1875H30.375ZM11.625 18.1875L15.5625 20.625L16.5 18.9375L12.5625 16.6875L11.625 18.1875ZM19.3125 9.75L21.5625 13.5L23.25 12.5625L21 8.8125L19.3125 9.75ZM31.3125 24.5625C33.5625 24.5625 35.4375 26.4375 35.4375 28.6875C35.4375 30.9375 33.5625 32.625 31.3125 32.625C29.0625 32.625 27.375 30.9375 27.375 28.6875C27.375 28.125 27.375 27.75 27.5625 27.375L19.6875 17.0625L30 24.75C30.375 24.75 30.9375 24.5625 31.3125 24.5625Z"
              fill="#F5F5F5"
              stroke="#F5F5F5"
              stroke-width="0.5625"
              stroke-miterlimit="2.61313"
            />
          </g>
          <defs>
            <clipPath id="clip0_265_470">
              <rect width="60" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      categoryName: "بلند",
      pieceName: "آچارکشی",
      desc: "به‌طورکلی آچارکشی در بررسی کلیه بخش‌های یک خودرو که دارای اتصالات گوناگون از جمله پیچ و مهره هستند بکار می‌رود. این واژه به بررسی شل یا سفت بودن پیچ و مهره‌ها و سفت کردن پیچ‌های شل به ویژه در خودروها بکار می‌رود و جلوبندی نیز به عنوان یکی از اجزای مهم خودرو نیازمند بازدید دوره‌ای و آچارکشی قطعات است.",
    },
    {
      id: 48,
      svg: (
        <svg
          width="1000"
          height="1000"
          viewBox="0 0 61 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_252_2)">
            <path
              d="M11.2038 44.5068C10.9221 45.0702 10.6404 45.6336 10.9221 46.197C10.9221 47.3237 12.0489 48.1688 12.0489 49.0139C12.3306 50.1406 10.6404 50.9857 9.51367 51.5491"
              stroke="#FEC42B"
              stroke-width="1.40845"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M21.0627 38.0281C21.0627 37.4647 20.781 36.9014 20.2176 36.9014C19.6542 36.9014 19.0908 37.4647 19.0908 38.0281C19.0908 38.5915 19.6542 39.1549 20.2176 39.1549C20.781 39.1549 21.0627 38.5915 21.0627 38.0281Z"
              stroke="#FEC42B"
              stroke-width="1.40845"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22.7529 30.141L23.598 29.2959L27.26 31.8311L26.4149 32.6762L22.7529 30.141Z"
              stroke="#FEC42B"
              stroke-width="1.40845"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M21.9082 31.2676L25.5702 33.5211"
              stroke="#FEC42B"
              stroke-width="1.40845"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M28.6685 23.6617L28.3868 21.6899L28.1051 21.4082C27.26 21.9716 26.6966 22.8166 26.6966 23.38C26.6966 23.6617 26.4149 23.9434 26.4149 24.2251L16.8375 33.8025C16.8375 33.8025 16.8375 33.8025 16.8375 34.0842L11.7671 41.9716C11.4854 42.2532 11.4854 43.0983 12.0488 43.38L12.8938 44.2251C13.1755 44.7885 14.0206 44.7885 14.584 44.2251L18.2459 40.5631C18.8093 40.2814 19.3727 39.9997 19.6544 40.2814L20.7811 40.8448C21.3445 41.1265 21.9079 40.8448 22.1896 40.2814L23.598 38.5913H24.1614L25.2882 37.4645V36.0561C25.2882 35.7744 25.5699 35.4927 25.8516 35.211L39.6544 21.4082C39.9361 21.1265 39.9361 20.8448 39.9361 20.5631C39.9361 20.2814 39.9361 19.9997 39.6544 19.718L39.091 19.4363C39.091 19.1547 38.8093 18.873 38.8093 18.3096C38.8093 18.0279 39.091 17.7462 39.091 17.4645L39.9361 16.6194C40.2178 16.3378 40.4995 16.0561 40.4995 15.7744C40.4995 15.4927 40.2178 15.211 39.9361 14.9293L37.9642 12.9575C37.9642 12.6758 37.6826 12.6758 37.6826 12.6758C37.4009 12.6758 37.4009 12.6758 37.4009 12.9575C36.5558 14.3659 35.1473 15.7744 33.7389 16.9011V17.1828L34.584 22.2532C34.8657 23.38 34.584 24.5068 33.7389 25.3518C32.8938 25.9152 31.7671 26.1969 30.6403 25.9152C29.7952 25.6335 28.9502 24.7885 28.6685 23.6617Z"
              stroke="#FEC42B"
              stroke-width="1.40845"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M27.5421 10.4225C27.2605 9.85912 27.5421 9.29573 28.1055 8.73235C28.3872 8.45066 29.2323 8.16897 29.7957 8.45066C30.3591 8.73235 30.6407 9.29573 30.9224 9.85912L33.4576 22.5352C33.4576 23.0986 33.4576 23.9436 32.8943 24.2253C32.3309 24.7887 31.7675 24.7887 31.2041 24.507C30.359 24.507 30.0774 23.9436 30.0774 23.0986L27.5421 10.4225Z"
              stroke="#FEC42B"
              stroke-width="1.40845"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              d="M27.542 10.4224L30.0772 23.0984"
              stroke="#FEC42B"
              stroke-width="1.40845"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M51.4853 24.7886C50.922 23.9435 49.7952 23.6618 48.9501 23.9435L39.091 33.8027C38.8093 34.9294 39.091 35.7745 39.6544 36.6196L51.4853 24.7886Z"
              stroke="#FEC42B"
              stroke-width="1.40845"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M36.2744 26.4791L41.3448 21.4086C41.6265 21.4086 41.6265 21.127 41.9082 21.127L43.88 21.4086C44.1617 21.4086 44.1617 21.4086 44.1617 21.4086L45.2885 22.2537C45.2885 22.2537 45.2885 22.2537 45.5702 22.2537H46.1336L47.2603 23.0988C47.2603 23.3805 47.2603 23.6622 47.2603 23.9439L38.8096 32.1129C38.8096 32.3946 38.5279 32.3946 38.5279 32.3946C38.2462 32.3946 38.2462 32.3946 38.2462 32.1129L37.1195 31.2678V30.4227L36.5561 29.296L36.2744 29.0143V26.7608V26.4791Z"
              stroke="#FEC42B"
              stroke-width="1.40845"
              stroke-miterlimit="2.61313"
              stroke-linejoin="bevel"
            />
          </g>
          <defs>
            <clipPath id="clip0_252_2">
              <rect
                width="60"
                height="60"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      catergorySvg: (
        <svg
          width="40"
          height="40"
          viewBox="0 0 60 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_265_470)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.3125 1.875C46.125 1.875 58.125 13.875 58.125 28.6875C58.125 43.3125 46.125 55.3125 31.3125 55.3125C30.1875 55.3125 28.875 55.3125 27.75 55.125L26.625 58.125C24.5625 57.75 22.6875 57.1875 20.8125 56.625L21.375 53.4375C18.9375 52.5 16.875 51.1875 15 49.6875L12.5625 51.75C11.0625 50.4375 9.5625 49.125 8.25 47.4375L10.3125 45C8.8125 43.125 7.5 41.0625 6.5625 38.625L3.375 39.1875C2.8125 37.3125 2.25 35.4375 1.875 33.375L4.875 32.25C4.6875 31.125 4.6875 29.8125 4.6875 28.6875C4.6875 13.875 16.6875 1.875 31.3125 1.875ZM31.3125 53.4375C45 53.4375 56.25 42.375 56.25 28.6875C56.25 15 45 3.75 31.3125 3.75C17.625 3.75 6.5625 15 6.5625 28.6875H18.5625C18.5625 35.625 24.375 41.4375 31.3125 41.4375V53.4375ZM43.3125 47.4375L41.0625 43.5L39.375 44.4375L41.8125 48.5625L43.3125 47.4375ZM51.1875 39L47.25 36.75L46.3125 38.4375L50.25 40.6875L51.1875 39ZM53.8125 27.75H49.125V29.625H53.8125V27.75ZM50.25 16.6875L46.3125 18.9375L47.25 20.625L51.1875 18.1875L50.25 16.6875ZM41.8125 8.8125L39.375 12.75L41.0625 13.6875L43.3125 9.75L41.8125 8.8125ZM30.375 6.1875V10.875H32.25V6.1875H30.375ZM11.625 18.1875L15.5625 20.625L16.5 18.9375L12.5625 16.6875L11.625 18.1875ZM19.3125 9.75L21.5625 13.5L23.25 12.5625L21 8.8125L19.3125 9.75ZM31.3125 24.5625C33.5625 24.5625 35.4375 26.4375 35.4375 28.6875C35.4375 30.9375 33.5625 32.625 31.3125 32.625C29.0625 32.625 27.375 30.9375 27.375 28.6875C27.375 28.125 27.375 27.75 27.5625 27.375L19.6875 17.0625L30 24.75C30.375 24.75 30.9375 24.5625 31.3125 24.5625Z"
              fill="#F5F5F5"
              stroke="#F5F5F5"
              stroke-width="0.5625"
              stroke-miterlimit="2.61313"
            />
          </g>
          <defs>
            <clipPath id="clip0_265_470">
              <rect width="60" height="60" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      categoryName: "بلند",
      pieceName: "دیتیلینگ",
      desc: " پولیش کشیدن تمامی اجزای بیرونی و درونی ماشین به وسیله ی مواد و تجهیزاتی که در حالت عادی در مراکز نظافتی ماشین ها مورد استفاده قرار نمی گیرد، معرفی شده است.",
    },
  ];

  useEffect(() => {
    setPieces(piecesObj);
    setPiecesIndex(contextData?.piecesIndexInMob);
  }, [contextData?.piecesIndexInMob]);

  const forwardPiece = () => {
    if (piecesIndex >= 23) {
      setPiecesIndex(0);
    } else {
      setPiecesIndex((prev) => prev + 1);
    }
  };
  const backwardPiece = () => {
    if (piecesIndex <= 0) {
      setPiecesIndex(23);
    } else {
      setPiecesIndex((prev) => prev - 1);
    }
  };
  return (
    <div className="relative min-[769px]:hidden w-full h-screen flex flex-col items-center justify-center ">
      <div className="relative w-full h-[52%]  flex flex-col items-center justify-center bg-color-primary-C rounded-bl-[20px] rounded-br-[20px]">
        <div className="w-full flex items-center justify-center">
          <div className="w-[150px] h-[150px] flex items-center justify-center rounded-[10px]">
            {pieces[piecesIndex]?.svg}
          </div>
        </div>
        <div className="w-full  flex items-center justify-center gap-x-[20px] px-[40px] absolute bottom-[16px] min-[390px]:bottom-[48px]">
          <span className="font-font_primary_A font-medium text-[14px] text-color-primary-A">
            در دسته {pieces[piecesIndex]?.categoryName} مدت
          </span>
          {pieces[piecesIndex]?.catergorySvg}
        </div>
      </div>
      <div className=" w-full h-[60%] flex flex-col items-center justify-start bottom-0 bg-color-primary-A rounded-tl-[20px] rounded-tr-[20px] ">
        <div className="w-full h-[80px] flex items-center justify-center bg-[#FFF] mt-[28px] px-[40px] py-[20px]">
          <div className=" w-full   flex items-center justify-between ">
            <button
              className="w-[30px] h-[30px] rounded-full flex items-center justify-center border-[1px] border-color-primary-D text-color-primary-D text-[28px] "
              onClick={forwardPiece}
            >
              <MdOutlineChevronLeft />
            </button>
            <span className="font-font_primary_A font-bold text-[24px] ">
              {pieces[piecesIndex]?.pieceName}
            </span>
            <button
              className=" w-[30px] h-[30px] rounded-full flex items-center justify-center border-[1px] border-color-primary-D text-color-primary-D text-[28px]  "
              onClick={backwardPiece}
            >
              <MdOutlineChevronRight />
            </button>
          </div>
        </div>

        <div className="w-full flex items-center  justify-center px-[20px] mt-[20px]">
          <div
            dir="rtl"
            className="w-full h-[230px] flex items-start justify-center  rounded-[10px] py-[15px] px-[15px] font-font_primary_A font-medium text-[1.9vh] leading-[3vh] text-color-primary-D text-justify "
          >
            {pieces[piecesIndex]?.desc}
          </div>
        </div>
      </div>
    </div>
  );
}
